import * as i0 from '@angular/core';
import { Injectable, SecurityContext, Component, Input, EventEmitter, Output, Directive, ViewChild, NgModule } from '@angular/core';
import * as i3$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import * as i1$1 from '@roosevelt/common-ui-lib/core';
import { first, tap, mergeMap, catchError, startWith } from 'rxjs/operators';
import { of, throwError, combineLatest } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/platform-browser';
import * as i4 from '@roosevelt/common-ui-lib/paginator';
import { PaginatorModule } from '@roosevelt/common-ui-lib/paginator';
import * as i5$1 from '@roosevelt/common-ui-lib/tooltip';
import { TooltipModule } from '@roosevelt/common-ui-lib/tooltip';
import * as i6 from '@roosevelt/common-ui-lib/dialog';
import { DialogModule } from '@roosevelt/common-ui-lib/dialog';
import * as i7 from '@roosevelt/common-ui-lib/loader';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import * as i5 from '@roosevelt/common-ui-lib/button';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import * as i7$1 from '@roosevelt/common-ui-lib/checkbox';
import { CheckboxModule } from '@roosevelt/common-ui-lib/checkbox';
import * as i4$1 from '@roosevelt/common-ui-lib/tabs';
import { TabsModule } from '@roosevelt/common-ui-lib/tabs';
import * as i2 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i8 from '@roosevelt/common-ui-lib/input';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import * as i6$1 from '@roosevelt/common-ui-lib/select';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import * as i9 from '@roosevelt/common-ui-lib/radio';
import { RadioModule } from '@roosevelt/common-ui-lib/radio';
import * as i4$2 from 'ngx-stripe';
import { StripeCardComponent, NgxStripeModule } from 'ngx-stripe';

const initialBillingState = {
    isFetching: false,
    clientSearchCriteria: {
        planAcronym: [],
        specifiedId: '',
        name: '',
        status: '',
        subClient: {
            specifiedId: '',
            name: ''
        },
        pagination: {
            offset: 0,
            limit: 25
        },
        sort: [{
                order: '',
                fieldName: ''
            }]
    },
    searchCriteria: {
        planAcronym: '',
        clientSpecifiedIdentifier: '',
        clientSpecifiedName: '',
        subClientSpecifiedIdentifier: '',
        subClientSpecifiedName: '',
        activeIndicator: false,
        clientStatus: '',
        pagination: {
            offset: 0,
            limit: 25
        },
        asOfDate: '',
        subClientStatus: '',
        paymentId: ''
    },
    subClientSearchCriteria: {
        client: {
            planAcronym: '',
            specifiedId: '',
            id: 0
        },
        subClient: {
            specifiedId: '',
            name: '',
            status: '',
            asOf: ''
        },
        pagination: {
            offset: 0,
            limit: 25
        },
        sort: [{
                order: '',
                fieldName: ''
            }]
    },
    clientsInfo: {
        clients: [],
        pagination: {
            offset: 0,
            limit: 25
        },
        sort: [],
    },
    subClientInfo: {
        subClients: [],
        pagination: {
            offset: 0,
            limit: 25
        },
        sort: [],
    },
    isSubClientCalled: false,
    BillingComponentCriteria: {
        planAcronym: '',
        clientsSubclients: {
            clientSpecifiedIdentifier: '',
            subClientSpecifiedIdentifier: ''
        },
        startDate: '',
        endDate: '',
        pagination: {
            limit: '',
            offset: '',
            totalRecords: ''
        }
    },
    totalBalanceDueResponse: {
        futureDue: '',
        pastDue: '',
        totalDue: ''
    },
    nonConsolidatedSummaryResponse: {
        nonConsolidatedSummary: [],
        pagination: {
            limit: '',
            offset: '',
            totalRecords: ''
        }
    },
    consolidatedSummaryResponse: {
        consolidatedSummary: [],
        pagination: {
            limit: '',
            offset: '',
            totalRecords: ''
        }
    },
    invoiceRequest: {
        pagination: {
            limit: '',
            offset: '',
            totalRecords: ''
        },
        planAcronym: '',
        consolidatedTo: {
            clientSpecifiedIdentifier: '',
            subClientSpecifiedIdentifier: ''
        },
        startDate: '',
        endDate: ''
    },
    errorMessage: '',
    isInvoiceFetching: false,
    subClientFlow: false,
    selectedSubClient: [],
    selectedClient: {
        id: 0,
        planAcronym: '',
        specifiedId: '',
        name: '',
        status: {
            code: '',
            value: '',
            effectiveDate: ''
        }
    },
    isFetchingClient: false,
    clientOrSubClientSearchErrors: '',
    isFetchingTotalBal: false,
    downloadInvoiceRequest: {
        billingPeriod: {
            startDate: '',
            endDate: ''
        },
        consolidatedTo: [],
        clientsSubclients: [],
        reportsAndFileFormats: [],
        planAcronym: ''
    },
    downloadInvoiceResponse: {
        deliveryType: '',
        format: '',
        id: '',
        message: ''
    },
    isInvoiceDownloadFetching: false,
    invoiceDownloadError: '',
    documentDownloadError: '',
    isDownloadDocumentFetching: false,
    isFetchingUiAuth: false,
    isFetchingIndividualInvoice: false,
    individualInvoiceError: '',
    reportFormatsRequest: [],
    reportFormatResponse: {
        billType: '',
        billingReports: [],
        consolidatedTo: [],
        clientsSubclients: [],
        endDate: '',
        planAcronym: '',
        startDate: ''
    },
    reportFormatError: '',
    isFetchingReportFormats: false,
    paymentConfigError: '',
    isFetchingpaymentConfig: false,
    totalBalanceErrorMessage: '',
    reportsErrorMessage: '',
    groupErrorMessage: '',
    paymentHistoryRequest: {
        pagination: {
            limit: '',
            offset: '',
            totalRecords: '',
        },
        planAcronym: '',
        clientsSubclients: {
            clientSpecifiedIdentifier: '',
            subClientSpecifiedIdentifier: '',
        },
        paymentMethod: '',
        fromAmount: '',
        toAmount: '',
        fromDateReceived: '',
        toDateReceived: '',
    },
    paymentHistoryResponse: {
        pagination: {
            limit: '',
            offset: '',
            totalRecords: '',
        },
        paymentHistories: []
    },
    isFetchingPaymentHistory: false,
    paymentHistoryError: '',
    paymentActivitiesRequest: {
        paymentId: '',
        planAcronym: '',
        offset: '',
        limit: '',
        depositId: '',
        businessUnit: '',
    },
    paymentActivityError: '',
    isFetchingPaymentActivity: false,
    paymentActivityResponse: {
        pagination: {
            limit: '',
            offset: '',
            totalRecords: '',
        },
        payments: {
            paymentId: '',
            paymentAmount: '',
            dateReceived: '',
            dateApplied: '',
            paymentMethod: '',
            activities: []
        }
    },
    customerPaymentProfilesError: '',
    isFetchingCustomerPaymentProfiles: false,
    customerPaymentProfilesResponse: {
        customerProfile: {
            customerProfileId: '',
            customerUserName: '',
            adminPlan: '',
            planAcronym: '',
            businessUnit: '',
            paymentProfile: []
        }
    },
    customerPaymentProfilesRequest: {
        planAcronym: '',
        businessUnit: '',
        fetchAllAccounts: '',
        _include: ''
    },
    addCustomerProfileError: '',
    isFetchingAddCustomerProfile: false,
    addCustomerProfileResponse: {
        customerProfileId: ''
    },
    addCustomerProfileRequest: {
        planAcronym: '',
        businessUnit: '',
        startDate: '',
        merchantAcctIdentifier: '',
        description: '',
        email: '',
        paymentProfileToken: ''
    },
    addCustomerPaymentProfileError: '',
    isFetchingAddCustomerPaymentProfile: false,
    addCustomerPaymentProfileResponse: {
        paymentProfileId: ''
    },
    addCustomerPaymentProfileRequest: {
        paymentProfileToken: '',
        merchantAcctIdentifier: '',
        planAcronym: '',
        businessUnit: '',
        paymentType: '',
        startDate: '',
        defaultPaymentIndicator: ''
    },
    merchantAccountError: '',
    isFetchingMerchantAccount: false,
    merchantAccountResponse: {
        merchantAccountId: '',
        merchantAccountRegistrationKey: '',
        merchantAccountIdentifier: '',
        paymentProcessorName: ''
    },
    merchantAccountRequest: {
        adminPlanAcronym: '',
        planAcronym: '',
        businessUnit: '',
        departmentNumber: '',
        clientType: '',
        preenrollProductId: '',
        startDate: ''
    },
    paymentError: '',
    isFetchingPayment: false,
    paymentResponse: {
        transactions: []
    },
    paymentRequest: {
        billPymtGatewayId: '',
        businessUnitDeptTypeId: '',
        merchantAccountId: '',
        creditCardInfoId: '',
        message: '',
        gatewayCustomerId: '',
        paymentProfileId: '',
        pplsftPymtId: '',
        customerId: '',
        userId: '',
        applicationName: '',
        planAcronym: '',
        clientsSubclients: [],
        totalBalanceDueDetails: {
            remainingBalance: '',
            filterType: ''
        },
        businessUnitDepartmentIds: [],
        invoiceDetails: [],
        consolidationDetails: []
    },
    invoiceActivityRequest: {
        invoiceNumber: '',
        planAcronym: '',
        offset: '',
        limit: '',
    },
    invoiceActivityError: '',
    isFetchingInvoiceActivity: false,
    invoiceActivityResponse: {
        invoiceActivity: [],
        invoiceAmount: '',
        invoiceEndDate: '',
        invoiceNumber: '',
        invoiceStartDate: '',
        invoiceStatus: '',
        pagination: {
            limit: '',
            offset: '',
            totalRecords: '',
        }
    },
    isNavigateToMyreports: false
};

const BillingComponentCriteria = (state) => {
    const req = state.billing.BillingComponentCriteria;
    return {
        ...req,
        clientsSubclients: Object.keys(req.clientsSubclients).reduce((acc, i) => {
            if (req.clientsSubclients[i] !== '') {
                acc[i] = req.clientsSubclients[i];
            }
            return acc;
        }, {})
    };
};
const groupSearchCriteria = (state) => {
    const req = state.billing.BillingComponentCriteria;
    return {
        ...req,
        view: 'CLIENT',
        clientsSubclients: Object.keys(req.clientsSubclients).reduce((acc, i) => {
            if (req.clientsSubclients[i] !== '') {
                acc[i] = req.clientsSubclients[i];
            }
            return acc;
        }, {})
    };
};
const subGroupSearchCriteria = (state) => {
    const req = state.billing.BillingComponentCriteria;
    return {
        ...req,
        view: 'SUBCLIENT',
        clientsSubclients: Object.keys(req.clientsSubclients).reduce((acc, i) => {
            if (req.clientsSubclients[i] !== '') {
                acc[i] = req.clientsSubclients[i];
            }
            return acc;
        }, {})
    };
};
const totalBalanceDueRes = (state) => state.billing.totalBalanceDueResponse;
const consolidatedResponse = (state) => state.billing.consolidatedSummaryResponse;
const nonConsolidatedResponse = (state) => state.billing.nonConsolidatedSummaryResponse;
const isFetchingData = (state) => state.billing.isFetching;
const error = (state) => state.billing.errorMessage;
const reportsErrorMessage = (state) => state.billing.reportsErrorMessage;
const groupErrorMessage = (state) => state.billing.groupErrorMessage;
const invoiceDownloaderrorMessage = (state) => state.billing.invoiceDownloadError;
const invoiceReq = (state) => state.billing.invoiceRequest;
const isInvoiceFetching = (state) => state.billing.isInvoiceFetching;
const getSearchCriteria = (state) => state.billing.searchCriteria;
const getClientSearchCriteria = (state) => {
    return {
        planAcronym: state.billing.searchCriteria.planAcronym ? state.billing.searchCriteria.planAcronym : [],
        specifiedId: state.billing.searchCriteria.clientSpecifiedIdentifier,
        name: state.billing.searchCriteria.clientSpecifiedName,
        status: state.billing.searchCriteria.activeIndicator ? 'A' : null,
        subClient: {
            specifiedId: state.billing.searchCriteria.subClientSpecifiedIdentifier,
        },
        pagination: {
            offset: state.billing.searchCriteria.pagination.offset,
            limit: 25,
        },
        sort: [{
                order: 'ASC',
                fieldName: 'specifiedId'
            }]
    };
};
const getClientSearchCriteriaLimit25 = (state) => {
    return {
        planAcronym: state.billing.searchCriteria.planAcronym ? state.billing.searchCriteria.planAcronym : [],
        specifiedId: state.billing.searchCriteria.clientSpecifiedIdentifier,
        name: state.billing.searchCriteria.clientSpecifiedName,
        status: state.billing.searchCriteria.clientStatus === 'Active'
            ? 'A' : state.billing.searchCriteria.clientStatus === 'Inactive' ? 'I' : null,
        subClient: {
            specifiedId: state.billing.searchCriteria.subClientSpecifiedIdentifier,
        },
        pagination: {
            offset: state.billing.clientSearchCriteria.pagination.offset,
            limit: 25,
        },
        sort: [{
                order: 'ASC',
                fieldName: 'specifiedId'
            }]
    };
};
const getSubClientSearchCriteria = (state) => {
    return {
        client: {
            planAcronym: state.billing.selectedClient.planAcronym,
            specifiedId: state.billing.selectedClient.specifiedId,
            id: null
        },
        subClient: {
            specifiedId: state.billing.searchCriteria.subClientSpecifiedIdentifier,
            name: state.billing.searchCriteria.subClientSpecifiedName,
            status: state.billing.searchCriteria.activeIndicator ? 'A' : null,
        },
        includeContractStatus: true,
        pagination: {
            offset: state.billing.subClientSearchCriteria.pagination.offset,
            limit: 25
        },
        sort: [{
                order: 'ASC',
                fieldName: 'specifiedId'
            }]
    };
};
const getSubClientSearchCriteriaLimit25 = (state) => {
    return {
        client: {
            planAcronym: state.billing.selectedClient.planAcronym,
            specifiedId: state.billing.selectedClient.specifiedId,
            id: null
        },
        subClient: {
            specifiedId: state.billing.searchCriteria.subClientSpecifiedIdentifier,
            name: state.billing.searchCriteria.subClientSpecifiedName,
            status: state.billing.searchCriteria.subClientStatus === 'Active'
                ? 'A' : state.billing.searchCriteria.subClientStatus === 'Inactive' ? 'I' : null,
        },
        pagination: {
            offset: state.billing.searchCriteria.pagination.offset,
            limit: 25
        },
        sort: [{
                order: 'ASC',
                fieldName: 'specifiedId'
            }]
    };
};
const getSubClientResults = (state) => {
    const subClientData = {
        ...state.billing.subClientInfo,
        hasMoreSubClients: (state.billing.subClientInfo.pagination.totalRecords > state.billing.subClientInfo.subClients.length)
    };
    return subClientData;
};
const getClientOrSubClientSearchErrors = (state) => state.billing.clientOrSubClientSearchErrors;
const getSelectedSubClient = (state) => state.billing.selectedSubClient;
const isFetchingClient = (state) => state.billing.isFetchingClient;
const getClientResults = (state) => {
    const clientsData = {
        ...state.billing.clientsInfo,
        hasMoreClients: (state.billing.clientsInfo.pagination.totalRecords > state.billing.clientsInfo.clients.length)
    };
    return clientsData;
};
const getSelectedClient = (state) => state.billing.selectedClient;
const getCallInfo = (state) => state.billing.isSubClientCalled;
const getFlowInfo = (state) => state.billing.subClientFlow;
const isFetchingTotalBalance = (state) => state.billing.isFetchingTotalBal;
const downloadCSearchCriteria = (state) => state.billing.downloadInvoiceRequest;
const downloadResponse = (state) => state.billing.downloadInvoiceResponse;
const isFetchingDownload = (state) => state.billing.isInvoiceDownloadFetching;
const isFetchingAuth = (state) => state.billing.isFetchingUiAuth;
const isFetchingIndividualInvoice = (state) => state.billing.isFetchingIndividualInvoice;
const individualInvoiceError = (state) => state.billing.individualInvoiceError;
const reportFormatRequest = (state) => state.billing.reportFormatsRequest;
const reportFormatResponse = (state) => state.billing.reportFormatResponse;
const isFetchingReportFormats = (state) => state.billing.isFetchingReportFormats;
const reportFormatError = (state) => state.billing.reportFormatError;
const documentDownloadError = (state) => state.billing.documentDownloadError;
const paymentConfigError = (state) => state.billing.paymentConfigError;
const isFetchingpaymentConfig = (state) => state.billing.isFetchingpaymentConfig;
const totalBalanceErrorMessage = (state) => state.billing.totalBalanceErrorMessage;
const paymentHistoryRequest = (state) => state.billing.paymentHistoryRequest;
const paymentHistoryResponse = (state) => state.billing.paymentHistoryResponse;
const isFetchingPaymentHistory = (state) => state.billing.isFetchingPaymentHistory;
const paymentHistoryError = (state) => state.billing.paymentHistoryError;
const paymentActivityRequest = (state) => state.billing.paymentActivitiesRequest;
const isFetchingPaymentActivity = (state) => state.billing.isFetchingPaymentActivity;
const paymentActivityError = (state) => state.billing.paymentActivityError;
const paymentActivityResponse = (state) => state.billing.paymentActivityResponse;
const customerPaymentProfilesRequest = (state) => state.billing.customerPaymentProfilesRequest;
const customerPaymentProfilesResponse = (state) => state.billing.customerPaymentProfilesResponse;
const customerPaymentProfileError = (state) => state.billing.customerPaymentProfilesError;
const isFetchingCustomerPaymentProfiles = (state) => state.billing.isFetchingCustomerPaymentProfiles;
const addCustomerProfileRequest = (state) => state.billing.addCustomerProfileRequest;
const addCustomerProfileResponse = (state) => state.billing.addCustomerProfileResponse;
const addCustomerProfileError = (state) => state.billing.addCustomerProfileError;
const isFetchingAddCustomerProfile = (state) => state.billing.isFetchingAddCustomerProfile;
const addCustomerPaymentProfileRequest = (state) => state.billing.addCustomerPaymentProfileRequest;
const addCustomerPaymentProfileResponse = (state) => state.billing.addCustomerPaymentProfileResponse;
const addCustomerPaymentProfileError = (state) => state.billing.addCustomerPaymentProfileError;
const isFetchingAddCustomerPaymentProfile = (state) => state.billing.isFetchingAddCustomerPaymentProfile;
const merchantAccountRequest = (state) => state.billing.merchantAccountRequest;
const merchantAccountResponse = (state) => state.billing.merchantAccountResponse;
const merchantAccountError = (state) => state.billing.merchantAccountError;
const isFetchingMerchantAccount = (state) => state.billing.isFetchingMerchantAccount;
const paymentRequest = (state) => state.billing.paymentRequest;
const paymentResponse = (state) => state.billing.paymentResponse;
const paymentError = (state) => state.billing.paymentError;
const isFetchingPayment = (state) => state.billing.isFetchingPayment;
const invoiceActivityRequest = (state) => state.billing.invoiceActivityRequest;
const isFetchingInvoiceActivity = (state) => state.billing.isFetchingInvoiceActivity;
const invoiceActivityError = (state) => state.billing.invoiceActivityError;
const invoiceActivityResponse = (state) => state.billing.invoiceActivityResponse;
const navigateUserToMyReports = (state) => state.billing.isNavigateToMyreports;

class BillingService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    getClients(searchReq) {
        const url = this.config.clientSearchUrl;
        return this.http.post(url, searchReq);
    }
    getSubClients(searchReq) {
        const url = this.config.subClientSearchUrl;
        return this.http.post(url, searchReq);
    }
    getTotalBalDue(req) {
        const url = this.config.totalBalanceDueUrl;
        return this.http.post(url, req);
    }
    getConsolidations(req) {
        const url = this.config.consolidationsSearchUrl;
        return this.http.post(url, req);
    }
    getNonConsolidations(req) {
        const url = this.config.nonConsolidationsSearchUrl;
        return this.http.post(url, req);
    }
    getInvoices(req, isNonConsolidated) {
        const url = isNonConsolidated ? this.config.nonConsolidationsInvoiceUrl : this.config.consolidationsInvoiceUrl;
        return this.http.post(url, req);
    }
    downloadInvoiceReports(req, isNonConsolidated) {
        const url = isNonConsolidated ? this.config.nonConsolidationsReportsInvoiceUrl : this.config.consolidationsReportsInvoiceUrl;
        return this.http.post(url, req);
    }
    getDownloadDoc(req) {
        const url = this.config.downloadDocumentUrl + req;
        if (this.config.authedUrls.indexOf(url) === -1) {
            this.config.authedUrls = [...this.config.authedUrls, url];
        }
        return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' });
    }
    getStrictAuthorizations(context) {
        const url = this.config.uiAuthorizationsUrl;
        const authUrl = url + '?type=S&context=' + context;
        return this.http.get(authUrl);
    }
    getReportFormats(req, isNonConsolidated) {
        const url = isNonConsolidated ? this.config.nonConsolidationReportsFormatUrl : this.config.consolidationReportsFormatUrl;
        return this.http.post(url, req);
    }
    checkPaymentConfig(req) {
        const url = this.config.paymentConfigurationsUrl;
        return this.http.post(url, req);
    }
    getPaymentHistory(req) {
        const url = this.config.paymentHistoryUrl;
        return this.http.post(url, req);
    }
    getPayments(request) {
        const url = this.config.paymentsActivityUrl;
        const paymentsUrl = url + '?_includes=activities&planAcronym=' + request.planAcronym + '&paymentId=' + request.paymentId
            + '&depositId=' + request.depositId + '&businessUnit=' + request.businessUnit + '&paginationOffset=' + request.offset + '&paginationLimit=' + request.limit;
        return this.http.get(paymentsUrl);
    }
    getCustomerPaymentProfiles(request) {
        const url = this.config.customerPaymentProfilesUrl;
        const customerPaymentProfileUrl = url + '?_include=paymentProfile&planAcronym=' + request.planAcronym +
            '&businessUnit=' + request.businessUnit + '&fetchAllAccounts=' + request.fetchAllAccounts;
        return this.http.get(customerPaymentProfileUrl);
    }
    addCustomerProfile(req) {
        const url = this.config.addCustomerProfileUrl;
        return this.http.post(url, req);
    }
    addCustomerPaymentProfile(req) {
        const url = this.config.addPaymentProfileUrl;
        return this.http.post(url, req);
    }
    getMerchantAccount(req) {
        const url = this.config.merchantAccountUrl;
        return this.http.post(url, req);
    }
    submitPayment(req) {
        const url = this.config.paymentUrl;
        return this.http.post(url, req);
    }
    getInvoiceActivity(request, isConsolidated) {
        const url = isConsolidated ? this.config.consolidatedInvoiceActivityUrl : this.config.nonConsolidatedInvoiceActivityUrl;
        const invoiceActivityUrl = url + '?planAcronym=' + request.planAcronym + '&invoiceNumber=' + request.invoiceNumber + '&paginationOffset=' + request.offset + '&paginationLimit=' + request.limit;
        return this.http.get(invoiceActivityUrl);
    }
    static { this.ɵfac = function BillingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1$1.BasicAuthConfig)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BillingService, factory: BillingService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: i1$1.BasicAuthConfig }], null); })();

class BillingAsync {
    constructor(lux, billingService, sanitizer) {
        this.lux = lux;
        this.billingService = billingService;
        this.sanitizer = sanitizer;
    }
    getTotalAmount() {
        return this.lux.get(BillingComponentCriteria).pipe(first(), tap(() => this.lux.set(x => x.billing, { isFetchingTotalBal: true, totalBalanceDueResponse: initialBillingState.totalBalanceDueResponse })), mergeMap(x => this.billingService.getTotalBalDue(x)), tap(results => {
            this.lux.set(x => x.billing, { isFetchingTotalBal: false, totalBalanceDueResponse: results });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.billing, { isFetchingTotalBal: false, totalBalanceErrorMessage: errorMessage });
            return of(errorMessage);
        }));
    }
    getConsolidatedSummaryReports() {
        return this.lux.get(BillingComponentCriteria).pipe(first(), tap(() => this.lux.set(x => x.billing, { reportsErrorMessage: initialBillingState.reportsErrorMessage, consolidatedSummaryResponse: initialBillingState.consolidatedSummaryResponse, isFetching: true, errorMessage: '' })), mergeMap(x => this.billingService.getConsolidations(x)), tap(results => this.lux.set(state => state.billing, { isFetching: false, consolidatedSummaryResponse: results })), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(state => state.billing, { isFetching: false, reportsErrorMessage: errorMessage });
            this.lux.set(state => state.billing, { consolidatedSummaryResponse: initialBillingState.consolidatedSummaryResponse });
            return of(errorMessage);
        }));
    }
    getNonConsolidatedSummaryReports(type) {
        return this.lux.get(type === 'Group Reports' ? groupSearchCriteria : subGroupSearchCriteria).pipe(first(), tap(() => this.lux.set(state => state.billing, { nonConsolidatedSummaryResponse: initialBillingState.nonConsolidatedSummaryResponse, isFetching: true, errorMessage: '' })), mergeMap(x => this.billingService.getNonConsolidations(x)), tap(results => this.lux.set(state => state.billing, { isFetching: false, nonConsolidatedSummaryResponse: results })), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(state => state.billing, { isFetching: false, reportsErrorMessage: errorMessage });
            this.lux.set(state => state.billing, { nonConsolidatedSummaryResponse: initialBillingState.nonConsolidatedSummaryResponse });
            return of(errorMessage);
        }));
    }
    getInvoiceRecords(isNonConsolidated) {
        return this.lux.get(invoiceReq).pipe(first(), tap(() => this.lux.set(x => x.billing, { isInvoiceFetching: true, errorMessage: '' })), mergeMap(x => this.billingService.getInvoices(x, isNonConsolidated)), tap(results => {
            this.lux.set(x => x.billing, { isInvoiceFetching: false });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.billing, { isInvoiceFetching: false, errorMessage: errorMessage });
            return of(errorMessage);
        }));
    }
    getClients(showMore) {
        return this.lux.get((!showMore) ? getClientSearchCriteriaLimit25 : getClientSearchCriteria).pipe(first(), tap(() => this.lux.set(x => x.billing, { isFetchingClient: true })), mergeMap(x => this.billingService.getClients(x)), tap(results => {
            this.lux.set(x => x.billing, !showMore ? { isFetchingClient: false, clientsInfo: results, clientOrSubClientSearchErrors: '' } :
                x => ({
                    isFetchingClient: false,
                    clientsInfo: {
                        ...x.clientsInfo,
                        clients: [...x.clientsInfo.clients, ...results.clients]
                    }
                }));
        }), catchError(err => {
            let errorMessage = '';
            if (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length) {
                err.error.apiErrorList.forEach(x => {
                    errorMessage += x.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.billing, {
                isFetchingClient: false,
                clientOrSubClientSearchErrors: errorMessage,
                clientsInfo: {
                    clients: [],
                    pagination: {
                        offset: 0,
                        limit: 25
                    },
                    sort: [],
                }
            });
            return of(null);
        }));
    }
    getSubClients(showMore) {
        const searchCriteria = (!showMore) ? getSubClientSearchCriteriaLimit25 : getSubClientSearchCriteria;
        return this.lux.get(searchCriteria).pipe(first(), tap(() => this.lux.set(x => x.billing, { isFetchingClient: true })), mergeMap(x => this.billingService.getSubClients(x)), tap(results => {
            this.lux.set(x => x.billing, !showMore ? { isFetchingClient: false, subClientInfo: results, clientOrSubClientSearchErrors: '' } :
                x => ({
                    isFetchingClient: false,
                    subClientInfo: {
                        ...x.subClientInfo,
                        subClients: [...x.subClientInfo.subClients, ...results.subClients]
                    }
                }));
        }), catchError(err => {
            let errorMessage = '';
            if (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length) {
                err.error.apiErrorList.forEach(x => errorMessage += x.errorMessage + '\n');
            }
            this.lux.set(x => x.billing, {
                isFetchingClient: false,
                clientOrSubClientSearchErrors: errorMessage,
                subClientInfo: {
                    subClients: [],
                    pagination: {
                        offset: 0,
                        limit: 25
                    },
                    sort: [],
                },
            });
            return of(null);
        }));
    }
    downloadRecords(isNonConsolidated) {
        return this.lux.get(downloadCSearchCriteria).pipe(first(), tap(() => this.lux.set(x => x.billing, { isInvoiceDownloadFetching: true, invoiceDownloadError: '' })), mergeMap(x => this.billingService.downloadInvoiceReports(x, isNonConsolidated)), tap(results => {
            this.lux.set(x => x.billing, { isInvoiceDownloadFetching: false, downloadInvoiceResponse: results });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.billing, { isInvoiceDownloadFetching: false, invoiceDownloadError: errorMessage });
            return of(errorMessage);
        }));
    }
    getStrictAuthorizations(context) {
        return of('').pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingUiAuth: true
        })), mergeMap(x => this.billingService.getStrictAuthorizations(context)), tap(() => this.lux.set(state => state.billing, {
            isFetchingUiAuth: false
        })), catchError(err => {
            this.lux.set(state => state.billing, {
                isFetchingUiAuth: false
            });
            return throwError(err);
        }));
    }
    downloadAsyncReport(req, type) {
        return of(req).pipe(first(), tap(() => this.lux.set(state => state.billing, { isDownloadDocumentFetching: true })), mergeMap(state => this.billingService.getDownloadDoc(state)), tap(res => {
            this.lux.set(state => state.billing, { isDownloadDocumentFetching: false });
            type === 'XLS' ? this.formExcelBlobUrl(res) : (type === 'PDF') ? this.fromPDF(res) : this.downloadCsvFile(res);
        }), catchError((err) => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Document is not available';
            this.lux.set(state => state.billing, { documentDownloadError: errorMessage, isDownloadDocumentFetching: false });
            return of(errorMessage);
        }));
    }
    formExcelBlobUrl(blobResponse) {
        const file = new Blob([blobResponse.body], { type: 'application/vnd.ms-excel' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    fromPDF(response) {
        const file = new Blob([response.body], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    downloadCsvFile(blobResponse) {
        const file = new Blob([blobResponse.body], { type: 'text/csv' });
        const fileURL = URL.createObjectURL(file);
        const resp = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(fileURL));
        const anchor = document.createElement('a');
        anchor.download = 'billing-reports.zip';
        anchor.href = resp;
        anchor.click();
    }
    getIndividualInvoices(request) {
        return of(request).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingIndividualInvoice: true
        })), mergeMap(state => this.billingService.getInvoices(request, false)), tap(() => this.lux.set(state => state.billing, {
            isFetchingIndividualInvoice: false
        })), catchError((err) => {
            const errorMessage = '';
            if (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => item.errorMessage).join('\n');
            }
            this.lux.set(state => state.billing, { individualInvoiceError: errorMessage, isFetchingIndividualInvoice: false });
            return of(errorMessage);
        }));
    }
    getBillingReportsTypesAndFormats(isNonConsolidated) {
        return this.lux.get(reportFormatRequest).pipe(first(), tap(() => this.lux.set(x => x.billing, { isFetchingReportFormats: true, reportFormatError: '' })), mergeMap(x => this.billingService.getReportFormats(x, isNonConsolidated)), tap(results => {
            this.lux.set(x => x.billing, { isFetchingReportFormats: false, reportFormatResponse: results });
        }), catchError((err) => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, { isFetchingReportFormats: false, reportFormatError: errorMessage });
            return of(errorMessage);
        }));
    }
    checkPaymentConfig(request) {
        return of(request).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingIndividualInvoice: true
        })), mergeMap(state => this.billingService.checkPaymentConfig(request)), tap(() => this.lux.set(state => state.billing, {
            isFetchingIndividualInvoice: false
        })), catchError((err) => {
            const errorMessage = '';
            if (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => item.errorMessage).join('\n');
            }
            this.lux.set(state => state.billing, { paymentConfigError: errorMessage });
            return of(errorMessage);
        }));
    }
    getGroupViewInfo() {
        return this.lux.get(groupSearchCriteria).pipe(first(), tap(() => this.lux.set(state => state.billing, { groupErrorMessage: initialBillingState.groupErrorMessage })), mergeMap(x => this.billingService.getNonConsolidations(x)), tap(() => this.lux.set(state => state.billing, { isFetching: false })), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(state => state.billing, { isFetching: false, groupErrorMessage: errorMessage });
            return of(errorMessage);
        }));
    }
    getPaymentHistory() {
        return this.lux.get(paymentHistoryRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, { isFetchingPaymentHistory: true, errorMessage: '' })), mergeMap(x => this.billingService.getPaymentHistory(x)), tap(results => {
            this.lux.set(state => state.billing, { paymentHistoryResponse: results, isFetchingPaymentHistory: false });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(state => state.billing, { isFetchingPaymentHistory: false, paymentHistoryError: errorMessage });
            return of(errorMessage);
        }));
    }
    getPaymentGroupDetails() {
        return this.lux.get(paymentActivityRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingPaymentActivity: true, paymentActivityResponse: initialBillingState.paymentActivityResponse
        })), mergeMap(state => this.billingService.getPayments(state)), tap(results => this.lux.set(state => state.billing, { isFetchingPaymentActivity: false, paymentActivityResponse: results })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, { paymentActivityError: errorMessage, isFetchingPaymentActivity: false });
            return of(errorMessage);
        }));
    }
    getInvoiceActivity(isConsolidated) {
        return this.lux.get(invoiceActivityRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingInvoiceActivity: true, invoiceActivityResponse: initialBillingState.invoiceActivityResponse
        })), mergeMap(state => this.billingService.getInvoiceActivity(state, isConsolidated)), tap(results => this.lux.set(state => state.billing, { isFetchingInvoiceActivity: false, invoiceActivityResponse: results })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, { invoiceActivityError: errorMessage, isFetchingInvoiceActivity: false });
            return of(errorMessage);
        }));
    }
    getCustomerPaymentProfiles() {
        return this.lux.get(customerPaymentProfilesRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingCustomerPaymentProfiles: true, customerPaymentProfilesResponse: initialBillingState.customerPaymentProfilesResponse
        })), mergeMap(state => this.billingService.getCustomerPaymentProfiles(state)), tap(results => this.lux.set(state => state.billing, {
            isFetchingCustomerPaymentProfiles: false,
            customerPaymentProfilesResponse: results
        })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, {
                customerPaymentProfilesError: errorMessage,
                isFetchingCustomerPaymentProfiles: false
            });
            return of(errorMessage);
        }));
    }
    addGroupBillingCustomerProfile() {
        return this.lux.get(addCustomerProfileRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingAddCustomerProfile: true, addCustomerProfileResponse: initialBillingState.addCustomerProfileResponse
        })), mergeMap(state => this.billingService.addCustomerProfile(state)), tap(results => this.lux.set(state => state.billing, {
            isFetchingAddCustomerProfile: false,
            addCustomerProfileResponse: results
        })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, {
                addCustomerProfileError: errorMessage,
                isFetchingAddCustomerProfile: false
            });
            return of(errorMessage);
        }));
    }
    addGroupBillingPaymentProfile() {
        return this.lux.get(addCustomerPaymentProfileRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingAddCustomerPaymentProfile: true, addCustomerPaymentProfileResponse: initialBillingState.addCustomerPaymentProfileResponse
        })), mergeMap(state => this.billingService.addCustomerPaymentProfile(state)), tap(results => this.lux.set(state => state.billing, {
            isFetchingAddCustomerPaymentProfile: false,
            addCustomerPaymentProfileResponse: results
        })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, {
                addCustomerPaymentProfileError: errorMessage,
                isFetchingAddCustomerPaymentProfile: false
            });
            return of(errorMessage);
        }));
    }
    getMerchantAccount() {
        return this.lux.get(merchantAccountRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingMerchantAccount: true, merchantAccountResponse: initialBillingState.merchantAccountResponse
        })), mergeMap(state => this.billingService.getMerchantAccount(state)), tap(results => this.lux.set(state => state.billing, {
            isFetchingMerchantAccount: false,
            merchantAccountResponse: results
        })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, {
                merchantAccountError: errorMessage,
                isFetchingMerchantAccount: false
            });
            return of(errorMessage);
        }));
    }
    submitPayment() {
        return this.lux.get(paymentRequest).pipe(first(), tap(() => this.lux.set(state => state.billing, {
            isFetchingPayment: true, paymentResponse: initialBillingState.paymentResponse
        })), mergeMap(state => this.billingService.submitPayment(state)), tap(results => this.lux.set(state => state.billing, {
            isFetchingPayment: false,
            paymentResponse: results
        })), catchError(err => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Internal server error';
            this.lux.set(state => state.billing, {
                paymentError: errorMessage,
                isFetchingPayment: false
            });
            return of(errorMessage);
        }));
    }
    static { this.ɵfac = function BillingAsync_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingAsync)(i0.ɵɵinject(i1$1.Lux), i0.ɵɵinject(BillingService), i0.ɵɵinject(i3.DomSanitizer)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BillingAsync, factory: BillingAsync.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingAsync, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1$1.Lux }, { type: BillingService }, { type: i3.DomSanitizer }], null); })();

const availableReportsReq = (state) => state.availableReports.availableReportsRequest;
const availableReportserror = (state) => state.availableReports.availableReportsErrorMessage;
const isFetchingAvailableReports = (state) => state.availableReports.isFetchingAvailableReports;
const availableReportsRes = (state) => state.availableReports.avaialableReportsResponse;
const isDownloading = (state) => state.availableReports.isDownloading;
const downloadError = (state) => state.availableReports.downloadError;
const isUpdatingAvailableReports = (state) => state.availableReports.isUpdatingAvailableReports;

class AvailableReportsService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    getAReports(searchReq) {
        const url = this.config.availableReportsUrl;
        return this.http.post(url, searchReq);
    }
    downloadDoc(req) {
        const url = this.config.downloadDocumentUrl + req;
        if (this.config.authedUrls.indexOf(url) === -1) {
            this.config.authedUrls = [...this.config.authedUrls, url];
        }
        return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' });
    }
    updateAvailableReports(request) {
        const url = this.config.documentAvailableReportsUrl;
        return this.http.patch(url, request);
    }
    downloadSelectedReports(request) {
        const url = this.config.downloadsSelectedReportsUrl;
        return this.http.post(url, request, { observe: 'response', responseType: 'arraybuffer' });
    }
    static { this.ɵfac = function AvailableReportsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvailableReportsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1$1.BasicAuthConfig)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AvailableReportsService, factory: AvailableReportsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvailableReportsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }, { type: i1$1.BasicAuthConfig }], null); })();

class AvailableReportsAsync {
    constructor(lux, availableReportsService) {
        this.lux = lux;
        this.availableReportsService = availableReportsService;
    }
    updateAvailableReports() {
        return this.lux.get(state => state.availableReports.updateAvailableReportsRequest).pipe(first(), tap(() => this.lux.set(x => x.availableReports, { isUpdatingAvailableReports: true })), mergeMap(x => this.availableReportsService.updateAvailableReports(x)), tap(results => {
            this.lux.set(x => x.availableReports, { isUpdatingAvailableReports: false });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.availableReports, { isUpdatingAvailableReports: false, availableReportsErrorMessage: errorMessage });
            return of(errorMessage);
        }));
    }
    getAvailableReports() {
        return this.lux.get(availableReportsReq).pipe(first(), tap(() => this.lux.set(x => x.availableReports, { isFetchingAvailableReports: true, avaialableReportsResponse: [] })), mergeMap(x => this.availableReportsService.getAReports(x)), tap(results => {
            this.lux.set(x => x.availableReports, { avaialableReportsResponse: results, isFetchingAvailableReports: false });
        }), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(x => x.availableReports, { isFetchingAvailableReports: false, availableReportsErrorMessage: errorMessage });
            return of(errorMessage);
        }));
    }
    downloadAsyncReport(req) {
        return of(req).pipe(first(), tap(() => this.lux.set(state => state.availableReports, { isDownloading: true })), mergeMap(state => this.availableReportsService.downloadDoc(req)), tap(state => {
            this.lux.set(state => state.availableReports, { isDownloading: false });
        }), catchError((err) => {
            const errorMessage = (err && err.error && err.error.apiErrorList && err.error.apiErrorList.length > 0) ?
                err.error.apiErrorList.map(item => item.errorMessage).join('\n') : err.name && err.name === 'TimeoutError' ? 'Timeout has occurred' : 'Document is not available.';
            this.lux.set(state => state.availableReports, { downloadError: errorMessage, isDownloading: false });
            return of(err);
        }));
    }
    downloadSelectedReports(documentMaskIds) {
        return of(documentMaskIds).pipe(first(), mergeMap(ids => this.availableReportsService.downloadSelectedReports({ documentMaskIds: ids })), catchError((err) => {
            let errorMessage = '';
            if (err &&
                err.error &&
                err.error.apiErrorList &&
                err.error.apiErrorList.length > 0) {
                err.error.apiErrorList.map(item => {
                    errorMessage += item.errorMessage + '\n';
                });
            }
            this.lux.set(state => state.availableReports, { downloadError: errorMessage, isDownloading: false });
            return of(errorMessage);
        }));
    }
    static { this.ɵfac = function AvailableReportsAsync_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvailableReportsAsync)(i0.ɵɵinject(i1$1.Lux), i0.ɵɵinject(AvailableReportsService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AvailableReportsAsync, factory: AvailableReportsAsync.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvailableReportsAsync, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1$1.Lux }, { type: AvailableReportsService }], null); })();

const _c0$1 = a0 => ({ reports: a0 });
function availableReportsComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r1.loaderImage);
} }
function availableReportsComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.downloadDocError);
} }
function availableReportsComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "div", 15)(3, "button", 16);
    i0.ɵɵlistener("click", function availableReportsComponent_ng_container_13_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.downloadSelectedReports()); });
    i0.ɵɵtext(4, "Download");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 17)(6, "button", 16);
    i0.ɵɵlistener("click", function availableReportsComponent_ng_container_13_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeReports()); });
    i0.ɵɵtext(7, "Remove");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} }
function availableReportsComponent_tbody_34_tr_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function availableReportsComponent_tbody_34_tr_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reports_r6 = ctx.$implicit;
    const isLast_r7 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", reports_r6, "", isLast_r7 ? "" : ", ", "");
} }
function availableReportsComponent_tbody_34_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "rs-checkbox", 19);
    i0.ɵɵlistener("change", function availableReportsComponent_tbody_34_tr_1_Template_rs_checkbox_change_2_listener() { const reports_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.updateRemoveList(reports_r5.outFileLogId)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtemplate(6, availableReportsComponent_tbody_34_tr_1_ng_container_6_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 21);
    i0.ɵɵtemplate(8, availableReportsComponent_tbody_34_tr_1_span_8_Template, 2, 2, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "td");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td")(21, "a", 22);
    i0.ɵɵlistener("click", function availableReportsComponent_tbody_34_tr_1_Template_a_click_21_listener() { const reports_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.downloadReport(reports_r5.maskId, reports_r5.documentId)); });
    i0.ɵɵtext(22, "Download");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const reports_r5 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const reportType_r9 = i0.ɵɵreference(59);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", reports_r5.outFileLogId)("checked", ctx_r1.removeReportsList && ctx_r1.removeReportsList.indexOf(reports_r5.outFileLogId) > -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r8 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", reportType_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(19, _c0$1, reports_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", reports_r5.reportsRequested);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(reports_r5.reportType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(reports_r5 && reports_r5.billingPeriod ? i0.ɵɵpipeBind2(13, 10, reports_r5.billingPeriod.startDate, "MM/dd/yyyy") : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(reports_r5 && reports_r5.billingPeriod ? i0.ɵɵpipeBind2(16, 13, reports_r5.billingPeriod.endDate, "MM/dd/yyyy") : "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(19, 16, reports_r5.fileCloseTimeStamp, "MM/dd/yyyy HH:mm:ss"));
} }
function availableReportsComponent_tbody_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, availableReportsComponent_tbody_34_tr_1_Template, 23, 21, "tr", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.reportsAvaialbleForDownload);
} }
function availableReportsComponent_ng_template_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 23)(2, "label", 24);
    i0.ɵɵtext(3, "No Results");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "label", 25);
    i0.ɵɵtext(6, "Reports will display when available.");
    i0.ɵɵelementEnd()()();
} }
function availableReportsComponent_tbody_55_tr_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function availableReportsComponent_tbody_55_tr_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reports_r10 = ctx.$implicit;
    const isLast_r11 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", reports_r10, "", isLast_r11 ? "" : ", ", "");
} }
function availableReportsComponent_tbody_55_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, availableReportsComponent_tbody_55_tr_1_ng_container_4_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 21);
    i0.ɵɵtemplate(6, availableReportsComponent_tbody_55_tr_1_span_6_Template, 2, 2, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td")(13, "a");
    i0.ɵɵtext(14, "In Process");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const reports_r12 = ctx.$implicit;
    const i_r13 = ctx.index;
    i0.ɵɵnextContext(2);
    const reportType_r9 = i0.ɵɵreference(59);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r13 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", reportType_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c0$1, reports_r12));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", reports_r12.reportsRequested);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(reports_r12.reportType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 6, reports_r12.fileCloseTimeStamp, "MM/dd/yyyy HH:mm:ss"));
} }
function availableReportsComponent_tbody_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, availableReportsComponent_tbody_55_tr_1_Template, 15, 11, "tr", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.reportsInProcess);
} }
function availableReportsComponent_ng_template_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 26)(2, "label", 24);
    i0.ɵɵtext(3, "No Results");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "label", 25);
    i0.ɵɵtext(6, "In process reports are shown if reports are not ready for download");
    i0.ɵɵelementEnd()()();
} }
function availableReportsComponent_ng_template_58_span_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const clientsSubclients_r14 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", clientsSubclients_r14.clientSpecifiedIdentifier, " - ", clientsSubclients_r14.subClientSpecifiedIdentifier, "");
} }
function availableReportsComponent_ng_template_58_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, availableReportsComponent_ng_template_58_span_0_span_1_Template, 2, 2, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reports_r15 = i0.ɵɵnextContext().reports;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", reports_r15.clientsSubclients);
} }
function availableReportsComponent_ng_template_58_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const consolidatedTo_r16 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", consolidatedTo_r16.clientSpecifiedIdentifier, " - ", consolidatedTo_r16.subClientSpecifiedIdentifier, "");
} }
function availableReportsComponent_ng_template_58_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, availableReportsComponent_ng_template_58_span_1_span_1_Template, 2, 2, "span", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reports_r15 = i0.ɵɵnextContext().reports;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", reports_r15.consolidatedTo);
} }
function availableReportsComponent_ng_template_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, availableReportsComponent_ng_template_58_span_0_Template, 2, 1, "span", 9)(1, availableReportsComponent_ng_template_58_span_1_Template, 2, 1, "span", 9);
} if (rf & 2) {
    const reports_r15 = ctx.reports;
    i0.ɵɵproperty("ngIf", reports_r15.reportType === "Non-Consolidated");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", reports_r15.reportType === "Consolidated");
} }
class availableReportsComponent {
    constructor(lux, aRAsync, sanitizer) {
        this.lux = lux;
        this.aRAsync = aRAsync;
        this.sanitizer = sanitizer;
        this.loaderImage = '';
        this.luxId = 'billing-lib-available-comp' + this.constructor.name;
        this.availableReportsResponse$ = this.lux.get(availableReportsRes, this.luxId);
        this.availableReportsError$ = this.lux.get(availableReportserror, this.luxId);
        this.isARFetching$ = this.lux.get(isFetchingAvailableReports, this.luxId);
        this.isARUpdating$ = this.lux.get(isUpdatingAvailableReports, this.luxId);
        this.downloadDocError$ = this.lux.get(downloadError, this.luxId);
        this.isDocDownloading$ = this.lux.get(isDownloading, this.luxId);
        this.removeAllReports = false;
    }
    ngOnInit() {
        this.getAvailablereports();
        this.availableReportsResponse$.subscribe(x => {
            if (x && x.availableReports && x.availableReports.length) {
                this.availableReportsResponse = x.availableReports;
                this.reportsAvaialbleForDownload = this.availableReportsResponse.filter(reports => reports.status === 'CLOSED');
                this.reportsInProcess = this.availableReportsResponse.filter(reports => reports.status === 'OPEN');
            }
            else {
                this.reportsAvaialbleForDownload = [];
            }
            this.removeReportsList = [];
            this.removeAllReports = false;
        });
        this.isARFetching$.subscribe(x => this.isARFetching = x);
        this.downloadDocError$.subscribe(x => this.downloadDocError = x);
        this.isDocDownloading$.subscribe(x => this.isDocDownloading = x);
        this.availableReportsError$.subscribe(x => this.availableReportsError = x);
        this.isARUpdating$.subscribe(x => this.isARFetching = x);
    }
    getAvailablereports() {
        const request = {
            pagination: {
                offset: 0,
                limit: 100
            },
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            startDate: moment(new Date()).subtract(7, 'd').format('YYYY-MM-DD')
        };
        this.lux.set(state => state.availableReports, { availableReportsRequest: request });
        this.aRAsync.getAvailableReports().subscribe();
    }
    downloadReport(id, filename) {
        const docType = filename.endsWith('pdf') ? 'PDF' : filename.endsWith('xls') ? 'XLS' : 'CSV';
        this.downloadDocError = '';
        this.aRAsync.downloadAsyncReport(id).subscribe(res => {
            docType === 'CSV' ? this.downloadCsvFile(res) : (docType === 'PDF') ? this.fromPDF(res) : this.formExcelBlobUrl(res, filename);
        });
    }
    formExcelBlobUrl(blobResponse, filename) {
        const file = new Blob([blobResponse.body], { type: 'application/vnd.ms-excel' });
        const fileURL = URL.createObjectURL(file);
        const resp = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(fileURL));
        const anchor = document.createElement('a');
        anchor.download = filename;
        anchor.href = resp;
        anchor.click();
    }
    fromPDF(response) {
        this.lux.set(state => state.availableReports, { isDownloading: false });
        const file = new Blob([response.body], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }
    downloadCsvFile(blobResponse) {
        this.lux.set(state => state.availableReports, { isDownloading: false });
        const file = new Blob([blobResponse.body], { type: 'text/csv' });
        const fileURL = URL.createObjectURL(file);
        const resp = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(fileURL));
        const anchor = document.createElement('a');
        anchor.download = 'billing-Reports.zip';
        anchor.href = resp;
        anchor.click();
    }
    downloadZipFile(blobResponse) {
        this.lux.set(state => state.availableReports, { isDownloading: false });
        const file = new Blob([blobResponse.body], { type: 'application/zip' });
        const fileURL = URL.createObjectURL(file);
        const sanitizedURL = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(fileURL));
        const anchor = document.createElement('a');
        anchor.download = 'download-reports.zip';
        anchor.href = sanitizedURL;
        anchor.click();
        URL.revokeObjectURL(fileURL);
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    updateRemoveList(outFileLogId) {
        if (this.removeReportsList === undefined) {
            this.removeReportsList = [];
        }
        if (this.removeReportsList.indexOf(outFileLogId) > -1) {
            this.removeReportsList.splice(this.removeReportsList.indexOf(outFileLogId), 1);
        }
        else {
            this.removeReportsList.push(outFileLogId);
        }
        this.removeAllReports = this.removeReportsList.length === this.reportsAvaialbleForDownload.length;
    }
    selectAllRemoveReports() {
        this.removeAllReports = !this.removeAllReports;
        this.removeReportsList = this.removeAllReports && this.reportsAvaialbleForDownload ? this.reportsAvaialbleForDownload.map(a => a.outFileLogId) : [];
    }
    removeReports() {
        this.lux.set(state => state.availableReports, {
            updateAvailableReportsRequest: [...this.removeReportsList.map(a => ({
                    outFileLogId: a,
                    reportViewable: 0
                }))]
        });
        this.aRAsync.updateAvailableReports().subscribe(() => this.getAvailablereports());
    }
    downloadSelectedReports() {
        const documentMaskIds = this.reportsAvaialbleForDownload
            .filter(report => this.removeReportsList.includes(report.outFileLogId))
            .map(report => report.maskId);
        if (documentMaskIds.length > 0) {
            this.aRAsync.downloadSelectedReports(documentMaskIds).subscribe(res => {
                if (res) {
                    this.downloadZipFile(res);
                }
            });
        }
    }
    static { this.ɵfac = function availableReportsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || availableReportsComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(AvailableReportsAsync), i0.ɵɵdirectiveInject(i3.DomSanitizer)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: availableReportsComponent, selectors: [["billing-available-reports"]], inputs: { loaderImage: "loaderImage" }, decls: 60, vars: 10, consts: [["noDownload", ""], ["noDownloads", ""], ["reportType", ""], [1, "row", "available-reports"], [1, "col-sm-12", "card"], [1, "reports-header"], [1, "refresh"], ["rs-raised-button", "", "color", "primary", 3, "click"], [1, "reports-sub-header"], [4, "ngIf"], [3, "change", "checked", "indeterminate", "disabled"], [4, "ngIf", "ngIfElse"], ["position", "absolute", 3, "imageSrc"], [1, "error"], [1, "row", "justify-content-end", "w-100", "pr-0"], [1, "col-auto", "pr-2"], ["rs-raised-button", "", 3, "click"], [1, "col-auto"], [4, "ngFor", "ngForOf"], [3, "change", "id", "checked"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "report-requested"], [3, "click"], ["colspan", "9", 1, "no-results"], [1, "no-results-title"], [1, "no-results-content"], ["colspan", "8", 1, "no-results"]], template: function availableReportsComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "h4");
            i0.ɵɵtext(4, "My Reports");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 6)(6, "button", 7);
            i0.ɵɵlistener("click", function availableReportsComponent_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.getAvailablereports()); });
            i0.ɵɵtext(7, "Refresh");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 8)(9, "label");
            i0.ɵɵtext(10, "Reports Download");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, availableReportsComponent_ng_container_11_Template, 2, 1, "ng-container", 9)(12, availableReportsComponent_ng_container_12_Template, 3, 1, "ng-container", 9)(13, availableReportsComponent_ng_container_13_Template, 8, 0, "ng-container", 9);
            i0.ɵɵelementStart(14, "table")(15, "thead")(16, "tr")(17, "th")(18, "rs-checkbox", 10);
            i0.ɵɵlistener("change", function availableReportsComponent_Template_rs_checkbox_change_18_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectAllRemoveReports()); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "th");
            i0.ɵɵtext(20, "Sr. No.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "th");
            i0.ɵɵtext(22, "Group ID - Subgroup ID");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "th");
            i0.ɵɵtext(24, "Report Name");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "th");
            i0.ɵɵtext(26, "Report Type");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "th");
            i0.ɵɵtext(28, "Billing Start Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "th");
            i0.ɵɵtext(30, "Billing End Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "th");
            i0.ɵɵtext(32, "Request Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "th");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(34, availableReportsComponent_tbody_34_Template, 2, 1, "tbody", 11)(35, availableReportsComponent_ng_template_35_Template, 7, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "div", 4)(38, "div", 8)(39, "label");
            i0.ɵɵtext(40, "In Process");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(41, "table")(42, "thead")(43, "tr")(44, "th");
            i0.ɵɵtext(45, "Sr. No.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "th");
            i0.ɵɵtext(47, "Group ID - Subgroup ID");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "th");
            i0.ɵɵtext(49, "Report Name");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "th");
            i0.ɵɵtext(51, "Report Type");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "th");
            i0.ɵɵtext(53, "Request Start Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(54, "th");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(55, availableReportsComponent_tbody_55_Template, 2, 1, "tbody", 11)(56, availableReportsComponent_ng_template_56_Template, 7, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(58, availableReportsComponent_ng_template_58_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            const noDownload_r17 = i0.ɵɵreference(36);
            const noDownloads_r18 = i0.ɵɵreference(57);
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("ngIf", ctx.isARFetching || ctx.isDocDownloading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.downloadDocError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.removeReportsList && ctx.removeReportsList.length > 0);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("checked", ctx.removeAllReports)("indeterminate", ctx.removeReportsList && ctx.removeReportsList.length > 0 && !ctx.removeAllReports)("disabled", !ctx.reportsAvaialbleForDownload || !ctx.reportsAvaialbleForDownload.length);
            i0.ɵɵadvance(16);
            i0.ɵɵproperty("ngIf", ctx.reportsAvaialbleForDownload && ctx.reportsAvaialbleForDownload.length)("ngIfElse", noDownload_r17);
            i0.ɵɵadvance(21);
            i0.ɵɵproperty("ngIf", ctx.reportsInProcess && ctx.reportsInProcess.length)("ngIfElse", noDownloads_r18);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i3$1.NgTemplateOutlet, i5.ButtonComponent, i7.LoaderComponent, i7$1.CheckboxComponent, i3$1.DatePipe], styles: [".available-reports[_ngcontent-%COMP%]   .reports-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.1803921569);margin:20px 0}.available-reports[_ngcontent-%COMP%]   .reports-sub-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.1803921569);margin-bottom:24px;margin-top:20px;padding-bottom:10px}.available-reports[_ngcontent-%COMP%]   .reports-sub-header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{border-bottom:3px solid #EB8510;font-weight:700;font-size:14px;padding-bottom:10px}.available-reports[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]{background-color:#0000001d;text-align:center;padding:2%}.available-reports[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]   .no-results-title[_ngcontent-%COMP%]{font-size:medium;color:#636870;margin:1%}.available-reports[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]   .no-results-content[_ngcontent-%COMP%]{font-size:small;color:#636870}.available-reports[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.available-reports[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .available-reports[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 0}.available-reports[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#06c;font-weight:700;cursor:pointer}.available-reports[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .available-reports[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .available-reports[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .available-reports[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.available-reports[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.available-reports[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border-collapse:collapse;width:100%}.available-reports[_ngcontent-%COMP%]   .refresh[_ngcontent-%COMP%]{text-align:right}.available-reports[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.available-reports[_ngcontent-%COMP%]   .report-requested[_ngcontent-%COMP%]{width:20%}.text-right[_ngcontent-%COMP%]{text-align:right}.pr-0[_ngcontent-%COMP%]{padding-right:0}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(availableReportsComponent, [{
        type: Component,
        args: [{ selector: 'billing-available-reports', template: "<div class=\"row available-reports\">\n    <div class=\"col-sm-12 card\">\n        <div class=\"reports-header\">\n            <h4>My Reports</h4>\n        </div>\n        <div class=\"refresh\">\n            <button rs-raised-button color=\"primary\" (click)=\"getAvailablereports()\">Refresh</button>\n        </div>\n        <div class=\"reports-sub-header\">\n            <label>Reports Download</label>\n        </div>\n        <ng-container *ngIf=\"(isARFetching || isDocDownloading)\">\n            <rs-loader position=\"absolute\" imageSrc={{loaderImage}}></rs-loader>\n        </ng-container>\n        <ng-container *ngIf=\"downloadDocError\">\n         <div class =\"error\">{{downloadDocError}}</div>   \n        </ng-container>\n        <ng-container *ngIf=\"removeReportsList && removeReportsList.length > 0\">\n            <div class=\"row justify-content-end  w-100 pr-0\">\n                <div class=\"col-auto pr-2\">\n                    <button rs-raised-button (click)=\"downloadSelectedReports()\">Download</button>\n                </div>\n                <div class=\"col-auto\">\n                    <button rs-raised-button (click)=\"removeReports()\">Remove</button>\n                </div>\n            </div>\n        </ng-container>\n        <table>\n            <thead>\n                <tr>\n                    <th><rs-checkbox (change)=\"selectAllRemoveReports()\" [checked]=\"removeAllReports\" [indeterminate]=\"removeReportsList && removeReportsList.length > 0 && !removeAllReports\" [disabled]=\"!reportsAvaialbleForDownload || !reportsAvaialbleForDownload.length\"></rs-checkbox></th>\n                    <th>Sr. No.</th>\n                    <th>Group ID - Subgroup ID</th>\n                    <th>Report Name</th>\n                    <th>Report Type</th>\n                    <th>Billing Start Date</th>\n                    <th>Billing End Date</th>\n                    <th>Request Date</th>\n                    <th> </th>\n                </tr>\n            </thead>\n            <tbody *ngIf=\"reportsAvaialbleForDownload && reportsAvaialbleForDownload.length; else noDownload\">\n                    <tr *ngFor=\"let reports of reportsAvaialbleForDownload; let i = index\">\n                        <td><rs-checkbox [id]=\"reports.outFileLogId\" (change)=\"updateRemoveList(reports.outFileLogId)\" [checked]=\"removeReportsList && removeReportsList.indexOf(reports.outFileLogId) > -1\"></rs-checkbox> </td>\n                        <td>{{i + 1}}</td>\n                        <td> <ng-container *ngTemplateOutlet=\"reportType; context:{reports: reports}\"></ng-container></td>\n                        <td class =\"report-requested\"><span *ngFor=\"let reports of reports.reportsRequested;let isLast=last\">{{reports}}{{isLast ? '' : ', '}}</span></td>\n                        <td>{{reports.reportType}}</td>\n                        <td>{{reports && reports.billingPeriod ? ((reports.billingPeriod.startDate) | date: 'MM/dd/yyyy') : ''}}</td>\n                        <td>{{reports && reports.billingPeriod ? ((reports.billingPeriod.endDate) | date: 'MM/dd/yyyy') : ''}}</td>\n                        <td>{{reports.fileCloseTimeStamp | date: 'MM/dd/yyyy HH:mm:ss'}}</td>\n                        <td><a (click)=\"downloadReport(reports.maskId,reports.documentId)\">Download</a></td>\n                    </tr>\n            </tbody>\n            <ng-template #noDownload>\n                <tr>\n                    <td colspan=\"9\" class=\"no-results\"><label class=\"no-results-title\">No Results</label> <br>\n                        <label class=\"no-results-content\">Reports will display when available.</label>\n                    </td>\n                </tr>\n            </ng-template>\n        </table>\n    </div>\n    <div class=\"col-sm-12 card\">\n        <div class=\"reports-sub-header\">\n            <label>In Process</label>\n        </div>\n        <table>\n            <thead>\n                <tr>\n                    <th>Sr. No.</th>\n                    <th>Group ID - Subgroup ID</th>\n                    <th>Report Name</th>\n                    <th>Report Type</th>\n                    <th>Request Start Date</th>\n                    <th> </th>\n                </tr>\n            </thead>\n            <tbody *ngIf=\"reportsInProcess && reportsInProcess.length;  else noDownloads\">\n                    <tr *ngFor=\"let reports of reportsInProcess; let i = index\">\n                        <td>{{i + 1}}</td>\n                        <td> <ng-container *ngTemplateOutlet=\"reportType; context:{reports: reports}\"></ng-container></td>\n                        <td class =\"report-requested\"><span *ngFor=\"let reports of reports.reportsRequested;let isLast=last\">{{reports}}{{isLast ? '' : ', '}}</span></td>\n                        <td>{{reports.reportType}}</td>\n                        <td>{{reports.fileCloseTimeStamp | date: 'MM/dd/yyyy HH:mm:ss'}}</td>\n                        <td><a>In Process</a></td>\n                    </tr>\n            </tbody>\n            <ng-template #noDownloads>\n                <tr>\n                    <td colspan=\"8\" class=\"no-results\"><label class=\"no-results-title\">No Results</label> <br>\n                        <label class=\"no-results-content\">In process reports are shown if reports are not ready for download</label>\n                    </td>\n                </tr>\n            </ng-template>\n            <ng-template #reportType let-reports=\"reports\">\n                <span *ngIf=\"reports.reportType === 'Non-Consolidated'\"><span *ngFor=\"let clientsSubclients of reports.clientsSubclients\">{{clientsSubclients.clientSpecifiedIdentifier}} - {{clientsSubclients.subClientSpecifiedIdentifier}}</span></span>\n                <span *ngIf=\"reports.reportType === 'Consolidated'\"><span *ngFor=\"let consolidatedTo of reports.consolidatedTo\"> {{consolidatedTo.clientSpecifiedIdentifier}} - {{consolidatedTo.subClientSpecifiedIdentifier}}</span></span>\n            </ng-template>\n            \n        </table>\n    </div>\n</div>\n", styles: [".available-reports .reports-header{border-bottom:1px solid rgba(0,0,0,.1803921569);margin:20px 0}.available-reports .reports-sub-header{border-bottom:1px solid rgba(0,0,0,.1803921569);margin-bottom:24px;margin-top:20px;padding-bottom:10px}.available-reports .reports-sub-header label{border-bottom:3px solid #EB8510;font-weight:700;font-size:14px;padding-bottom:10px}.available-reports .no-results{background-color:#0000001d;text-align:center;padding:2%}.available-reports .no-results .no-results-title{font-size:medium;color:#636870;margin:1%}.available-reports .no-results .no-results-content{font-size:small;color:#636870}.available-reports tbody tr:nth-child(odd){background-color:#f0f2f5}.available-reports th,.available-reports td{padding:12px 0}.available-reports td a{color:#06c;font-weight:700;cursor:pointer}.available-reports th:first-of-type,.available-reports td:first-of-type,.available-reports th:last-of-type,.available-reports td:last-of-type{padding-left:32px}.available-reports th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.available-reports table{border-collapse:collapse;width:100%}.available-reports .refresh{text-align:right}.available-reports .error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.available-reports .report-requested{width:20%}.text-right{text-align:right}.pr-0{padding-right:0}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: AvailableReportsAsync }, { type: i3.DomSanitizer }], { loaderImage: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(availableReportsComponent, { className: "availableReportsComponent", filePath: "lib/available-reports/availableReports/available-reports.component.ts", lineNumber: 18 }); })();

function InvoiceComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1, " Reports will be available under My Reports in the Billing section. Click here for ");
    i0.ɵɵelementStart(2, "a", 12);
    i0.ɵɵlistener("keydown.enter", function InvoiceComponent_div_1_Template_a_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openMyReports = true); })("click", function InvoiceComponent_div_1_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openMyReports = true); });
    i0.ɵɵtext(3, " Available reports ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " quick view");
    i0.ɵɵelementEnd();
} }
function InvoiceComponent_rs_loader_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("imageSrc", ctx_r2.loaderImage);
} }
function InvoiceComponent_ng_container_4_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "Total Invoice Count");
    i0.ɵɵelementEnd();
} }
function InvoiceComponent_ng_container_4_tr_20_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 21);
    i0.ɵɵlistener("click", function InvoiceComponent_ng_container_4_tr_20_ng_container_17_Template_td_click_1_listener() { i0.ɵɵrestoreView(_r6); const item_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.getIndividualInvoices(item_r5)); });
    i0.ɵɵelementStart(2, "a");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r5.totalInvoiceCount);
} }
function InvoiceComponent_ng_container_4_tr_20_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "a", 15);
    i0.ɵɵlistener("keydown.enter", function InvoiceComponent_ng_container_4_tr_20_Template_a_keydown_enter_2_listener($event) { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectedAction($event, item_r5)); })("click", function InvoiceComponent_ng_container_4_tr_20_Template_a_click_2_listener($event) { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectedAction($event, item_r5)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 16);
    i0.ɵɵlistener("click", function InvoiceComponent_ng_container_4_tr_20_Template_a_click_4_listener() { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.downloadStandardandInvoiceReports(item_r5)); });
    i0.ɵɵelementStart(5, "span", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 18);
    i0.ɵɵlistener("keydown.enter", function InvoiceComponent_ng_container_4_tr_20_Template_svg_keydown_enter_6_listener() { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.downloadStandardandInvoiceReports(item_r5)); });
    i0.ɵɵelement(7, "path", 19)(8, "path", 20);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, InvoiceComponent_ng_container_4_tr_20_ng_container_17_Template, 4, 1, "ng-container", 6);
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "td")(25, "a", 21);
    i0.ɵɵlistener("click", function InvoiceComponent_ng_container_4_tr_20_Template_a_click_25_listener() { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onClickRemainingBalance(item_r5)); });
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const AdminTooltip_r7 = i0.ɵɵreference(6);
    const clamsTooltip_r8 = i0.ɵɵreference(11);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.feed.isNonConsolidated ? item_r5.invoiceNumber : item_r5.consolidatedInvoiceNumber);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rsTooltipTrigger", item_r5.billType === "Claims" ? clamsTooltip_r8 : AdminTooltip_r7);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(item_r5.billType || "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 9, item_r5.startDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 12, item_r5.endDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.feed.isNonConsolidated);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 15, item_r5.invoiceAmount));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(23, 17, item_r5.dueDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r5.status === "PENDING" ? "Pending" : i0.ɵɵpipeBind1(27, 20, item_r5.remainingBalance));
} }
function InvoiceComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table")(2, "thead")(3, "tr")(4, "th");
    i0.ɵɵtext(5, "Invoice #");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Invoice Type/Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, InvoiceComponent_ng_container_4_th_12_Template, 2, 0, "th", 6);
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Invoice Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Due Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Remaining Balance");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "tbody");
    i0.ɵɵtemplate(20, InvoiceComponent_ng_container_4_tr_20_Template, 28, 22, "tr", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", !ctx_r2.feed.isNonConsolidated);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", ctx_r2.invoiceResponse.invoices);
} }
function InvoiceComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.errorMsg);
} }
function InvoiceComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "rs-paginator", 24);
    i0.ɵɵlistener("page", function InvoiceComponent_div_16_Template_rs_paginator_page_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.pageChanged($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("length", ctx_r2.invoiceResponse.pagination.totalRecords)("pageSize", ctx_r2.defaultPageSize);
} }
function InvoiceComponent_div_18_rs_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader", 29);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r2.loaderImage);
} }
function InvoiceComponent_div_18_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.individualInvoiceErrorMsg);
} }
function InvoiceComponent_div_18_tr_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r10.invoiceNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r10.clientSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r10.subclientSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r10.subclientName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 8, item_r10.startDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 11, item_r10.endDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 14, item_r10.invoiceAmount));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 16, item_r10.remainingBalance));
} }
function InvoiceComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, InvoiceComponent_div_18_rs_loader_1_Template, 1, 1, "rs-loader", 26)(2, InvoiceComponent_div_18_div_2_Template, 2, 1, "div", 27);
    i0.ɵɵelementStart(3, "div", 28)(4, "table")(5, "thead")(6, "tr")(7, "th");
    i0.ɵɵtext(8, "Invoice #");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Group ID\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Subgroup ID\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Subgroup Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20, "Invoice Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "th");
    i0.ɵɵtext(22, "Remaining Balance");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(23, "tbody");
    i0.ɵɵtemplate(24, InvoiceComponent_div_18_tr_24_Template, 21, 18, "tr", 14);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isFetchingIndividualInvoice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.individualInvoiceErrorMsg);
    i0.ɵɵadvance(22);
    i0.ɵɵproperty("ngForOf", ctx_r2.individualInvoiceResponse);
} }
function InvoiceComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "billing-available-reports");
    i0.ɵɵelementEnd();
} }
class InvoiceComponent {
    get feed() {
        return this._feed;
    }
    set feed(val) {
        this._feed = val;
        val && this.getInvoiceRecords(val);
    }
    constructor(lux, bAsync) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.openOptionsforRow = 0;
        this.invoiceDetails = new EventEmitter();
        this.emitInvoiceActivity = new EventEmitter();
        this.showDialog = false;
        this.loaderImage = '';
        this.openMyReports = false;
        this.luxId = 'billing-lib-invoice-comp' + this.constructor.name;
        this.defaultPageSize = 10;
        this.errorMsg$ = this.lux.get(error, this.luxId);
        this.isFetching$ = this.lux.get(isInvoiceFetching, this.luxId);
        this.individualInvoiceErrorMsg$ = this.lux.get(individualInvoiceError, this.luxId);
        this.isFetchingIndividualInvoice$ = this.lux.get(isFetchingIndividualInvoice, this.luxId);
        this.isFetchingDownloadReports$ = this.lux.get(isFetchingDownload, this.luxId);
        this.documentDownloadError$ = this.lux.get(documentDownloadError, this.luxId);
        this.downloadReportResponse$ = this.lux.get(downloadResponse, this.luxId);
    }
    ngOnInit() {
        this.errorMsg$.subscribe(x => this.errorMsg = x);
        this.isFetching$.subscribe(x => this.isFetching = x);
        this.individualInvoiceErrorMsg$.subscribe(error => this.individualInvoiceErrorMsg = error);
        this.isFetchingIndividualInvoice$.subscribe(fetching => this.isFetchingIndividualInvoice = fetching);
        this.isFetchingDownloadReports$.subscribe(fetching => this.isFetchingDownloadReports = fetching);
        this.downloadReportResponse$.subscribe(x => {
            if (x) {
                this.downloadReportResponse = x;
            }
        });
    }
    getInvoiceRecords(val) {
        this.lux.set(state => state.billing, { downloadInvoiceResponse: initialBillingState.downloadInvoiceResponse });
        this.invoiceResponse = '';
        const clientId = val.groupId;
        const subGroupId = val && val.subGroupId;
        const commonRequest = {
            pagination: {
                offset: 0,
                limit: 10
            },
            planAcronym: val.plan,
            startDate: val.sDate,
            endDate: val.eDate,
        };
        const request = {
            ...commonRequest,
            ...(this.feed.isNonConsolidated) ? {
                clientsSubclients: {
                    clientSpecifiedIdentifier: clientId,
                    subClientSpecifiedIdentifier: subGroupId ? subGroupId : ''
                }
            } : {
                consolidatedTo: {
                    clientSpecifiedIdentifier: clientId,
                    subClientSpecifiedIdentifier: subGroupId ? subGroupId : ''
                }
            }
        };
        this.lux.set(state => state.billing, { invoiceRequest: request });
        this.bAsync.getInvoiceRecords(this.feed.isNonConsolidated).subscribe(invoices => {
            this.invoiceResponse = invoices;
            this.isFetching = false;
        });
    }
    pageChanged(page) {
        this.resetDownloadReportsState();
        this.getMoreRecords(page.pageIndex >= 1 ? (page.pageIndex * this.defaultPageSize) : 0);
    }
    getMoreRecords(offset) {
        this.lux.set(state => state.billing.invoiceRequest.pagination, { offset });
        this.bAsync.getInvoiceRecords(this.feed.isNonConsolidated).subscribe(x => this.invoiceResponse = x);
    }
    selectedAction(event, data) {
        this.resetDownloadReportsState();
        event.stopPropagation();
        const emitObj = {
            ...data,
            ...this.feed
        };
        this.invoiceDetails.emit(emitObj);
        this.openOptionsforRow = 0;
    }
    getIndividualInvoices(item) {
        const request = {
            planAcronym: this.feed.plan,
            consolidationDetails: [
                {
                    invoiceNumber: item.consolidatedInvoiceNumber,
                    remainingBalance: item.remainingBalance
                }
            ]
        };
        this.showDialog = true;
        this.bAsync.getIndividualInvoices(request).subscribe(invoiceResponse => {
            if (invoiceResponse.invoices && invoiceResponse.invoices.length) {
                this.individualInvoiceResponse = invoiceResponse.invoices;
            }
        });
    }
    downloadStandardandInvoiceReports(item) {
        const AdminReports = [{ report: 'STANDARD_BILLING_REPORT', format: ['XLS'] }, { report: 'INVOICE', format: ['PDF'] }];
        const ClaimsReport = [{ report: 'CLAIMS_INVOICE', format: ['PDF'] }, { report: 'CLAIMS_DETAIL', format: ['XLS'] }];
        this.resetDownloadReportsState();
        const commonDownloadRequest = {
            billingPeriod: {
                startDate: moment(item.startDate).format('YYYY-MM-DD'),
                endDate: moment(item.endDate).format('YYYY-MM-DD')
            },
            reportsAndFileFormats: item.billType === 'Claims' ? ClaimsReport : AdminReports,
            planAcronym: this.feed.plan,
        };
        const clientSubclientObj = {
            clientSpecifiedIdentifier: this.feed.groupId,
            ...this.feed.subGroupId && { subClientSpecifiedIdentifier: this.feed.subGroupId }
        };
        const request = {
            ...commonDownloadRequest,
            ...(this.feed.isNonConsolidated) ? {
                clientsSubclients: [
                    clientSubclientObj
                ]
            } : {
                consolidatedTo: [
                    clientSubclientObj
                ]
            }
        };
        this.lux.set(state => state.billing, { downloadInvoiceRequest: request });
        this.bAsync.downloadRecords(this.feed.isNonConsolidated).subscribe();
        // if (document && document.deliveryType && (document.deliveryType).toLowerCase() === 'sync' ) {
        //     this.bAsync.downloadAsyncReport(document.id, document.format).subscribe(res => {
        //         this.isFetching = false;
        //         this.documentDownloadError$.subscribe(error => this.documentDownloadError = error);
        //     })
        // }
    }
    onClickRemainingBalance(data) {
        const emitObj = {
            ...data,
            ...this.feed
        };
        this.emitInvoiceActivity.emit(emitObj);
    }
    dialogClose(event) {
        this.showDialog = false;
        this.openMyReports = false;
        this.individualInvoiceResponse = [];
        this.individualInvoiceErrorMsg = '';
    }
    resetDownloadReportsState() {
        this.lux.set(state => state.billing, { documentDownloadError: '', invoiceDownloadError: '', downloadInvoiceResponse: initialBillingState.downloadInvoiceResponse });
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function InvoiceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InvoiceComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvoiceComponent, selectors: [["billing-invoice"]], inputs: { loaderImage: "loaderImage", feed: "feed" }, outputs: { invoiceDetails: "invoiceDetails", emitInvoiceActivity: "emitInvoiceActivity" }, decls: 20, vars: 9, consts: [["AdminTooltip", ""], ["clamsTooltip", ""], [1, "invoice-container"], ["class", "message", 4, "ngIf"], [1, "search-results-content"], [3, "imageSrc", 4, "ngIf"], [4, "ngIf"], ["class", "billing-pagination", 4, "ngIf"], ["maxWidth", "70%", 3, "visibleChange", "visible", "heading"], ["class", "search-results-container", 4, "ngIf"], ["class", "avaialable-reports", 4, "ngIf"], [1, "message"], ["role", "button", "tabindex", "0", 3, "keydown.enter", "click"], [3, "imageSrc"], [4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 1, "invoice-number", 3, "keydown.enter", "click"], [1, "standard-reports", 3, "click", "rsTooltipTrigger"], [1, "svg-holder"], ["alt", "Get Report", "role", "button", "tabindex", "0", "viewBox", "0 0 20 20", 1, "svg-icon", 3, "keydown.enter"], ["fill", "none", "d", "M9.634,10.633c0.116,0.113,0.265,0.168,0.414,0.168c0.153,0,0.308-0.06,0.422-0.177l4.015-4.111c0.229-0.235,0.225-0.608-0.009-0.836c-0.232-0.229-0.606-0.222-0.836,0.009l-3.604,3.689L6.35,5.772C6.115,5.543,5.744,5.55,5.514,5.781C5.285,6.015,5.29,6.39,5.522,6.617L9.634,10.633z"], ["fill", "none", "d", "M17.737,9.815c-0.327,0-0.592,0.265-0.592,0.591v2.903H2.855v-2.903c0-0.327-0.264-0.591-0.591-0.591c-0.327,0-0.591,0.265-0.591,0.591V13.9c0,0.328,0.264,0.592,0.591,0.592h15.473c0.327,0,0.591-0.264,0.591-0.592v-3.494C18.328,10.08,18.064,9.815,17.737,9.815z"], [3, "click"], [1, "error"], [1, "billing-pagination"], ["showFirstLastButtons", "", 3, "page", "length", "pageSize"], [1, "search-results-container"], ["position", "absolute", 3, "imageSrc", 4, "ngIf"], ["class", "error", 4, "ngIf"], [1, "search-results"], ["position", "absolute", 3, "imageSrc"], [1, "avaialable-reports"]], template: function InvoiceComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, InvoiceComponent_div_1_Template, 5, 0, "div", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵtemplate(3, InvoiceComponent_rs_loader_3_Template, 1, 1, "rs-loader", 5)(4, InvoiceComponent_ng_container_4_Template, 21, 2, "ng-container", 6);
            i0.ɵɵelementStart(5, "rs-tooltip", null, 0)(7, "div");
            i0.ɵɵtext(8, "Standard Billing Report and Invoice fast download");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(9, "> ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "rs-tooltip", null, 1)(12, "div");
            i0.ɵɵtext(13, "Claims fast download");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(14, "> ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, InvoiceComponent_ng_container_15_Template, 3, 1, "ng-container", 6)(16, InvoiceComponent_div_16_Template, 2, 2, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "rs-dialog", 8);
            i0.ɵɵlistener("visibleChange", function InvoiceComponent_Template_rs_dialog_visibleChange_17_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dialogClose($event)); });
            i0.ɵɵtemplate(18, InvoiceComponent_div_18_Template, 25, 3, "div", 9)(19, InvoiceComponent_div_19_Template, 2, 0, "div", 10);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.downloadReportResponse && ctx.downloadReportResponse.deliveryType);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isFetching || ctx.isFetchingDownloadReports);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.invoiceResponse && ctx.invoiceResponse.invoices && ctx.invoiceResponse.invoices);
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("ngIf", ctx.errorMsg);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.invoiceResponse && ctx.invoiceResponse.invoices && ctx.invoiceResponse.invoices.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("visible", ctx.showDialog || ctx.openMyReports)("heading", ctx.showDialog ? "Individual Invoices" : "Available Reports");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showDialog);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.openMyReports);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i4.PaginatorComponent, i5$1.TooltipComponent, i5$1.TooltipDirective, i6.DialogComponent, i7.LoaderComponent, availableReportsComponent, i3$1.CurrencyPipe, i3$1.DatePipe], styles: [".invoice-container[_ngcontent-%COMP%]{padding:0 16px 0 29px}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 5px;width:100px}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0c6ac7;text-decoration:none;cursor:pointer}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{vertical-align:middle}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #c2c2c2;border-collapse:collapse;width:100%;margin-left:15px}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}.invoice-container[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .invoice-number[_ngcontent-%COMP%]{display:inline-block;width:50%}.invoice-container[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.invoice-container[_ngcontent-%COMP%]   .billing-pagination[_ngcontent-%COMP%]{margin:2px 0 0 30px}.invoice-container[_ngcontent-%COMP%]   .search-results-container[_ngcontent-%COMP%]{height:400px}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]{padding:5px 10px 20px}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #c2c2c2;border-collapse:collapse;width:100%;margin-left:0}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{display:block;max-height:350px;overflow-x:hidden}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%], .invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{display:table;width:100%;table-layout:fixed}.invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .invoice-container[_ngcontent-%COMP%]   .search-results[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 5px;width:100px;text-align:center}.invoice-container[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{border:1px solid red;padding:10px;color:red}.invoice-container[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#06c;cursor:pointer}.invoice-container[_ngcontent-%COMP%]   .svg-holder[_ngcontent-%COMP%]{display:inline-block;width:30px;height:30px;top:8px;position:relative;left:10px}.invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]{width:100%;height:100%}.invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]   polygon[_ngcontent-%COMP%], .invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:#4691f6}.invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.invoice-container[_ngcontent-%COMP%]   .svg-icon[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#4691f6;stroke-width:1}.invoice-container[_ngcontent-%COMP%]   .standard-reports[_ngcontent-%COMP%]{padding-left:20px;cursor:pointer}.invoice-container[_ngcontent-%COMP%]   .avaialable-reports[_ngcontent-%COMP%]{padding:5px}.invoice-container[_ngcontent-%COMP%]   .avaialable-reports[_ngcontent-%COMP%]:hover{outline:none;border:2px solid #1D8928}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvoiceComponent, [{
        type: Component,
        args: [{ selector: 'billing-invoice', template: "<div class=\"invoice-container\">\n    <div *ngIf=\"downloadReportResponse && downloadReportResponse.deliveryType\" class=\"message\">\n        Reports will be available under My Reports in the Billing section. Click here for\n        <a role=\"button\" tabindex=\"0\" (keydown.enter)=\"openMyReports = true\" (click)=\"openMyReports = true\"> Available reports </a> quick view</div>\n    <div class=\"search-results-content\">\n        <rs-loader *ngIf=\"(isFetching || isFetchingDownloadReports)\" [imageSrc]=\"loaderImage\"></rs-loader>\n        <ng-container *ngIf=\"invoiceResponse &&invoiceResponse.invoices && invoiceResponse.invoices\">\n            <table>\n                <thead>\n                <tr>\n                    <th>Invoice #</th>\n                    <th>Invoice Type/Name</th>\n                    <th>Start Date</th>\n                    <th>End Date</th>\n                    <th *ngIf=\"!feed.isNonConsolidated\">Total Invoice Count</th>\n                    <th>Invoice Amount</th>\n                    <th>Due Date</th>\n                    <th>Remaining Balance</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let item of invoiceResponse.invoices; let i = index\">\n                    <td >\n                        <a class = \"invoice-number\" role=\"button\" tabindex=\"0\" (keydown.enter)=\"selectedAction($event,item)\" (click)=\"selectedAction($event,item)\">{{(feed.isNonConsolidated) ? item.invoiceNumber : item.consolidatedInvoiceNumber}}</a>\n                        <a (click)=\"downloadStandardandInvoiceReports(item)\" [rsTooltipTrigger]=\"item.billType === 'Claims' ? clamsTooltip : AdminTooltip\" class = \"standard-reports\">\n                                <span class=\"svg-holder\">\n                                  <svg alt=\"Get Report\" role=\"button\" tabindex=\"0\" (keydown.enter)=\"downloadStandardandInvoiceReports(item)\" class=\"svg-icon\" viewBox=\"0 0 20 20\">\n                                    <path fill=\"none\"\n                                          d=\"M9.634,10.633c0.116,0.113,0.265,0.168,0.414,0.168c0.153,0,0.308-0.06,0.422-0.177l4.015-4.111c0.229-0.235,0.225-0.608-0.009-0.836c-0.232-0.229-0.606-0.222-0.836,0.009l-3.604,3.689L6.35,5.772C6.115,5.543,5.744,5.55,5.514,5.781C5.285,6.015,5.29,6.39,5.522,6.617L9.634,10.633z\">\n                                    </path>\n                                    <path fill=\"none\"\n                                          d=\"M17.737,9.815c-0.327,0-0.592,0.265-0.592,0.591v2.903H2.855v-2.903c0-0.327-0.264-0.591-0.591-0.591c-0.327,0-0.591,0.265-0.591,0.591V13.9c0,0.328,0.264,0.592,0.591,0.592h15.473c0.327,0,0.591-0.264,0.591-0.592v-3.494C18.328,10.08,18.064,9.815,17.737,9.815z\">\n                                    </path>\n                                  </svg>\n                                </span></a>\n                    </td>\n                    <td>{{item.billType || ''}}</td>\n                    <td>{{(item.startDate | date: 'MM/dd/yyyy') || ''}}</td>\n                    <td>{{(item.endDate | date: 'MM/dd/yyyy') || ''}}</td>\n                    <ng-container *ngIf=\"!feed.isNonConsolidated\">\n                        <td (click)=\"getIndividualInvoices(item)\" ><a>{{item.totalInvoiceCount}}</a></td>\n                    </ng-container>\n                    <td>{{(item.invoiceAmount)| currency}}</td>\n                    <td>{{(item.dueDate | date: 'MM/dd/yyyy') || ''}}</td>\n                    <td><a (click)=\"onClickRemainingBalance(item)\">{{item.status === 'PENDING' ? 'Pending': ((item.remainingBalance) | currency)}}</a></td>\n                </tr>\n                </tbody>\n            </table>\n        </ng-container>\n        <rs-tooltip #AdminTooltip>\n            <div>Standard Billing Report and Invoice fast download</div>>\n        </rs-tooltip>\n        <rs-tooltip #clamsTooltip>\n            <div>Claims fast download</div>>\n        </rs-tooltip>\n        <ng-container *ngIf=\"errorMsg\">\n            <div class=\"error\">{{errorMsg}}</div>\n        </ng-container>\n        <div *ngIf=\"invoiceResponse && invoiceResponse.invoices && invoiceResponse.invoices.length\"\n             class=\"billing-pagination\">\n            <rs-paginator  [length]=\"invoiceResponse.pagination.totalRecords\" showFirstLastButtons\n                           (page)=\"pageChanged($event)\" [pageSize]=\"defaultPageSize\"></rs-paginator>\n        </div>\n    </div>\n    <rs-dialog [visible]=\"showDialog || openMyReports\"  maxWidth=\"70%\" (visibleChange)=\"dialogClose($event)\" [heading]=\" showDialog ? 'Individual Invoices' : 'Available Reports'\">\n        <div *ngIf=\"showDialog\" class = \"search-results-container\">\n            <rs-loader *ngIf=\"isFetchingIndividualInvoice\" position=\"absolute\" imageSrc={{loaderImage}}></rs-loader>\n            <div  *ngIf=\"individualInvoiceErrorMsg\" class=\"error\">{{individualInvoiceErrorMsg}}</div>\n            <div class=\"search-results\">\n                <table>\n                    <thead>\n                    <tr>\n                        <th>Invoice #</th>\n                        <th>Group ID\u00A0</th>\n                        <th>Subgroup ID\u00A0</th>\n                        <th>Subgroup Name</th>\n                        <th>Start Date</th>\n                        <th>End Date</th>\n                        <th>Invoice Amount</th>\n                        <th>Remaining Balance</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of individualInvoiceResponse\">\n                        <td>{{item.invoiceNumber}}</td>\n                        <td>{{item.clientSpecifiedIdentifier}}</td>\n                        <td>{{item.subclientSpecifiedIdentifier}}</td>\n                        <td>{{item.subclientName}}</td>\n                        <td>{{(item.startDate | date: 'MM/dd/yyyy') || ''}}</td>\n                        <td>{{(item.endDate | date: 'MM/dd/yyyy') || ''}}</td>\n                        <td>{{(item.invoiceAmount) | currency}}</td>\n                        <td>{{(item.remainingBalance) | currency}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div *ngIf=\"openMyReports\" class=\"avaialable-reports\">\n            <billing-available-reports></billing-available-reports>\n        </div>\n    </rs-dialog>\n</div>\n", styles: [".invoice-container{padding:0 16px 0 29px}.invoice-container .search-results-content tbody tr:nth-child(odd){background-color:#f0f2f5}.invoice-container .search-results-content th,.invoice-container .search-results-content td{padding:12px 5px;width:100px}.invoice-container .search-results-content td a{color:#0c6ac7;text-decoration:none;cursor:pointer}.invoice-container .search-results-content td a:focus{outline:none;border:2px solid #1D8928}.invoice-container .search-results-content td label{vertical-align:middle}.invoice-container .search-results-content th:first-of-type,.invoice-container .search-results-content td:first-of-type,.invoice-container .search-results-content th:last-of-type,.invoice-container .search-results-content td:last-of-type{padding-left:32px}.invoice-container .search-results-content th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.invoice-container .search-results-content table{border:1px solid #c2c2c2;border-collapse:collapse;width:100%;margin-left:15px}.invoice-container .search-results-content tbody tr{cursor:pointer}.invoice-container .search-results-content .invoice-number{display:inline-block;width:50%}.invoice-container .error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.invoice-container .billing-pagination{margin:2px 0 0 30px}.invoice-container .search-results-container{height:400px}.invoice-container .search-results{padding:5px 10px 20px}.invoice-container .search-results table{border:1px solid #c2c2c2;border-collapse:collapse;width:100%;margin-left:0}.invoice-container .search-results tbody{display:block;max-height:350px;overflow-x:hidden}.invoice-container .search-results tbody tr:nth-child(odd){background-color:#f0f2f5}.invoice-container .search-results thead,.invoice-container .search-results tbody tr{display:table;width:100%;table-layout:fixed}.invoice-container .search-results th,.invoice-container .search-results td{padding:12px 5px;width:100px;text-align:center}.invoice-container .message{border:1px solid red;padding:10px;color:red}.invoice-container .message a{color:#06c;cursor:pointer}.invoice-container .svg-holder{display:inline-block;width:30px;height:30px;top:8px;position:relative;left:10px}.invoice-container .svg-icon{width:100%;height:100%}.invoice-container .svg-icon path,.invoice-container .svg-icon polygon,.invoice-container .svg-icon rect{fill:#4691f6}.invoice-container .svg-icon:focus{outline:none;border:2px solid #1D8928}.invoice-container .svg-icon circle{stroke:#4691f6;stroke-width:1}.invoice-container .standard-reports{padding-left:20px;cursor:pointer}.invoice-container .avaialable-reports{padding:5px}.invoice-container .avaialable-reports:hover{outline:none;border:2px solid #1D8928}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }], { invoiceDetails: [{
            type: Output
        }], emitInvoiceActivity: [{
            type: Output
        }], loaderImage: [{
            type: Input
        }], feed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(InvoiceComponent, { className: "InvoiceComponent", filePath: "lib/billing/invoice/invoice.component.ts", lineNumber: 14 }); })();

function InvoiceDownloadComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r0.loaderImage);
} }
function InvoiceDownloadComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.reportFormatError);
} }
function InvoiceDownloadComponent_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "label");
    i0.ɵɵtext(3, "Parent Subgroup ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "label");
    i0.ɵɵtext(8, "Consolidation Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div")(12, "label");
    i0.ɵɵtext(13, "Invoice #");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div")(17, "label");
    i0.ɵɵtext(18, "Invoice Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.subGroupId || "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.consolidationName || "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.invoice || "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.billType || "");
} }
function InvoiceDownloadComponent_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "label");
    i0.ɵɵtext(3, "Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "label");
    i0.ɵɵtext(8, "Group Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.groupId || "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.groupName || "");
} }
function InvoiceDownloadComponent_div_3_ng_container_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label");
    i0.ɵɵtext(2, "Invoice #");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.invoice || "");
} }
function InvoiceDownloadComponent_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "label");
    i0.ɵɵtext(3, "Subgroup ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "label");
    i0.ɵɵtext(8, "Subgroup Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, InvoiceDownloadComponent_div_3_ng_container_4_div_11_Template, 5, 1, "div", 1);
    i0.ɵɵelementStart(12, "div")(13, "label");
    i0.ɵɵtext(14, "Invoice Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.subGroupId || "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.subGroupName || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.invoiceInput.selectedView === "Subgroup Reports");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.invoiceInput.billType || "");
} }
function InvoiceDownloadComponent_div_3_ng_container_15_div_4_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 15)(1, "rs-checkbox", 16);
    i0.ɵɵlistener("change", function InvoiceDownloadComponent_div_3_ng_container_15_div_4_span_3_Template_rs_checkbox_change_1_listener($event) { const format_r4 = i0.ɵɵrestoreView(_r3).$implicit; const reports_r5 = i0.ɵɵnextContext().$implicit; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.selectedFormats(format_r4, reports_r5.reportType, $event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const format_r4 = ctx.$implicit;
    const j_r6 = ctx.index;
    const i_r7 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", format_r4)("value", format_r4)("id", format_r4 + j_r6 + i_r7)("checked", format_r4.checked);
} }
function InvoiceDownloadComponent_div_3_ng_container_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, InvoiceDownloadComponent_div_3_ng_container_15_div_4_span_3_Template, 2, 4, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reports_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.reportType(reports_r5.reportType), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", reports_r5.reportFormats);
} }
function InvoiceDownloadComponent_div_3_ng_container_15_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.downloadReportError);
} }
function InvoiceDownloadComponent_div_3_ng_container_15_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.documentDownloadError);
} }
function InvoiceDownloadComponent_div_3_ng_container_15_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtext(2, "Reports will be available under My Reports in the Billing section. Click here for ");
    i0.ɵɵelementStart(3, "a", 18);
    i0.ɵɵlistener("click", function InvoiceDownloadComponent_div_3_ng_container_15_ng_container_12_Template_a_click_3_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.navigateToMyReports($event)); });
    i0.ɵɵtext(4, " Available reports ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " quick view");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function InvoiceDownloadComponent_div_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "div", 9);
    i0.ɵɵtext(3, "Please select report types and formats to Download");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, InvoiceDownloadComponent_div_3_ng_container_15_div_4_Template, 4, 2, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7)(6, "div", 11)(7, "span")(8, "button", 12);
    i0.ɵɵlistener("click", function InvoiceDownloadComponent_div_3_ng_container_15_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.downloadReports()); });
    i0.ɵɵtext(9, "DOWNLOAD");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, InvoiceDownloadComponent_div_3_ng_container_15_ng_container_10_Template, 3, 1, "ng-container", 1)(11, InvoiceDownloadComponent_div_3_ng_container_15_ng_container_11_Template, 3, 1, "ng-container", 1)(12, InvoiceDownloadComponent_div_3_ng_container_15_ng_container_12_Template, 6, 0, "ng-container", 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.formatResponse);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.downloadReportError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.documentDownloadError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.downloadReportResponse && ctx_r0.downloadReportResponse.deliveryType.toLowerCase() === "async");
} }
function InvoiceDownloadComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, InvoiceDownloadComponent_div_3_ng_container_2_Template, 21, 4, "ng-container", 1)(3, InvoiceDownloadComponent_div_3_ng_container_3_Template, 11, 2, "ng-container", 1)(4, InvoiceDownloadComponent_div_3_ng_container_4_Template, 17, 4, "ng-container", 1);
    i0.ɵɵelementStart(5, "div")(6, "label");
    i0.ɵɵtext(7, "Invoice Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, "-");
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(15, InvoiceDownloadComponent_div_3_ng_container_15_Template, 13, 4, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.invoiceInput.selectedView === "Consolidated Reports");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.invoiceInput.selectedView === "Group Reports" || ctx_r0.invoiceInput.isFromHistoricalReports);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.invoiceInput.selectedView === "Subgroup Reports" || ctx_r0.invoiceInput.isFromHistoricalReports);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("(", i0.ɵɵpipeBind2(10, 6, ctx_r0.invoiceInput.invoiceStartDate, "MM/dd/yyyy") || "", "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(14, 9, ctx_r0.invoiceInput.invoiceEndDate, "MM/dd/yyyy") || "", ")");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.formatResponse && ctx_r0.formatResponse.length);
} }
function InvoiceDownloadComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "a", 20);
    i0.ɵɵlistener("click", function InvoiceDownloadComponent_div_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.openMyReports = false); });
    i0.ɵɵtext(2, "Back To Download Invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "billing-available-reports");
    i0.ɵɵelementEnd();
} }
class InvoiceDownloadComponent {
    get downloadFeed() {
        return this._downloadFeed;
    }
    set downloadFeed(val) {
        this._downloadFeed = val;
        val && this.displayOptions(val);
    }
    constructor(lux, bAsync) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.downloadDilogClosed = new EventEmitter();
        this.loaderImage = '';
        this.reportsAndFileFormats = {};
        this.luxId = 'billing-lib-invoice-download-comp' + this.constructor.name;
        this.downloadReportError$ = this.lux.get(invoiceDownloaderrorMessage, this.luxId);
        this.downloadReportResponse$ = this.lux.get(downloadResponse, this.luxId);
        this.isFetching$ = this.lux.get(isFetchingDownload, this.luxId);
        this.isReportFormatFetching$ = this.lux.get(isFetchingReportFormats, this.luxId);
        this.reportFormatError$ = this.lux.get(reportFormatError, this.luxId);
        this.formatResponse$ = this.lux.get(reportFormatResponse, this.luxId);
        this.documentDownloadError$ = this.lux.get(documentDownloadError, this.luxId);
    }
    ngOnInit() {
        this.formatResponse$.subscribe(response => {
            if (response && response.length) {
                this.formatResponse = response[0].billingReports;
            }
        });
        this.downloadReportError$.subscribe(err => {
            if (err) {
                this.downloadReportError = err;
            }
        });
        this.reportFormatError$.subscribe(err => {
            if (err) {
                this.reportFormatError = err;
            }
        });
        this.isFetching$.subscribe(x => this.isFetching = x);
        this.isReportFormatFetching$.subscribe(x => this.isReportFormatFetching = x);
        this.downloadReportResponse$.subscribe(x => {
            if (x) {
                this.downloadReportResponse = x;
            }
        });
        this.documentDownloadError$.subscribe(error => this.documentDownloadError = error);
    }
    selectedFormats(format, reportType, event) {
        this.downloadReportResponse = '';
        this.downloadReportError = '';
        this.documentDownloadError = '';
        if (this.reportsAndFileFormats && this.reportsAndFileFormats[reportType]) {
            if (event.target.checked) {
                this.reportsAndFileFormats[reportType] = [
                    ...this.reportsAndFileFormats[reportType],
                    format,
                ];
            }
            else {
                const index = this.reportsAndFileFormats[reportType].indexOf(format);
                if (index > -1) {
                    this.reportsAndFileFormats[reportType].splice(index, 1);
                }
            }
        }
        else {
            if (event.target.checked) {
                this.reportsAndFileFormats[reportType] = [format];
            }
        }
    }
    downloadReports() {
        this.downloadReportError = '';
        this.documentDownloadError = '';
        const isNonConsolidated = !(this.downloadFeed.selectedView === 'Consolidated Reports');
        const commonDownloadRequest = {
            billingPeriod: {
                startDate: moment(this.downloadFeed.invoiceStartDate).format('YYYY-MM-DD'),
                endDate: moment(this.downloadFeed.invoiceEndDate).format('YYYY-MM-DD')
            },
            reportsAndFileFormats: this.formatReportsAndFileFormats(this.reportsAndFileFormats),
            planAcronym: this.downloadFeed.planAcronym,
        };
        const clientSubclientObj = {
            clientSpecifiedIdentifier: this.downloadFeed.groupId,
            ...this.downloadFeed.subGroupId && { subClientSpecifiedIdentifier: this.downloadFeed.subGroupId }
        };
        const request = {
            ...commonDownloadRequest,
            ...(isNonConsolidated) ? {
                clientsSubclients: [
                    clientSubclientObj
                ]
            } : {
                consolidatedTo: [
                    clientSubclientObj
                ]
            }
        };
        this.lux.set(state => state.billing, { downloadInvoiceRequest: request });
        this.bAsync.downloadRecords(isNonConsolidated).subscribe(document => {
            if (document && document.deliveryType && (document.format).toLowerCase() === 'pdf' && (document.deliveryType).toLowerCase() === 'sync') {
                this.bAsync.downloadAsyncReport(document.id, document.format).subscribe(res => {
                    this.isFetching = false;
                    this.documentDownloadError$.subscribe(error => this.documentDownloadError = error);
                });
            }
        });
    }
    formatReportsAndFileFormats(reportFormats) {
        const cleanedObj = this.cleanTheEmptyValues(reportFormats);
        return Object.keys(cleanedObj).map((key) => {
            const obj = {
                report: key,
                format: reportFormats[key],
            };
            if (reportFormats[key].length) {
                return obj;
            }
        });
    }
    cleanTheEmptyValues(obj) {
        for (const propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined || !obj[propName].length) {
                delete obj[propName];
            }
        }
        return obj;
    }
    displayOptions(input) {
        this.downloadReportError = '';
        this.formatResponse = [];
        this.invoiceInput = input;
        this.showDialog = true;
    }
    dialogClose(event) {
        this.fileFormatType = '';
        this.formatResponse = [];
        this.reportFormatError = '';
        this.downloadReportError = '';
        this.lux.set(state => state.billing, { downloadInvoiceResponse: initialBillingState.downloadInvoiceResponse });
        this.lux.set(state => state.billing, { invoiceDownloadError: initialBillingState.invoiceDownloadError });
        this.lux.set(state => state.billing, { reportFormatResponse: initialBillingState.reportFormatResponse });
        this.lux.set(state => state.billing, { reportFormatsRequest: initialBillingState.reportFormatsRequest });
        this.downloadDilogClosed.emit(event);
        this.showDialog = false;
        this.openMyReports = false;
    }
    navigateToMyReports(event) {
        this.openMyReports = true;
        this.lux.set(state => state.billing, { isNavigateToMyreports: true });
    }
    reportType(reportType) {
        return reportType.replace(/_/g, ' ');
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function InvoiceDownloadComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InvoiceDownloadComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvoiceDownloadComponent, selectors: [["billing-invoice-download"]], inputs: { loaderImage: "loaderImage", downloadFeed: "downloadFeed" }, outputs: { downloadDilogClosed: "downloadDilogClosed" }, decls: 5, vars: 6, consts: [["maxWidth", "65%", 3, "visibleChange", "visible", "heading"], [4, "ngIf"], ["class", "download-reports-component", 4, "ngIf"], ["class", "avaialable-reports", 4, "ngIf"], [3, "imageSrc"], [1, "error-message"], [1, "download-reports-component"], [1, "download-reports-content"], [1, "download-reports-content", "reports-formats-container"], [1, "download-reports-title"], [4, "ngFor", "ngForOf"], [1, "download-options"], ["rs-raised-button", "", "color", "primary", 3, "click"], [1, "reports"], ["class", "formats", 4, "ngFor", "ngForOf"], [1, "formats"], ["name", "formatsGroup", 3, "change", "label", "value", "id", "checked"], [1, "message"], [3, "click"], [1, "avaialable-reports"], [1, "backToReports", 3, "click"]], template: function InvoiceDownloadComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "rs-dialog", 0);
            i0.ɵɵlistener("visibleChange", function InvoiceDownloadComponent_Template_rs_dialog_visibleChange_0_listener($event) { return ctx.dialogClose($event); });
            i0.ɵɵtemplate(1, InvoiceDownloadComponent_ng_container_1_Template, 2, 1, "ng-container", 1)(2, InvoiceDownloadComponent_ng_container_2_Template, 3, 1, "ng-container", 1)(3, InvoiceDownloadComponent_div_3_Template, 16, 12, "div", 2)(4, InvoiceDownloadComponent_div_4_Template, 4, 0, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("visible", ctx.showDialog)("heading", !ctx.openMyReports ? "Download Invoice" : "Available Reports");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isFetching || ctx.isReportFormatFetching);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.reportFormatError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.invoiceInput && !ctx.openMyReports);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.openMyReports);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i7$1.CheckboxComponent, i5.ButtonComponent, i6.DialogComponent, i7.LoaderComponent, availableReportsComponent, i3$1.DatePipe], styles: [".download-reports-component[_ngcontent-%COMP%]{padding:0 25px}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]{padding:10px 10px 15px}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .download-reports-title[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .download-reports-title[_ngcontent-%COMP%]{border-bottom:1px solid gray;color:#102b52;font-size:1.3em;font-weight:700}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .download-reports-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .download-reports-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{float:right;font-size:16px}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .reports[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .reports[_ngcontent-%COMP%]{width:35%}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:12px}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;width:25%}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after, .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{content:\":\"}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;font-weight:700;font-size:1em}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .download-options[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .download-options[_ngcontent-%COMP%]{text-align:right}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .download-options[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .download-options[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 25px}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px;text-align:left}.download-reports-component[_ngcontent-%COMP%]   .download-reports-content[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .download-reports-component[_ngcontent-%COMP%]   .download-reports-sub-div[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;font-weight:700;color:#06c}.download-reports-component[_ngcontent-%COMP%]   .reports-formats-container[_ngcontent-%COMP%]{margin-bottom:10px;border:1px solid gray}.error-message[_ngcontent-%COMP%]{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px}[_nghost-%COMP%]     .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}.avaialable-reports[_ngcontent-%COMP%]{padding:5px}.avaialable-reports[_ngcontent-%COMP%]   .backToReports[_ngcontent-%COMP%]{display:inline-block;padding:10px 0;font-weight:1000;cursor:pointer;color:#06c}.avaialable-reports[_ngcontent-%COMP%]   .backToReports[_ngcontent-%COMP%]:before{content:\"<<\";color:#06c;padding-right:8px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvoiceDownloadComponent, [{
        type: Component,
        args: [{ selector: 'billing-invoice-download', template: "<rs-dialog maxWidth=\"65%\" [visible]=\"showDialog\" (visibleChange)=\"dialogClose($event)\" [heading]=\" !openMyReports ? 'Download Invoice' : 'Available Reports'\">\n  <ng-container *ngIf=\"(isFetching || isReportFormatFetching)\">\n    <rs-loader imageSrc={{loaderImage}}></rs-loader>\n  </ng-container>\n  <ng-container *ngIf=\"reportFormatError\">\n    <div class=\"error-message\">{{reportFormatError}}</div>\n  </ng-container>\n  <div *ngIf=\"invoiceInput && !openMyReports\" class=\"download-reports-component\">\n    <div class=\"download-reports-content\">\n      <ng-container *ngIf=\"invoiceInput.selectedView === 'Consolidated Reports'\">\n        <div>\n          <label>Parent Subgroup ID</label>\n          <span>{{invoiceInput.subGroupId || ''}}</span>\n        </div>\n        <div>\n          <label>Consolidation Name</label>\n          <span>{{invoiceInput.consolidationName || ''}}</span>\n        </div>\n        <div>\n          <label>Invoice #</label>\n          <span>{{invoiceInput.invoice || ''}}</span>\n        </div>\n        <div>\n          <label>Invoice Type</label>\n          <span>{{invoiceInput.billType || ''}}</span>\n        </div>\n      </ng-container>\n      <ng-container *ngIf=\"(invoiceInput.selectedView === 'Group Reports' || invoiceInput.isFromHistoricalReports)\">\n        <div>\n          <label>Group ID</label>\n          <span>{{invoiceInput.groupId || ''}}</span>\n        </div>\n        <div>\n          <label>Group Name</label>\n          <span>{{invoiceInput.groupName || ''}}</span>\n        </div>\n      </ng-container>\n      <ng-container *ngIf=\"(invoiceInput.selectedView === 'Subgroup Reports' || invoiceInput.isFromHistoricalReports)\">\n        <div>\n          <label>Subgroup ID</label>\n          <span>{{invoiceInput.subGroupId || ''}}</span>\n        </div>\n        <div>\n          <label>Subgroup Name</label>\n          <span>{{invoiceInput.subGroupName || ''}}</span>\n        </div>\n        <div *ngIf=\"(invoiceInput.selectedView === 'Subgroup Reports')\">\n          <label>Invoice #</label>\n          <span>{{invoiceInput.invoice || ''}}</span>\n        </div>\n        <div>\n          <label>Invoice Type</label>\n          <span>{{invoiceInput.billType || ''}}</span>\n        </div>\n      </ng-container>\n      <div>\n        <label>Invoice Date</label>\n        <span>({{(invoiceInput.invoiceStartDate | date: 'MM/dd/yyyy') ||\n          ''}}</span>-<span>{{(invoiceInput.invoiceEndDate | date: 'MM/dd/yyyy') || ''}})</span>\n      </div>\n    </div>\n    <ng-container *ngIf=\"formatResponse &&  formatResponse.length\">\n      <div class=\"download-reports-content reports-formats-container\">\n        <div class=\"download-reports-title\">Please select report types and formats to Download</div>\n        <div *ngFor=\"let reports of formatResponse; let i = index\">\n          <span class=\"reports\"> {{reportType(reports.reportType)}}</span>\n          <span class=\"formats\" *ngFor=\"let format of reports.reportFormats; let j = index\">\n            <rs-checkbox [label]=\"format\" name=\"formatsGroup\" [value]=\"format\"\n              (change)=\"selectedFormats(format , reports.reportType ,$event )\" [id]=\"format + j + i\"\n              [checked]=\"format.checked\">\n            </rs-checkbox>\n          </span>\n        </div>\n      </div>\n      <div class=\"download-reports-content\">\n        <div class=\"download-options\">\n          <span>\n            <button (click)=\"downloadReports()\" rs-raised-button\n              color=\"primary\">DOWNLOAD</button>\n          </span>\n          <ng-container *ngIf=\"downloadReportError\">\n            <div class=\"message\">{{downloadReportError}}</div>\n          </ng-container>\n          <ng-container *ngIf=\"documentDownloadError\">\n            <div class=\"message\">{{documentDownloadError}}</div>\n          </ng-container>\n          <ng-container\n            *ngIf=\"downloadReportResponse && downloadReportResponse.deliveryType.toLowerCase() ==='async'\">\n            <div class=\"message\">Reports will be available under My Reports in the Billing section. Click here for <a (click)=\"navigateToMyReports($event)\"> Available reports </a> quick view</div>\n          </ng-container>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n  <div class = \"avaialable-reports\" *ngIf=\"openMyReports\">\n   <a class=\"backToReports\" (click)=\"openMyReports = false\">Back To Download Invoice</a>\n    <billing-available-reports></billing-available-reports>\n  </div>\n</rs-dialog>\n", styles: [".download-reports-component{padding:0 25px}.download-reports-component .download-reports-content,.download-reports-component .download-reports-sub-div{padding:10px 10px 15px}.download-reports-component .download-reports-content .download-reports-title,.download-reports-component .download-reports-sub-div .download-reports-title{border-bottom:1px solid gray;color:#102b52;font-size:1.3em;font-weight:700}.download-reports-component .download-reports-content .download-reports-title span,.download-reports-component .download-reports-sub-div .download-reports-title span{float:right;font-size:16px}.download-reports-component .download-reports-content .reports,.download-reports-component .download-reports-sub-div .reports{width:35%}.download-reports-component .download-reports-content div,.download-reports-component .download-reports-sub-div div{padding:12px}.download-reports-component .download-reports-content div label,.download-reports-component .download-reports-sub-div div label{display:inline-block;width:25%}.download-reports-component .download-reports-content div label:after,.download-reports-component .download-reports-sub-div div label:after{content:\":\"}.download-reports-component .download-reports-content div span,.download-reports-component .download-reports-sub-div div span{display:inline-block;font-weight:700;font-size:1em}.download-reports-component .download-reports-content .download-options,.download-reports-component .download-reports-sub-div .download-options{text-align:right}.download-reports-component .download-reports-content .download-options span,.download-reports-component .download-reports-sub-div .download-options span{padding:0 25px}.download-reports-component .download-reports-content .message,.download-reports-component .download-reports-sub-div .message{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px;text-align:left}.download-reports-component .download-reports-content .message a,.download-reports-component .download-reports-sub-div .message a{cursor:pointer;font-weight:700;color:#06c}.download-reports-component .reports-formats-container{margin-bottom:10px;border:1px solid gray}.error-message{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px}:host ::ng-deep .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}.avaialable-reports{padding:5px}.avaialable-reports .backToReports{display:inline-block;padding:10px 0;font-weight:1000;cursor:pointer;color:#06c}.avaialable-reports .backToReports:before{content:\"<<\";color:#06c;padding-right:8px}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }], { downloadDilogClosed: [{
            type: Output
        }], loaderImage: [{
            type: Input
        }], downloadFeed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(InvoiceDownloadComponent, { className: "InvoiceDownloadComponent", filePath: "lib/billing/invoice-download/invoice-download.component.ts", lineNumber: 15 }); })();

const _c0 = (a0, a1, a2, a3) => ({ consolidation: a0, index: a1, type: a2, expandRowIndex: a3 });
function ReportsComponent_ng_container_1_p_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Reports will be available under My Reports in the Billing section. Click here for ");
    i0.ɵɵelementStart(2, "a", 14);
    i0.ɵɵlistener("keydown.enter", function ReportsComponent_ng_container_1_p_2_Template_a_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.openMyReports = true); })("click", function ReportsComponent_ng_container_1_p_2_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.openMyReports = true); });
    i0.ɵɵtext(3, " Available reports ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " quick view");
    i0.ɵɵelementEnd();
} }
function ReportsComponent_ng_container_1_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.documentDownloadError || ctx_r2.invoiceDownloadError);
} }
function ReportsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, ReportsComponent_ng_container_1_p_2_Template, 5, 0, "p", 5)(3, ReportsComponent_ng_container_1_p_3_Template, 2, 1, "p", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isReportReadyForDownload);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.documentDownloadError || ctx_r2.invoiceDownloadError);
} }
function ReportsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r2.loaderImage);
} }
function ReportsComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Consolidation Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Consolidation Invoices");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Parent Subgroup");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function ReportsComponent_tbody_14_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ReportsComponent_tbody_14_ng_container_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 19)(1, "td", 20)(2, "billing-invoice", 21);
    i0.ɵɵlistener("invoiceDetails", function ReportsComponent_tbody_14_ng_container_1_tr_3_Template_billing_invoice_invoiceDetails_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openDownloadOptions($event)); })("emitInvoiceActivity", function ReportsComponent_tbody_14_ng_container_1_tr_3_Template_billing_invoice_emitInvoiceActivity_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openInvoiceActivity($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("feed", ctx_r2.invoiceFeed)("loaderImage", ctx_r2.loaderImage);
} }
function ReportsComponent_tbody_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr", 14);
    i0.ɵɵlistener("keydown.enter", function ReportsComponent_tbody_14_ng_container_1_Template_tr_keydown_enter_1_listener() { const ctx_r4 = i0.ɵɵrestoreView(_r4); const consolidation_r6 = ctx_r4.$implicit; const i_r7 = ctx_r4.index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.consolidatedInvoiceFeature ? ctx_r2.getInvoices(consolidation_r6, i_r7 + 1) : false); })("click", function ReportsComponent_tbody_14_ng_container_1_Template_tr_click_1_listener() { const ctx_r7 = i0.ɵɵrestoreView(_r4); const consolidation_r6 = ctx_r7.$implicit; const i_r7 = ctx_r7.index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.consolidatedInvoiceFeature ? ctx_r2.getInvoices(consolidation_r6, i_r7 + 1) : false); });
    i0.ɵɵtemplate(2, ReportsComponent_tbody_14_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ReportsComponent_tbody_14_ng_container_1_tr_3_Template, 3, 2, "tr", 18);
    i0.ɵɵpipe(4, "keyvalue");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    let tmp_10_0;
    const consolidation_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const summary_r10 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", summary_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction4(5, _c0, consolidation_r6, i_r7, ctx_r2.feed.selectedView, ctx_r2.expandRowIndex));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ((tmp_10_0 = i0.ɵɵpipeBind1(4, 3, ctx_r2.invoiceFeed)) == null ? null : tmp_10_0.length) && i_r7 === ctx_r2.expandRowIndex - 1 && ctx_r2.consolidatedInvoiceFeature);
} }
function ReportsComponent_tbody_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, ReportsComponent_tbody_14_ng_container_1_Template, 5, 10, "ng-container", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.consolidatedRes);
} }
function ReportsComponent_tbody_15_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ReportsComponent_tbody_15_ng_container_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 19)(1, "td", 20)(2, "billing-invoice", 21);
    i0.ɵɵlistener("invoiceDetails", function ReportsComponent_tbody_15_ng_container_1_tr_3_Template_billing_invoice_invoiceDetails_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openDownloadOptions($event)); })("emitInvoiceActivity", function ReportsComponent_tbody_15_ng_container_1_tr_3_Template_billing_invoice_emitInvoiceActivity_2_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.openInvoiceActivity($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("feed", ctx_r2.invoiceFeed)("loaderImage", ctx_r2.loaderImage);
} }
function ReportsComponent_tbody_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr", 14);
    i0.ɵɵlistener("keydown.enter", function ReportsComponent_tbody_15_ng_container_1_Template_tr_keydown_enter_1_listener() { const ctx_r11 = i0.ɵɵrestoreView(_r11); const consolidation_r13 = ctx_r11.$implicit; const i_r14 = ctx_r11.index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.feed.selectedView === "Subgroup Reports" && ctx_r2.nonConsolidatedInvoiceFeature ? ctx_r2.getInvoices(consolidation_r13, i_r14 + 1) : false); })("click", function ReportsComponent_tbody_15_ng_container_1_Template_tr_click_1_listener() { const ctx_r14 = i0.ɵɵrestoreView(_r11); const consolidation_r13 = ctx_r14.$implicit; const i_r14 = ctx_r14.index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.feed.selectedView === "Subgroup Reports" && ctx_r2.nonConsolidatedInvoiceFeature ? ctx_r2.getInvoices(consolidation_r13, i_r14 + 1) : false); });
    i0.ɵɵtemplate(2, ReportsComponent_tbody_15_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ReportsComponent_tbody_15_ng_container_1_tr_3_Template, 3, 2, "tr", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const consolidation_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    const summary_r10 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", summary_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c0, consolidation_r13, i_r14, ctx_r2.feed.selectedView, ctx_r2.expandRowIndex));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.invoiceFeed && i_r14 === ctx_r2.expandRowIndex - 1 && ctx_r2.nonConsolidatedInvoiceFeature);
} }
function ReportsComponent_tbody_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, ReportsComponent_tbody_15_ng_container_1_Template, 4, 8, "ng-container", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.nonConsolidatedRes);
} }
function ReportsComponent_ng_template_16_label_1__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 26);
    i0.ɵɵelement(1, "path", 27)(2, "path", 28);
    i0.ɵɵelementEnd();
} }
function ReportsComponent_ng_template_16_label_1__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 29);
    i0.ɵɵelement(1, "path", 27)(2, "path", 30);
    i0.ɵɵelementEnd();
} }
function ReportsComponent_ng_template_16_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtemplate(1, ReportsComponent_ng_template_16_label_1__svg_svg_1_Template, 3, 0, "svg", 24)(2, ReportsComponent_ng_template_16_label_1__svg_svg_2_Template, 3, 0, "svg", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const index_r18 = ctx_r16.index;
    const expandRowIndex_r19 = ctx_r16.expandRowIndex;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(index_r18 === expandRowIndex_r19 - 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", index_r18 === expandRowIndex_r19 - 1);
} }
function ReportsComponent_ng_template_16_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "a", 31);
    i0.ɵɵlistener("keydown.enter", function ReportsComponent_ng_template_16_span_2_Template_a_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r20); const consolidation_r21 = i0.ɵɵnextContext().consolidation; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openDownloadOptions(consolidation_r21, $event)); })("click", function ReportsComponent_ng_template_16_span_2_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r20); const consolidation_r21 = i0.ɵɵnextContext().consolidation; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openDownloadOptions(consolidation_r21, $event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 32);
    i0.ɵɵlistener("click", function ReportsComponent_ng_template_16_span_2_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r20); const consolidation_r21 = i0.ɵɵnextContext().consolidation; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.downloadStandardandInvoiceReports(consolidation_r21)); });
    i0.ɵɵelementStart(4, "span", 33);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 34);
    i0.ɵɵlistener("keydown.enter", function ReportsComponent_ng_template_16_span_2_Template_svg_keydown_enter_5_listener() { i0.ɵɵrestoreView(_r20); const consolidation_r21 = i0.ɵɵnextContext().consolidation; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.downloadStandardandInvoiceReports(consolidation_r21)); });
    i0.ɵɵelement(6, "path", 35)(7, "path", 36);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const consolidation_r21 = i0.ɵɵnextContext().consolidation;
    i0.ɵɵnextContext();
    const AdminTooltip_r22 = i0.ɵɵreference(23);
    const clamsTooltip_r23 = i0.ɵɵreference(28);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(consolidation_r21.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rsTooltipTrigger", consolidation_r21.name === "Claims" ? clamsTooltip_r23 : AdminTooltip_r22);
} }
function ReportsComponent_ng_template_16_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const consolidation_r21 = ctx_r16.consolidation;
    const type_r24 = ctx_r16.type;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(type_r24 === "Consolidated Reports" ? consolidation_r21.consolidationName : consolidation_r21.name);
} }
function ReportsComponent_ng_template_16_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const consolidation_r21 = i0.ɵɵnextContext().consolidation;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", consolidation_r21 && consolidation_r21.subClientSpecifiedIdentifier, " ");
} }
function ReportsComponent_ng_template_16_td_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const consolidation_r21 = i0.ɵɵnextContext().consolidation;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(consolidation_r21 && consolidation_r21.consolidation && consolidation_r21.consolidation.subClientSpecifiedIdentifier ? consolidation_r21.consolidation.subClientSpecifiedIdentifier : "");
} }
function ReportsComponent_ng_template_16_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const consolidation_r21 = i0.ɵɵnextContext().consolidation;
    i0.ɵɵclassProp("inactive-indicator", consolidation_r21.status === "Inactive");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(consolidation_r21.status);
} }
function ReportsComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 22);
    i0.ɵɵtemplate(1, ReportsComponent_ng_template_16_label_1_Template, 3, 2, "label", 5)(2, ReportsComponent_ng_template_16_span_2_Template, 8, 2, "span", 5)(3, ReportsComponent_ng_template_16_span_3_Template, 2, 1, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ReportsComponent_ng_template_16_td_4_Template, 2, 1, "td", 5);
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ReportsComponent_ng_template_16_td_7_Template, 2, 1, "td", 5);
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtemplate(15, ReportsComponent_ng_template_16_span_15_Template, 2, 3, "span", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const consolidation_r21 = ctx.consolidation;
    const type_r24 = ctx.type;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r24 !== "Group Reports");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r24 === "Group Reports");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(type_r24 === "Group Reports"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r24 === "Subgroup Reports");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(consolidation_r21.totalInvoiceCount || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !type_r24 || type_r24 === "Consolidated Reports");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(10, 9, consolidation_r21.startDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 12, consolidation_r21.endDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", consolidation_r21.status);
} }
function ReportsComponent_ng_template_18_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "Subgroup ID");
    i0.ɵɵelementEnd();
} }
function ReportsComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, " Name");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ReportsComponent_ng_template_18_th_2_Template, 2, 0, "th", 5);
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Invoices");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.feed.selectedView === "Subgroup Reports");
} }
function ReportsComponent_div_33_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.invoiceActivityError);
} }
function ReportsComponent_div_33_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r2.loaderImage);
} }
function ReportsComponent_div_33_ng_container_33_tr_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r26 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.clientSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.subclientSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.subclientName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.invoiceNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.activityType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r26.paymentId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 7, item_r26.paymentAmount));
} }
function ReportsComponent_div_33_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "h4");
    i0.ɵɵtext(3, "Invoice Activity");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "table")(5, "thead")(6, "tr")(7, "th");
    i0.ɵɵtext(8, "Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Sub Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Sub Group Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Activity Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Payment ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20, "Amount");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(21, "tbody");
    i0.ɵɵtemplate(22, ReportsComponent_div_33_ng_container_33_tr_22_Template, 16, 9, "tr", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(22);
    i0.ɵɵproperty("ngForOf", ctx_r2.invoiceActivityResponse.invoiceActivity);
} }
function ReportsComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, ReportsComponent_div_33_ng_container_1_Template, 3, 1, "ng-container", 5)(2, ReportsComponent_div_33_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementStart(3, "div", 39)(4, "div")(5, "label");
    i0.ɵɵtext(6, "Invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div")(10, "label");
    i0.ɵɵtext(11, "Invoice Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "currency");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div")(16, "label");
    i0.ɵɵtext(17, "Invoice Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div")(22, "label");
    i0.ɵɵtext(23, "Invoice End Date:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "span");
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(27, "div")(28, "label");
    i0.ɵɵtext(29, "Payment Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "span");
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(32, "div", 6);
    i0.ɵɵtemplate(33, ReportsComponent_div_33_ng_container_33_Template, 23, 1, "ng-container", 5);
    i0.ɵɵelementStart(34, "div", 40)(35, "rs-paginator", 9);
    i0.ɵɵlistener("page", function ReportsComponent_div_33_Template_rs_paginator_page_35_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.activityPageChanged($event)); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.invoiceActivityError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isFetchingInvoiceActivity);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.invoiceActivityResponse && (ctx_r2.invoiceActivityResponse.invoiceNumber || ""));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 10, ctx_r2.invoiceActivityResponse && ctx_r2.invoiceActivityResponse.invoiceAmount) || "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.invoiceActivityResponse && i0.ɵɵpipeBind2(20, 12, ctx_r2.invoiceActivityResponse.invoiceStartDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.invoiceActivityResponse && i0.ɵɵpipeBind2(26, 15, ctx_r2.invoiceActivityResponse.invoiceEndDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r2.invoiceActivityResponse && (ctx_r2.invoiceActivityResponse.invoiceStatus === "C" ? "Closed" : "Open") || "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.invoiceActivityResponse && ctx_r2.invoiceActivityResponse.invoiceActivity && ctx_r2.invoiceActivityResponse.invoiceActivity.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("length", ctx_r2.invoiceActivityResponse && ctx_r2.invoiceActivityResponse.pagination && ctx_r2.invoiceActivityResponse.pagination.totalRecords)("pageSize", ctx_r2.defaultPageSize);
} }
function ReportsComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "billing-available-reports");
    i0.ɵɵelementEnd();
} }
function ReportsComponent_ng_container_35_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-invoice-download", 43);
    i0.ɵɵlistener("downloadDilogClosed", function ReportsComponent_ng_container_35_Template_billing_invoice_download_downloadDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.downloadDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("downloadFeed", ctx_r2.invoiceDownloadInput)("loaderImage", ctx_r2.loaderImage);
} }
class ReportsComponent {
    get feed() {
        return this._feed;
    }
    set feed(val) {
        this._feed = val;
        val && this.loadComponent();
    }
    get billingFeatures() {
        return this._billingFeatures;
    }
    set billingFeatures(val) {
        if (val) {
            this._billingFeatures = val;
        }
    }
    constructor(lux, bAsync) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.openOptionsforRow = 0;
        this.currentPage = 1;
        this.defaultPageSize = 10;
        this.selectedIndex = 0;
        this.isReportReadyForDownload = false;
        this.luxId = 'billing-lib-common-reports-comp' + this.constructor.name;
        this.consolidatedRes$ = this.lux.get(consolidatedResponse, this.luxId);
        this.nonConsolidatedRes$ = this.lux.get(nonConsolidatedResponse, this.luxId);
        this.invoiceActivityResponse$ = this.lux.get(invoiceActivityResponse, this.luxId);
        this.isFetchingInvoiceActivity$ = this.lux.get(isFetchingInvoiceActivity, this.luxId);
        this.invoiceActivityError$ = this.lux.get(invoiceActivityError, this.luxId);
        this.errorMsg$ = this.lux.get(error, this.luxId);
        this.isFetching$ = this.lux.get(isFetchingData, this.luxId);
        this.isFetchingDownloadReports$ = this.lux.get(isFetchingDownload, this.luxId);
        this.documentDownloadError$ = this.lux.get(documentDownloadError, this.luxId);
        this.invoiceDownloadError$ = this.lux.get(invoiceDownloaderrorMessage, this.luxId);
    }
    ngOnInit() {
        this.loadComponent();
        this.consolidatedInvoiceFeature = this.billingFeatures && this.billingFeatures.includes('consolidatedInvoice');
        this.nonConsolidatedInvoiceFeature = this.billingFeatures && this.billingFeatures.includes('nonConsolidatedInvoice');
    }
    loadComponent() {
        this.expandRowIndex = 0;
        this.consolidatedRes$.subscribe(response => {
            this.consolidatedRes = response?.consolidatedSummary;
            if (this.consolidatedRes && this.consolidatedRes.length === 1) {
                this.getInvoices(this.consolidatedRes[0], 1);
                this.expandRowIndex = 1;
            }
            this.consTotalRecords = response?.pagination.totalRecords;
        });
        this.nonConsolidatedRes$.subscribe(response => {
            this.nonConsolidatedRes = response.nonConsolidatedSummary;
            this.nonConsTotalRecords = response.pagination.totalRecords;
        });
        this.isFetching$.subscribe(x => this.isFetching = x);
        this.errorMsg$.subscribe(x => this.errorMsg = x);
        this.invoiceActivityResponse$.subscribe(response => this.invoiceActivityResponse = response.invoiceActivityDetails);
        this.invoiceActivityError$.subscribe(error => this.invoiceActivityError = error);
        this.isFetchingInvoiceActivity$.subscribe(isFetching => this.isFetchingInvoiceActivity = isFetching);
        this.isFetchingDownloadReports$.subscribe(fetching => this.isFetchingDownloadReports = fetching);
        this.documentDownloadError$.subscribe(error => this.documentDownloadError = error);
        this.invoiceDownloadError$.subscribe(error => this.invoiceDownloadError = error);
    }
    getInvoices(item, index) {
        if (!(this.feed.selectedView === 'Group Reports')) {
            this.expandRowIndex = index === this.expandRowIndex ? 0 : index;
            this.invoiceFeed = {
                consolidationName: item.consolidationName ? item.consolidationName : '',
                groupId: (this.feed.selectedView === 'Subgroup Reports') ? this.feed.groupId : item.consolidation.clientSpecifiedIdentifier,
                subGroupId: (this.feed.selectedView === 'Subgroup Reports') ? item.subClientSpecifiedIdentifier : item.consolidation && item.consolidation.subClientSpecifiedIdentifier ? item.consolidation.subClientSpecifiedIdentifier : '',
                sDate: item.startDate ? item.startDate : '',
                eDate: item.endDate ? item.endDate : '',
                plan: this.feed.planAcronym,
                subGroupName: item.name,
                isNonConsolidated: (this.feed.selectedView === 'Subgroup Reports') ? true : false
            };
        }
    }
    openDownloadOptions(item, event) {
        this.resetDownloadReportsState();
        if (event) {
            event.stopPropagation();
        }
        const isnonConsolidated = !(this.feed.selectedView === 'Consolidated Reports');
        const request = !item.name ? [{
                planAcronym: item.plan,
                ...(isnonConsolidated) ? { clientsSubclients: {
                        clientSpecifiedIdentifier: item.groupId,
                        subClientSpecifiedIdentifier: item.subGroupId
                    } } : {
                    consolidatedTo: {
                        clientSpecifiedIdentifier: item.groupId,
                        subClientSpecifiedIdentifier: item.subGroupId,
                    }
                },
                billType: item.billType === 'Claims' ? 'CLAIMS' : 'ADMIN',
                startDate: moment(item.startDate).format('YYYY-MM-DD'),
                endDate: moment(item.endDate).format('YYYY-MM-DD')
            }] :
            [{
                    planAcronym: this.feed.planAcronym,
                    clientsSubclients: {
                        clientSpecifiedIdentifier: this.feed.groupId,
                        subClientSpecifiedIdentifier: this.feed.subGroupId
                    },
                    billType: item.name === 'Claims' ? 'CLAIMS' : 'ADMIN',
                    startDate: moment(item.startDate).format('YYYY-MM-DD'),
                    endDate: moment(item.endDate).format('YYYY-MM-DD')
                }];
        this.lux.set(state => state.billing, { reportFormatsRequest: request });
        this.bAsync.getBillingReportsTypesAndFormats(isnonConsolidated).subscribe();
        this.invoiceDownloadInput = {
            ...this.feed,
            consolidationName: item.consolidationName ? item.consolidationName : '',
            invoice: item.consolidatedInvoiceNumber ? item.consolidatedInvoiceNumber : item.invoiceNumber,
            invoiceType: item.billType ? item.billType : item.name,
            invoiceStartDate: item.startDate,
            invoiceEndDate: item.endDate,
            subGroupId: item.subGroupId,
            subGroupName: item.subGroupName,
            billType: item.invoiceType ? item.invoiceType : item.billType,
        };
        this.openOptionsforRow = 0;
    }
    downloadDilogClosed(event) {
        this.lux.set(state => state.billing, { isNavigateToMyreports: false });
        this.invoiceDownloadInput = {};
    }
    pageChanged(page) {
        this.resetDownloadReportsState();
        this.getMoreRecords(page.pageIndex >= 1 ? (page.pageIndex * this.defaultPageSize) : 0);
    }
    getMoreRecords(offset) {
        this.expandRowIndex = 0;
        this.lux.set(state => state.billing.BillingComponentCriteria.pagination, { offset });
        if (this.feed.selectedView === 'Consolidated Reports') {
            this.bAsync.getConsolidatedSummaryReports().subscribe();
        }
        else {
            this.bAsync.getNonConsolidatedSummaryReports(this.feed.selectedView).subscribe();
        }
    }
    openInvoiceActivity(data) {
        this.isConsolidated = !!(this.feed.selectedView === 'Consolidated Reports');
        const request = {
            planAcronym: data.plan,
            invoiceNumber: this.isConsolidated ? data.consolidatedInvoiceNumber : data.invoiceNumber,
            offset: 0,
            limit: 10,
        };
        this.lux.set((state) => state.billing, { invoiceActivityRequest: request });
        this.lux.set((state) => state.billing, { invoiceActivityError: '' });
        this.bAsync.getInvoiceActivity(this.isConsolidated).subscribe();
        this.showInvoiceActivities = true;
    }
    activityPageChanged(page) {
        this.getMoreActivityRecords(page.pageIndex >= 1 ? (page.pageIndex * this.defaultPageSize) + 1 : 0);
    }
    getMoreActivityRecords(offset) {
        this.lux.set((state) => state.billing.invoiceActivityRequest, {
            offset,
        });
        this.bAsync.getInvoiceActivity(this.isConsolidated).subscribe();
    }
    downloadStandardandInvoiceReports(item) {
        this.resetDownloadReportsState();
        const AdminReports = [{ report: 'STANDARD_BILLING_REPORT', format: ['XLS'] }, { report: 'INVOICE', format: ['PDF'] }];
        const ClaimsReport = [{ report: 'CLAIMS_INVOICE', format: ['PDF'] }, { report: 'CLAIMS_DETAIL', format: ['XLS'] }];
        const commonDownloadRequest = {
            billingPeriod: {
                startDate: moment(item.startDate).format('YYYY-MM-DD'),
                endDate: moment(item.endDate).format('YYYY-MM-DD')
            },
            reportsAndFileFormats: item.name === 'Claims' ? ClaimsReport : AdminReports,
            planAcronym: this.feed.planAcronym,
        };
        const clientSubclientObj = {
            clientSpecifiedIdentifier: this.feed.groupId,
            ...this.feed.subGroupId && { subClientSpecifiedIdentifier: this.feed.subGroupId }
        };
        const request = {
            ...commonDownloadRequest,
            clientsSubclients: [
                clientSubclientObj
            ]
        };
        this.lux.set(state => state.billing, { downloadInvoiceRequest: request });
        this.bAsync.downloadRecords(true).subscribe(document => {
            this.isReportReadyForDownload = document && document.deliveryType;
            // if (!this.isReportReadyForDownload ) {
            //     this.bAsync.downloadAsyncReport(document.id, document.format).subscribe(res => {
            //         this.isFetching = false;
            //         this.documentDownloadError$.subscribe(error => this.documentDownloadError = error);
            //     })
            // }
        });
    }
    dialogClose(event) {
        this.openMyReports = false;
        this.showInvoiceActivities = false;
    }
    resetDownloadReportsState() {
        this.isReportReadyForDownload = false;
        this.lux.set(state => state.billing, { documentDownloadError: '', invoiceDownloadError: '', downloadInvoiceResponse: initialBillingState.downloadInvoiceResponse });
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function ReportsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportsComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportsComponent, selectors: [["billing-common-reports"]], inputs: { feed: "feed", billingFeatures: "billingFeatures" }, decls: 37, vars: 15, consts: [["summary", ""], ["nonconsolidated", ""], ["AdminTooltip", ""], ["clamsTooltip", ""], [1, "consolidated-reports"], [4, "ngIf"], [1, "search-results-content"], [4, "ngIf", "ngIfElse"], [1, "billing-pagination"], ["showFirstLastButtons", "", 3, "page", "length", "pageSize"], ["maxWidth", "55%", 3, "visibleChange", "visible", "heading"], ["class", "invoice-activity", 4, "ngIf"], ["class", "avaialable-reports", 4, "ngIf"], [1, "message"], ["role", "button", "tabindex", "0", 3, "keydown.enter", "click"], [3, "imageSrc"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "child-component", 4, "ngIf"], [1, "child-component"], ["colspan", "6"], [3, "invoiceDetails", "emitInvoiceActivity", "feed", "loaderImage"], [1, "name"], ["class", "active-indicator", 3, "inactive-indicator", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "height", "24", "verticalviewBox", "0 0 24 24", "width", "24", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "height", "24", "viewBox", "0 0 24 24", "width", "24", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "height", "24", "verticalviewBox", "0 0 24 24", "width", "24"], ["d", "M0 0h24v24H0z", "fill", "none"], ["d", "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"], ["xmlns", "http://www.w3.org/2000/svg", "height", "24", "viewBox", "0 0 24 24", "width", "24"], ["d", "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"], ["role", "button", "tabindex", "0", 1, "invoice-number", 3, "keydown.enter", "click"], [1, "standard-reports", 3, "click", "rsTooltipTrigger"], ["role", "button", 1, "svg-holder"], ["alt", "Get Report", "role", "button", "tabindex", "0", "viewBox", "0 0 20 20", 1, "svg-icon", 3, "keydown.enter"], ["fill", "none", "d", "M9.634,10.633c0.116,0.113,0.265,0.168,0.414,0.168c0.153,0,0.308-0.06,0.422-0.177l4.015-4.111c0.229-0.235,0.225-0.608-0.009-0.836c-0.232-0.229-0.606-0.222-0.836,0.009l-3.604,3.689L6.35,5.772C6.115,5.543,5.744,5.55,5.514,5.781C5.285,6.015,5.29,6.39,5.522,6.617L9.634,10.633z"], ["fill", "none", "d", "M17.737,9.815c-0.327,0-0.592,0.265-0.592,0.591v2.903H2.855v-2.903c0-0.327-0.264-0.591-0.591-0.591c-0.327,0-0.591,0.265-0.591,0.591V13.9c0,0.328,0.264,0.592,0.591,0.592h15.473c0.327,0,0.591-0.264,0.591-0.592v-3.494C18.328,10.08,18.064,9.815,17.737,9.815z"], [1, "active-indicator"], [1, "invoice-activity"], [1, "invoice-activity-content"], [1, "activity-pagination"], [1, "invoice-error"], [1, "avaialable-reports"], [3, "downloadDilogClosed", "downloadFeed", "loaderImage"]], template: function ReportsComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 4);
            i0.ɵɵtemplate(1, ReportsComponent_ng_container_1_Template, 4, 2, "ng-container", 5)(2, ReportsComponent_ng_container_2_Template, 2, 1, "ng-container", 5);
            i0.ɵɵelementStart(3, "div", 6)(4, "table")(5, "thead")(6, "tr");
            i0.ɵɵtemplate(7, ReportsComponent_ng_container_7_Template, 7, 0, "ng-container", 7);
            i0.ɵɵelementStart(8, "th");
            i0.ɵɵtext(9, "Start Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "th");
            i0.ɵɵtext(11, "End Date");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "th");
            i0.ɵɵtext(13, "Status");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(14, ReportsComponent_tbody_14_Template, 2, 1, "tbody", 5)(15, ReportsComponent_tbody_15_Template, 2, 1, "tbody", 5)(16, ReportsComponent_ng_template_16_Template, 16, 15, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(18, ReportsComponent_ng_template_18_Template, 5, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 8)(21, "rs-paginator", 9);
            i0.ɵɵlistener("page", function ReportsComponent_Template_rs_paginator_page_21_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.pageChanged($event)); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "rs-tooltip", null, 2)(24, "div");
            i0.ɵɵtext(25, "Standard Billing Report and Invoice fast download");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(26, "> ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "rs-tooltip", null, 3)(29, "div");
            i0.ɵɵtext(30, "Claims fast download");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(31, "> ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "rs-dialog", 10);
            i0.ɵɵlistener("visibleChange", function ReportsComponent_Template_rs_dialog_visibleChange_32_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dialogClose($event)); });
            i0.ɵɵtemplate(33, ReportsComponent_div_33_Template, 36, 18, "div", 11)(34, ReportsComponent_div_34_Template, 2, 0, "div", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(35, ReportsComponent_ng_container_35_Template, 2, 2, "ng-container", 5);
            i0.ɵɵpipe(36, "keyvalue");
        } if (rf & 2) {
            let tmp_16_0;
            const nonconsolidated_r28 = i0.ɵɵreference(19);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isReportReadyForDownload || ctx.documentDownloadError || ctx.invoiceDownloadError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isFetchingDownloadReports);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", !ctx.feed.selectedView || ctx.feed.selectedView === "Consolidated Reports")("ngIfElse", nonconsolidated_r28);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", ctx.consolidatedRes && ctx.consolidatedRes.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.nonConsolidatedRes && ctx.nonConsolidatedRes.length);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("length", !(ctx.feed.selectedView === "Consolidated Reports") ? ctx.nonConsTotalRecords : ctx.consTotalRecords)("pageSize", ctx.defaultPageSize);
            i0.ɵɵadvance(11);
            i0.ɵɵproperty("visible", ctx.showInvoiceActivities || ctx.openMyReports)("heading", !ctx.openMyReports ? "Invoice Activity" : "Available Reports");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showInvoiceActivities);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.openMyReports);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_16_0 = i0.ɵɵpipeBind1(36, 13, ctx.invoiceDownloadInput)) == null ? null : tmp_16_0.length);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i3$1.NgTemplateOutlet, i4.PaginatorComponent, i5$1.TooltipComponent, i5$1.TooltipDirective, i6.DialogComponent, i7.LoaderComponent, availableReportsComponent, InvoiceComponent, InvoiceDownloadComponent, i3$1.CurrencyPipe, i3$1.DatePipe, i3$1.KeyValuePipe], styles: [".consolidated-reports[_ngcontent-%COMP%]{padding:0 30px}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 5px;width:100px}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{vertical-align:middle}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{width:150px}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #c2c2c2;border-collapse:collapse;width:100%}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#06c;font-weight:700;cursor:pointer}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .child-component[_ngcontent-%COMP%]{background-color:#fff!important}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-pagination[_ngcontent-%COMP%]{padding:20px}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .active-indicator[_ngcontent-%COMP%]{background-color:#41a929;padding:5px;border-radius:3px;color:#fff;text-transform:capitalize}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .inactive-indicator[_ngcontent-%COMP%]{background-color:#d3d3d3}.consolidated-reports[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .billing-pagination[_ngcontent-%COMP%]{margin:2px 0 0 30px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity[_ngcontent-%COMP%]{padding:0 16px 0 29px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid red;margin:10px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]{padding:10px 10px 15px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:5px 0}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;width:18%}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{content:\":\"}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;font-weight:700;font-size:1em;margin-right:5px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-of-type{margin-left:5px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-number[_ngcontent-%COMP%]{display:inline-block;width:25%;padding-left:5px}.consolidated-reports[_ngcontent-%COMP%]   .invoice-number[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.consolidated-reports[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto}.consolidated-reports[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{padding:10px;width:max-content}.consolidated-reports[_ngcontent-%COMP%]   .payment[_ngcontent-%COMP%]{border-bottom:1px solid #636870}.consolidated-reports[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]:hover{background-color:#eb8510}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .message[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:1px solid red;padding:10px;color:red}.message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#06c;cursor:pointer}.svg-holder[_ngcontent-%COMP%]{display:inline-block;width:30px;height:30px;top:8px;position:relative;left:10px}.svg-icon[_ngcontent-%COMP%]{width:100%;height:100%}.svg-icon[_ngcontent-%COMP%]   path[_ngcontent-%COMP%], .svg-icon[_ngcontent-%COMP%]   polygon[_ngcontent-%COMP%], .svg-icon[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:#4691f6}.svg-icon[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.svg-icon[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#4691f6;stroke-width:1}.standard-reports[_ngcontent-%COMP%]{padding-left:20px;cursor:pointer}.avaialable-reports[_ngcontent-%COMP%]{padding:5px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportsComponent, [{
        type: Component,
        args: [{ selector: 'billing-common-reports', template: "<div class=\"consolidated-reports\">\n    <ng-container *ngIf=\"(isReportReadyForDownload || documentDownloadError || invoiceDownloadError)\">\n        <div class=\"message\">\n            <p *ngIf=\"isReportReadyForDownload\">Reports will be available under My Reports in the Billing section. Click here for\n                <a role=\"button\" tabindex=\"0\" (keydown.enter)=\"openMyReports = true\" (click)=\"openMyReports = true\"> Available reports </a> quick view</p>\n            <p *ngIf=\"(documentDownloadError || invoiceDownloadError)\">{{ documentDownloadError || invoiceDownloadError}}</p>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"(isFetchingDownloadReports)\"><rs-loader imageSrc={{loaderImage}}></rs-loader></ng-container>\n    <div class=\"search-results-content\">\n        <table>\n            <thead>\n            <tr>\n                <ng-container\n                        *ngIf=\"!feed.selectedView || feed.selectedView ==='Consolidated Reports'; else nonconsolidated\">\n                    <th>Consolidation Name</th>\n                    <th>Consolidation Invoices</th>\n                    <th>Parent Subgroup</th>\n                </ng-container>\n                <th>Start Date</th>\n                <th>End Date</th>\n                <th>Status</th>\n            </thead>\n            <!-- Consolidated Response -->\n            <tbody *ngIf=\"consolidatedRes && consolidatedRes.length\">\n            <ng-container *ngFor=\"let consolidation of consolidatedRes; let i = index\">\n                <tr role=\"button\" tabindex=\"0\" (keydown.enter)=\"consolidatedInvoiceFeature ?  getInvoices(consolidation, i+1) : false\" (click)=\"consolidatedInvoiceFeature ?  getInvoices(consolidation, i+1) : false\">\n                    <ng-container\n                            *ngTemplateOutlet=\"summary; context:{consolidation: consolidation, index:i, type:feed.selectedView , expandRowIndex: expandRowIndex}\">\n                    </ng-container>\n                </tr>\n                <tr class=\"child-component\" *ngIf=\"(invoiceFeed| keyvalue)?.length &&  (i === expandRowIndex-1) && consolidatedInvoiceFeature\">\n                    <td colspan=\"6\">\n                        <billing-invoice [feed]=\"invoiceFeed\" [loaderImage]=\"loaderImage\" (invoiceDetails)=\"openDownloadOptions($event)\" (emitInvoiceActivity)= \"openInvoiceActivity($event)\">\n                        </billing-invoice>\n                    </td>\n                </tr>\n            </ng-container>\n            </tbody>\n            <!-- Non-consolidated Response -->\n            <tbody *ngIf=\"nonConsolidatedRes && nonConsolidatedRes.length\">\n            <ng-container *ngFor=\"let consolidation of nonConsolidatedRes; let i = index\">\n                <tr role=\"button\" tabindex=\"0\" (keydown.enter)=\"(feed.selectedView === 'Subgroup Reports') && nonConsolidatedInvoiceFeature ? getInvoices(consolidation, i+1) : false\" (click)=\"(feed.selectedView === 'Subgroup Reports') && nonConsolidatedInvoiceFeature ? getInvoices(consolidation, i+1) : false\">\n                    <ng-container\n                            *ngTemplateOutlet=\"summary; context:{consolidation: consolidation, index:i, type:feed.selectedView ,expandRowIndex: expandRowIndex}\">\n                    </ng-container>\n                </tr>\n                <tr class=\"child-component\" *ngIf=\"invoiceFeed &&  (i === expandRowIndex-1) && nonConsolidatedInvoiceFeature\">\n                    <td colspan=\"6\">\n                        <billing-invoice [feed]=\"invoiceFeed\" [loaderImage]=\"loaderImage\" (invoiceDetails)=\"openDownloadOptions($event)\" (emitInvoiceActivity)= \"openInvoiceActivity($event)\">\n                        </billing-invoice>\n                    </td>\n                </tr>\n            </ng-container>\n            </tbody>\n            <!--Common for Consolidated and Non consolidated Reports summary -->\n            <ng-template #summary let-consolidation=\"consolidation\" let-index=\"index\" let-type=\"type\"\n                         let-expandRowIndex=\"expandRowIndex\">\n                <td class=\"name\"><label *ngIf=\"type !== 'Group Reports'\">\n                    <svg *ngIf=\"!(index === expandRowIndex-1)\" xmlns=\"http://www.w3.org/2000/svg\" height=\"24\"\n                         verticalviewBox=\"0 0 24 24\" width=\"24\">\n                        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n                        <path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\" />\n                    </svg>\n                    <svg *ngIf=\"(index === expandRowIndex-1)\" xmlns=\"http://www.w3.org/2000/svg\" height=\"24\"\n                         viewBox=\"0 0 24 24\" width=\"24\">\n                        <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n                        <path d=\"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z\" />\n                    </svg>\n                </label>\n                    <span *ngIf=\"(type ==='Group Reports')\"><a class=\"invoice-number\" role=\"button\" tabindex=\"0\" (keydown.enter)=\"openDownloadOptions(consolidation,$event)\" (click)=\"openDownloadOptions(consolidation,$event)\">{{consolidation.name}}</a>\n                        <a  (click)=\"downloadStandardandInvoiceReports(consolidation)\" [rsTooltipTrigger]=\"consolidation.name === 'Claims' ? clamsTooltip  : AdminTooltip\" class = \"standard-reports\">\n                            <span class=\"svg-holder\" role=\"button\">\n                              <svg alt=\"Get Report\" role=\"button\" tabindex=\"0\" (keydown.enter)=\"downloadStandardandInvoiceReports(consolidation)\" class=\"svg-icon\" viewBox=\"0 0 20 20\">\n                                <path fill=\"none\"\n                                      d=\"M9.634,10.633c0.116,0.113,0.265,0.168,0.414,0.168c0.153,0,0.308-0.06,0.422-0.177l4.015-4.111c0.229-0.235,0.225-0.608-0.009-0.836c-0.232-0.229-0.606-0.222-0.836,0.009l-3.604,3.689L6.35,5.772C6.115,5.543,5.744,5.55,5.514,5.781C5.285,6.015,5.29,6.39,5.522,6.617L9.634,10.633z\">\n                                </path>\n                                <path fill=\"none\"\n                                      d=\"M17.737,9.815c-0.327,0-0.592,0.265-0.592,0.591v2.903H2.855v-2.903c0-0.327-0.264-0.591-0.591-0.591c-0.327,0-0.591,0.265-0.591,0.591V13.9c0,0.328,0.264,0.592,0.591,0.592h15.473c0.327,0,0.591-0.264,0.591-0.592v-3.494C18.328,10.08,18.064,9.815,17.737,9.815z\">\n                                </path>\n                              </svg>\n                            </span></a>\n                    </span>\n                    <span *ngIf=\"!(type ==='Group Reports')\">{{type ==='Consolidated Reports' ? consolidation.consolidationName :\n                        consolidation.name}}</span>\n                </td>\n                <td *ngIf=\"type ==='Subgroup Reports'\">{{consolidation && consolidation.subClientSpecifiedIdentifier}}\n                </td>\n                <td>{{consolidation.totalInvoiceCount || ''}}</td>\n                <td *ngIf=\"!type || type ==='Consolidated Reports'\">{{consolidation && consolidation.consolidation &&\n                consolidation.consolidation.subClientSpecifiedIdentifier ?\n                    consolidation.consolidation.subClientSpecifiedIdentifier : ''}}</td>\n                <td>{{(consolidation.startDate | date: 'MM/dd/yyyy') || ''}}</td>\n                <td>{{(consolidation.endDate | date: 'MM/dd/yyyy') || ''}}</td>\n                <td><span *ngIf=\"consolidation.status\" class=\"active-indicator\"\n                          [class.inactive-indicator]=\"consolidation.status === 'Inactive'\">{{consolidation.status}}</span>\n                </td>\n            </ng-template>\n            <ng-template #nonconsolidated>\n                <th> Name</th>\n                <th *ngIf=\"feed.selectedView === 'Subgroup Reports'\">Subgroup ID</th>\n                <th>Invoices</th>\n            </ng-template>\n        </table>\n    </div>\n    <div  class=\"billing-pagination\">\n        <rs-paginator  [length]= \"!(feed.selectedView  === 'Consolidated Reports') ? nonConsTotalRecords : consTotalRecords\" showFirstLastButtons\n                       (page)=\"pageChanged($event)\" [pageSize]=\"defaultPageSize\"></rs-paginator>\n    </div>\n    <rs-tooltip #AdminTooltip>\n        <div>Standard Billing Report and Invoice fast download</div>>\n    </rs-tooltip>\n    <rs-tooltip #clamsTooltip>\n        <div>Claims fast download</div>>\n    </rs-tooltip>\n    <rs-dialog [visible]=\"showInvoiceActivities || openMyReports\" maxWidth=\"55%\" (visibleChange)=\"dialogClose($event)\"\n               [heading]=\" !openMyReports ? 'Invoice Activity' : 'Available Reports'\">\n        <div *ngIf=\"showInvoiceActivities\" class=\"invoice-activity\">\n            <ng-container *ngIf=\"invoiceActivityError\">\n                <div class=\"invoice-error\">{{invoiceActivityError}}</div>\n            </ng-container>\n            <ng-container *ngIf=\"isFetchingInvoiceActivity\">\n                <rs-loader imageSrc={{loaderImage}}></rs-loader>\n            </ng-container>\n            <div class=\"invoice-activity-content\">\n                <div>\n                    <label>Invoice</label>\n                    <span>{{invoiceActivityResponse && (invoiceActivityResponse.invoiceNumber || '')}}</span>\n                </div>\n                <div>\n                    <label>Invoice Amount</label>\n                    <span>{{((invoiceActivityResponse && (invoiceActivityResponse.invoiceAmount) | currency) || '')}}</span>\n                </div>\n                <div>\n                    <label>Invoice Start Date</label>\n                    <span>{{invoiceActivityResponse && (invoiceActivityResponse.invoiceStartDate | date: 'MM/dd/yyyy')|| ''}}</span>\n                </div>\n                <div>\n                    <label>Invoice End Date:</label>\n                    <span>{{invoiceActivityResponse && (invoiceActivityResponse.invoiceEndDate | date: 'MM/dd/yyyy') || ''}}</span>\n                </div>\n                <div>\n                    <label>Payment Status</label>\n                    <span>{{(invoiceActivityResponse && (invoiceActivityResponse.invoiceStatus === 'C' ? 'Closed' : 'Open') || '')}}</span>\n                </div>\n            </div>\n            <div class =\"search-results-content\">\n                <ng-container\n                        *ngIf=\" invoiceActivityResponse && invoiceActivityResponse.invoiceActivity && invoiceActivityResponse.invoiceActivity.length\">\n                    <div>\n                        <h4>Invoice Activity</h4>\n                    </div>\n                    <table>\n                        <thead>\n                        <tr>\n                            <th>Group ID</th>\n                            <th>Sub Group ID</th>\n                            <th>Sub Group Name</th>\n                            <th>Invoice</th>\n                            <th>Activity Type</th>\n                            <th>Payment ID</th>\n                            <th>Amount</th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let item of invoiceActivityResponse.invoiceActivity; let i = index\">\n                            <td>{{item.clientSpecifiedIdentifier}}</td>\n                            <td>{{item.subclientSpecifiedIdentifier}}</td>\n                            <td>{{item.subclientName}}</td>\n                            <td>{{item.invoiceNumber}}</td>\n                            <td>{{item.activityType}}</td>\n                            <td>{{item.paymentId}}</td>\n                            <td>{{(item.paymentAmount) | currency}}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </ng-container>\n                <div  class=\"activity-pagination\">\n                    <rs-paginator [length]=\"invoiceActivityResponse && invoiceActivityResponse.pagination && invoiceActivityResponse.pagination.totalRecords\" showFirstLastButtons\n                                  (page)=\"activityPageChanged($event)\" [pageSize]=\"defaultPageSize\"></rs-paginator>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"openMyReports\" class=\"avaialable-reports\">\n            <billing-available-reports></billing-available-reports>\n        </div>\n    </rs-dialog>\n</div>\n<ng-container *ngIf=\"(invoiceDownloadInput| keyvalue)?.length\">\n    <billing-invoice-download [downloadFeed]=\"invoiceDownloadInput\" [loaderImage]=\"loaderImage\" (downloadDilogClosed)=\"downloadDilogClosed($event)\">\n    </billing-invoice-download>\n</ng-container>\n", styles: [".consolidated-reports{padding:0 30px}.consolidated-reports .search-results-content tbody tr:nth-child(odd){background-color:#f0f2f5}.consolidated-reports .search-results-content th,.consolidated-reports .search-results-content td{padding:12px 5px;width:100px}.consolidated-reports .search-results-content tr:focus{outline:none;border:2px solid #1D8928}.consolidated-reports .search-results-content td label{vertical-align:middle}.consolidated-reports .search-results-content .name{width:150px}.consolidated-reports .search-results-content th:first-of-type,.consolidated-reports .search-results-content td:first-of-type,.consolidated-reports .search-results-content th:last-of-type,.consolidated-reports .search-results-content td:last-of-type{padding-left:32px}.consolidated-reports .search-results-content th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.consolidated-reports .search-results-content table{border:1px solid #c2c2c2;border-collapse:collapse;width:100%}.consolidated-reports .search-results-content a{color:#06c;font-weight:700;cursor:pointer}.consolidated-reports .search-results-content tbody tr{cursor:pointer}.consolidated-reports .search-results-content .child-component{background-color:#fff!important}.consolidated-reports .search-results-content .activity-pagination{padding:20px}.consolidated-reports .search-results-content .active-indicator{background-color:#41a929;padding:5px;border-radius:3px;color:#fff;text-transform:capitalize}.consolidated-reports .search-results-content .inactive-indicator{background-color:#d3d3d3}.consolidated-reports .search-results-content .billing-pagination{margin:2px 0 0 30px}.consolidated-reports .invoice-activity{padding:0 16px 0 29px}.consolidated-reports .invoice-error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid red;margin:10px}.consolidated-reports .invoice-activity-content{padding:10px 10px 15px}.consolidated-reports .invoice-activity-content div{padding:5px 0}.consolidated-reports .invoice-activity-content div label{display:inline-block;width:18%}.consolidated-reports .invoice-activity-content div label:after{content:\":\"}.consolidated-reports .invoice-activity-content div span{display:inline-block;font-weight:700;font-size:1em;margin-right:5px}.consolidated-reports .invoice-activity-content div span:last-of-type{margin-left:5px}.consolidated-reports .invoice-number{display:inline-block;width:25%;padding-left:5px}.consolidated-reports .invoice-number:focus{outline:none;border:2px solid #1D8928}.consolidated-reports .error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto}.consolidated-reports .action{padding:10px;width:max-content}.consolidated-reports .payment{border-bottom:1px solid #636870}.consolidated-reports .action:hover{background-color:#eb8510}.message p,.message span{border:1px solid red;padding:10px;color:red}.message a{color:#06c;cursor:pointer}.svg-holder{display:inline-block;width:30px;height:30px;top:8px;position:relative;left:10px}.svg-icon{width:100%;height:100%}.svg-icon path,.svg-icon polygon,.svg-icon rect{fill:#4691f6}.svg-icon:focus{outline:none;border:2px solid #1D8928}.svg-icon circle{stroke:#4691f6;stroke-width:1}.standard-reports{padding-left:20px;cursor:pointer}.avaialable-reports{padding:5px}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }], { feed: [{
            type: Input
        }], billingFeatures: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReportsComponent, { className: "ReportsComponent", filePath: "lib/billing/reports/reports.component.ts", lineNumber: 28 }); })();

function BillingReportsComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r0.loaderImage);
} }
function BillingReportsComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " No Data Available ");
    i0.ɵɵelementEnd();
} }
function BillingReportsComponent_div_0_ng_container_3_rs_tab_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "billing-common-reports", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("feed", ctx_r0.reportsFeed)("loaderImage", ctx_r0.loaderImage)("billingFeatures", ctx_r0.billingFeatures);
} }
function BillingReportsComponent_div_0_ng_container_3_rs_tab_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rs-tab", 8);
    i0.ɵɵlistener("selected", function BillingReportsComponent_div_0_ng_container_3_rs_tab_2_Template_rs_tab_selected_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.getRecords($event, true)); });
    i0.ɵɵtemplate(1, BillingReportsComponent_div_0_ng_container_3_rs_tab_2_ng_container_1_Template, 2, 3, "ng-container", 2);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_5_0;
    const tab_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("label", tab_r3.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (tmp_5_0 = i0.ɵɵpipeBind1(2, 2, ctx_r0.reportsFeed)) == null ? null : tmp_5_0.length);
} }
function BillingReportsComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "rs-outlined-tab-group", 6);
    i0.ɵɵtemplate(2, BillingReportsComponent_div_0_ng_container_3_rs_tab_2_Template, 3, 4, "rs-tab", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedIndex", ctx_r0.selectedIndex)("allowFullWidth", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.tabs)("ngForTrackBy", ctx_r0.reportTab);
} }
function BillingReportsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, BillingReportsComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 2)(2, BillingReportsComponent_div_0_div_2_Template, 2, 0, "div", 3)(3, BillingReportsComponent_div_0_ng_container_3_Template, 3, 4, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isFetching);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.noResponse);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.noResponse);
} }
class BillingReportsComponent {
    constructor(lux, bAsync) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.loaderImage = '';
        this.tabs = [{
                label: 'Consolidated Reports',
                value: 'consolidatedReports'
            },
            {
                label: 'Group Reports',
                name: 'groupReports'
            },
            {
                label: 'Subgroup Reports',
                name: 'SubgroupReports'
            }];
        this.luxId = 'billing-lib-reports-comp' + this.constructor.name;
        this.isFetching$ = this.lux.get(isFetchingData, this.luxId);
        this.consolidatedRes$ = this.lux.get(consolidatedResponse, this.luxId);
        this.groupErrorMessage$ = this.lux.get(groupErrorMessage, this.luxId);
    }
    get feed() {
        return this._feed;
    }
    set feed(val) {
        this._feed = val;
        val && this.getRecords(val);
    }
    ngOnInit() {
        this.noResponse = false;
        this.selectedIndex = 0;
        this.isFetching$.subscribe(x => this.isFetching = x);
        this.groupErrorMessage$.subscribe(x => this.groupErrorMessage = x);
    }
    getRecords(item, fromtab) {
        this.lux.set(state => state.billing, { invoiceDownloadError: initialBillingState.invoiceDownloadError });
        this.reportsFeed = {};
        this.selectedIndex = item.index;
        this.lux.set(x => x.billing, { consolidatedSummaryResponse: initialBillingState.consolidatedSummaryResponse });
        this.lux.set(x => x.billing, { nonConsolidatedSummaryResponse: initialBillingState.nonConsolidatedSummaryResponse });
        if (!fromtab) {
            const request = {
                pagination: {
                    offset: 0,
                    limit: 10,
                },
                planAcronym: item.planAcronym,
                clientsSubclients: {
                    clientSpecifiedIdentifier: item.groupId,
                    subClientSpecifiedIdentifier: item.subGroupId ? item.subGroupId : '',
                },
                startDate: item.fromDate ? item.fromDate : '',
                endDate: item.toDate ? item.toDate : '',
            };
            this.lux.set(state => state.billing, { BillingComponentCriteria: request });
            this.bAsync.getGroupViewInfo().subscribe(x => {
                if (x && typeof x === 'string') {
                    this.hideGroupTab = true;
                    this.tabs = [{
                            label: 'Consolidated Reports',
                            value: 'consolidatedReports'
                        },
                        {
                            label: 'Subgroup Reports',
                            name: 'SubgroupReports'
                        }];
                }
                else {
                    this.hideGroupTab = false;
                }
            });
            this.bAsync.getTotalAmount().subscribe();
            this.bAsync.getConsolidatedSummaryReports().subscribe(consolidated => {
                if (typeof consolidated === 'string' || consolidated === null) {
                    this.tabs.shift();
                    this.bAsync.getNonConsolidatedSummaryReports('Group Reports').subscribe(nonConsolidated => {
                        if (typeof nonConsolidated === 'string' || nonConsolidated === null) {
                            !this.hideGroupTab && this.tabs.shift();
                            this.bAsync.getNonConsolidatedSummaryReports('Subgroup Reports').subscribe(nonConSubGroup => {
                                if (typeof nonConSubGroup === 'string' || nonConSubGroup === null) {
                                    this.noResponse = true;
                                }
                                else {
                                    this.feedReports('Subgroup Reports');
                                }
                            });
                        }
                        else {
                            this.feedReports('Group Reports');
                        }
                    });
                }
                else {
                    this.feedReports('Consolidated Reports');
                }
            });
        }
        else {
            this.lux.set(state => state.billing.BillingComponentCriteria.pagination, { offset: 0 });
            if (item.label === 'Consolidated Reports') {
                this.bAsync.getConsolidatedSummaryReports().subscribe();
            }
            else {
                this.bAsync.getNonConsolidatedSummaryReports(item.label).subscribe();
            }
            this.feedReports(item.label);
        }
    }
    feedReports(view) {
        this.reportsFeed = {
            selectedView: view,
            groupId: this.feed.groupId,
            planAcronym: this.feed.planAcronym,
            groupName: this.feed.groupName,
            subGroupName: this.feed.subGroupName,
        };
    }
    reportTab(item) {
        return item.id;
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function BillingReportsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingReportsComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BillingReportsComponent, selectors: [["billing-reports"]], inputs: { billingFeatures: "billingFeatures", loaderImage: "loaderImage", feed: "feed" }, decls: 1, vars: 1, consts: [["class", "billing-details", 4, "ngIf"], [1, "billing-details"], [4, "ngIf"], ["class", "error", 4, "ngIf"], ["position", "absolute", 3, "imageSrc"], [1, "error"], [3, "selectedIndex", "allowFullWidth"], [3, "label", "selected", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "selected", "label"], [3, "feed", "loaderImage", "billingFeatures"]], template: function BillingReportsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, BillingReportsComponent_div_0_Template, 4, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.feed.groupId);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i4$1.TabComponent, i4$1.OutlinedTabGroupComponent, i7.LoaderComponent, ReportsComponent, i3$1.KeyValuePipe], styles: [".billing-details[_ngcontent-%COMP%]{position:relative}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]{padding:2px 5px 20px}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .details[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]{border-bottom:1px solid grey;padding:20px 15px 15px;font-size:16px}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .total-bal[_ngcontent-%COMP%]{float:right}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .due[_ngcontent-%COMP%]{color:red}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700;display:inline;border-bottom:3px solid #ff7308;padding-bottom:15px}.billing-details[_ngcontent-%COMP%]   .billing-header[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 15px 0 10px;font-weight:400}.billing-details[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;border:1px solid #e01e5a;margin:10px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingReportsComponent, [{
        type: Component,
        args: [{ selector: 'billing-reports', template: "<div *ngIf=\"feed.groupId\" class=\"billing-details\">\n    <ng-container *ngIf=\"isFetching\">\n      <rs-loader position=\"absolute\" imageSrc={{loaderImage}}></rs-loader>\n    </ng-container>\n  <div class=\"error\" *ngIf=\"noResponse\"> No Data Available </div>\n  <ng-container *ngIf=\"!noResponse\">\n    <rs-outlined-tab-group [selectedIndex]=\"selectedIndex\" [allowFullWidth]=\"true\">\n      <rs-tab *ngFor=\"let tab of tabs; trackBy: reportTab\" [label]=\"tab.label\" (selected)=\"getRecords($event,true)\">\n        <ng-container *ngIf=\"(reportsFeed| keyvalue)?.length\">\n          <billing-common-reports [feed]=\"reportsFeed\" [loaderImage]=\"loaderImage\" [billingFeatures]=\"billingFeatures\">\n          </billing-common-reports>\n        </ng-container>\n      </rs-tab>\n    </rs-outlined-tab-group>\n  </ng-container>\n</div>", styles: [".billing-details{position:relative}.billing-details .billing-header{padding:2px 5px 20px}.billing-details .billing-header .details label{font-weight:700}.billing-details .billing-header .group-subgroup-heading{border-bottom:1px solid grey;padding:20px 15px 15px;font-size:16px}.billing-details .billing-header .group-subgroup-heading .total-bal{float:right}.billing-details .billing-header .group-subgroup-heading .due{color:red}.billing-details .billing-header .group-subgroup-heading label{font-weight:700;display:inline;border-bottom:3px solid #ff7308;padding-bottom:15px}.billing-details .billing-header .group-subgroup-heading label span{padding:0 15px 0 10px;font-weight:400}.billing-details .error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;border:1px solid #e01e5a;margin:10px}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }], { billingFeatures: [{
            type: Input
        }], loaderImage: [{
            type: Input
        }], feed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BillingReportsComponent, { className: "BillingReportsComponent", filePath: "lib/billing/billing-reports/billing-reports.component.ts", lineNumber: 13 }); })();

class FeatureComponent {
    get features() {
        return this._features;
    }
    set features(value) {
        this._features = value;
    }
    constructor(allFeatures) {
        this.allFeatures = allFeatures;
        // tslint:disable-next-line:variable-name
        this._features = [];
    }
    static { this.ɵfac = function FeatureComponent_Factory(__ngFactoryType__) { i0.ɵɵinvalidFactory(); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FeatureComponent, inputs: { features: "features" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeatureComponent, [{
        type: Directive
    }], () => [{ type: undefined }], { features: [{
            type: Input
        }] }); })();

var Billing;
(function (Billing) {
    /** it includes consolidatedInvoice */
    Billing["consolidatedInvoice"] = "consolidatedInvoice";
    /** it includes nonConsolidatedInvoice */
    Billing["nonConsolidatedInvoice"] = "nonConsolidatedInvoice";
    /** it includes payment history feature  */
    Billing["paymentHistory"] = "paymentHistory";
})(Billing || (Billing = {}));

function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}

class UserAuthConfig {
}
const userAuthProvider = {
    provide: UserAuthConfig,
    useValue: {
        userAuthorizations: {}
    }
};

// @dynamic
const BillingConstants = {
    REGEXP_BANK_ROUTING_NUMBER: /^[0-9]{9}$/,
    REGEXP_BANK_ACCOUNT_NUMBER: /^[0-9]{6,17}$/,
    NAME_REGEXP: /^[A-Za-z-\']( ?[A-Za-z-\'] ?)*$/,
    EMAIL_REGEXP: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    PAYMENT_CC: 'Credit Card',
    PAYMENT_ACH: 'ACH',
    PAYMENT_SAVING: 'SAVING'
};

function confirmValidator(controlName, matchingControlName) {
    return (formGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors &&
            ((controlName === 'accountNumber' && !matchingControl.errors.accountNumberMissMatch) ||
                (controlName === 'routingNumber' && !matchingControl.errors.routingNumberMissMatch))) {
            return;
        }
        if (control.value !== matchingControl.value) {
            if (controlName === 'accountNumber') {
                control.setErrors({ accountNumberMissMatch: true });
                matchingControl.setErrors({ accountNumberMissMatch: true });
            }
            if (controlName === 'routingNumber') {
                control.setErrors({ routingNumberMissMatch: true });
                matchingControl.setErrors({ routingNumberMissMatch: true });
            }
        }
        else {
            control.setErrors(null);
            matchingControl.setErrors(null);
        }
    };
}
function routingNumberValidator(controlName) {
    let checksum = 0;
    let sum = 0;
    let mod = 0;
    return (formGroup) => {
        const control = formGroup.controls[controlName];
        if (isNotEmpty(control.value) && control.value.length === 9) {
            const firstTwoDigits = control.value.substr(0, 2);
            if (!((1 <= firstTwoDigits && 15 >= firstTwoDigits)
                || (21 <= firstTwoDigits && 32 >= firstTwoDigits)
                || (61 <= firstTwoDigits && 72 >= firstTwoDigits))) {
                // 'Routing Number', 'The first two digits should fall within one of the following ranges: 01-15, 21-32 or 61-72');
                control.setErrors({ invalidRoutingNumber: true });
            }
            else {
                checksum = Number(control.value.substring(control.value.length - 1));
                sum = (7 * (Number('' + control.value.charAt(0)) + Number('' + control.value.charAt(3)) +
                    Number('' + control.value.charAt(6)))) +
                    (3 * (Number('' + control.value.charAt(1)) + Number('' + control.value.charAt(4)) +
                        Number('' + control.value.charAt(7)))) +
                    (9 * (Number('' + control.value.charAt(2)) + Number('' + control.value.charAt(5))));
                mod = sum % 10;
                (mod === checksum) ? control.setErrors(null) : control.setErrors({ invalidRoutingNumber: true });
            }
        }
    };
}
function isEmpty(value) {
    if (value === 'undefined' || value == null || value === '') {
        return true;
    }
    else {
        if (value.toString().trim().length === 0) {
            return true;
        }
        else {
            return false;
        }
    }
}
function isNotEmpty(value) {
    return !isEmpty(value);
}

function PaymentComponent_div_0_rs_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader", 22);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("imageSrc", ctx_r1.loaderImage);
} }
function PaymentComponent_div_0_form_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 14)(1, "div", 3)(2, "div", 23)(3, "rs-select", 24);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_form_9_Template_rs_select_change_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectedSavedPaymentProfile($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(4, "div", 3)(5, "div", 23);
    i0.ɵɵelement(6, "rs-input", 25);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.savedPaymentMethodForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.savedPaymentMethods)("selectValue", ctx_r1.selectedSavedPaymentMethod)("multiple", false);
} }
function PaymentComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "rs-checkbox", 27);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_div_17_Template_rs_checkbox_change_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.savePaymentMethodCheck = $event.target.checked); });
    i0.ɵɵelementEnd()();
} }
function PaymentComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 28);
    i0.ɵɵtext(2, " Bank Information ");
    i0.ɵɵelementEnd()();
} }
function PaymentComponent_div_0_form_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 14)(1, "div", 3)(2, "div", 29)(3, "div", 30)(4, "div", 6);
    i0.ɵɵelement(5, "rs-input", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 30)(7, "div", 6);
    i0.ɵɵelement(8, "rs-input", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 32)(10, "div", 6);
    i0.ɵɵelement(11, "rs-input", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 34);
    i0.ɵɵelement(13, "rs-input", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 32)(15, "div", 6);
    i0.ɵɵelement(16, "rs-input", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 34);
    i0.ɵɵelement(18, "rs-input", 37);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 6)(20, "div", 38);
    i0.ɵɵelement(21, "img", 39);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.eftForm);
} }
function PaymentComponent_div_0_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 28);
    i0.ɵɵtext(2, " Credit Card Information ");
    i0.ɵɵelementEnd()();
} }
function PaymentComponent_div_0_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 23);
    i0.ɵɵelement(2, "rs-input", 40);
    i0.ɵɵelementEnd()();
} }
function PaymentComponent_div_0_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 23);
    i0.ɵɵelement(2, "rs-input", 25);
    i0.ɵɵelementEnd()();
} }
function PaymentComponent_div_0_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 23)(2, "div", 41)(3, "label", 42);
    i0.ɵɵtext(4, "Card Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "ngx-stripe-card", 43)(6, "div", 44);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", ctx_r1.selectedPaymentMethod !== ctx_r1.BillingConstants.PAYMENT_CC);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("stripe", ctx_r1.stripe);
} }
function PaymentComponent_div_0_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.addCustomerProfileError || ctx_r1.addCustomerPaymentProfileError || ctx_r1.customerPaymentProfileError || ctx_r1.merchantAccountError || ctx_r1.paymentError || ctx_r1.stripeTokenError, " ");
} }
function PaymentComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PaymentComponent_div_0_rs_loader_1_Template, 1, 1, "rs-loader", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
    i0.ɵɵtext(4, " Select Payment Method ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "div", 3)(7, "div", 6)(8, "rs-radio", 7);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_Template_rs_radio_change_8_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectedSavedPaymentMethods()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, PaymentComponent_div_0_form_9_Template, 7, 4, "form", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5)(11, "div", 3)(12, "div", 6)(13, "rs-radio", 9);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_Template_rs_radio_change_13_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectedNewPaymentMethod()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 3)(15, "div", 10)(16, "rs-select", 11);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_Template_rs_select_change_16_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectedNewPaymentOption($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(17, PaymentComponent_div_0_div_17_Template, 2, 0, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, PaymentComponent_div_0_div_18_Template, 3, 0, "div", 13)(19, PaymentComponent_div_0_form_19_Template, 22, 1, "form", 8)(20, PaymentComponent_div_0_div_20_Template, 3, 0, "div", 13);
    i0.ɵɵelementStart(21, "form", 14);
    i0.ɵɵtemplate(22, PaymentComponent_div_0_div_22_Template, 3, 0, "div", 13)(23, PaymentComponent_div_0_div_23_Template, 3, 0, "div", 13)(24, PaymentComponent_div_0_div_24_Template, 7, 2, "div", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 15)(26, "div", 16)(27, "rs-checkbox", 17);
    i0.ɵɵlistener("change", function PaymentComponent_div_0_Template_rs_checkbox_change_27_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.authorizeCheck = $event.target.checked); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 6);
    i0.ɵɵtext(29, " By clicking Submit, I agree to the following: I hereby authorize Delta Dental, its subsidiaries and affiliates to initiate a one-time withdrawal (ACH) from the account indicated above. I understand that I am responsible for any fees incurred due to my payment being rejected for processing by my bank. Rejected payments may cause my account to become delinquent and a claims hold will be placed on my account until outstanding invoices are paid in full. ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "div", 18)(31, "button", 19);
    i0.ɵɵlistener("click", function PaymentComponent_div_0_Template_button_click_31_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeDialog()); });
    i0.ɵɵtext(32, "CANCEL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "button", 19);
    i0.ɵɵlistener("click", function PaymentComponent_div_0_Template_button_click_33_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.backToInvoices()); });
    i0.ɵɵtext(34, "BACK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "button", 20);
    i0.ɵɵlistener("click", function PaymentComponent_div_0_Template_button_click_35_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submitPayment()); });
    i0.ɵɵtext(36, "SUBMIT");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(37, PaymentComponent_div_0_div_37_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFetching || ctx_r1.isFetchingPayment || ctx_r1.isFetchingAddCustomerPaymentProfile || ctx_r1.isFetchingCustomerPaymentProfiles);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("checked", ctx_r1.isSavedPaymentEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSavedPaymentEnabled);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", !ctx_r1.isSavedPaymentEnabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.newPaymentMethods)("selectValue", ctx_r1.selectedPaymentMethod)("multiple", false)("disabled", ctx_r1.isSavedPaymentEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_ACH || ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_SAVING);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_ACH || ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_SAVING);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_CC);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.creditCardForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_CC);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_CC);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_CC);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("disabled", ctx_r1.isSavedPaymentEnabled ? !ctx_r1.authorizeCheck || !ctx_r1.savedPaymentMethodForm.valid : !(ctx_r1.selectedPaymentMethod === ctx_r1.BillingConstants.PAYMENT_CC ? ctx_r1.creditCardForm.valid : ctx_r1.eftForm.valid) || !ctx_r1.authorizeCheck);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.addCustomerProfileError || ctx_r1.addCustomerPaymentProfileError || ctx_r1.customerPaymentProfileError || ctx_r1.merchantAccountError || ctx_r1.paymentError || ctx_r1.stripeTokenError);
} }
class PaymentComponent {
    get paymentFeed() {
        return this._paymentFeed;
    }
    set paymentFeed(val) {
        this._paymentFeed = val;
        if (val) {
            this.paymentConfig();
            this.customerPaymentProfiles();
            this.getMerchantAccount();
            this.resetErrorMessages();
        }
    }
    constructor(lux, bAsync, formBuilder, stripeFactory) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.formBuilder = formBuilder;
        this.stripeFactory = stripeFactory;
        this.paymentDilogClosed = new EventEmitter();
        this.loaderImage = '';
        this.defaultPageSize = 50;
        this.luxId = 'billing-lib-payment-comp' + this.constructor.name;
        this.isFetching$ = this.lux.get(isFetchingpaymentConfig, this.luxId);
        this.isFetchingPayment$ = this.lux.get(isFetchingPayment, this.luxId);
        this.isFetchingAddCustomerPaymentProfile$ = this.lux.get(isFetchingAddCustomerPaymentProfile, this.luxId);
        this.isFetchingCustomerPaymentProfiles$ = this.lux.get(isFetchingCustomerPaymentProfiles, this.luxId);
        this.customerPaymentProfileError$ = this.lux.get(customerPaymentProfileError, this.luxId);
        this.merchantAccountError$ = this.lux.get(merchantAccountError, this.luxId);
        this.addCustomerProfileError$ = this.lux.get(addCustomerProfileError, this.luxId);
        this.addCustomerPaymentProfileError$ = this.lux.get(addCustomerPaymentProfileError, this.luxId);
        this.paymentError$ = this.lux.get(paymentError, this.luxId);
        this.addCustomerProfileError = '';
        this.addCustomerPaymentProfileError = '';
        this.customerPaymentProfileError = '';
        this.merchantAccountError = '';
        this.paymentError = '';
        this.stripeTokenError = '';
        this.isSavedPaymentEnabled = false;
        this.authorizeCheck = false;
        this.isConfirmPaymentEnable = false;
        this.isProfilePaymentEnabled = false;
        this.BillingConstants = BillingConstants;
        this._paymentFeed = {
            adminPlan: '',
            planAcronym: '',
            clientSpecifiedIdentifier: '',
            subClientSpecifiedIdentifier: '',
            startDate: '',
            endDate: '',
            groupName: '',
            amount: '',
            selectedInvoices: null,
            businessUnitDepartmentIDs: null,
            businessUnit: '',
            departmentId: '',
            filterType: '',
            allInvoicesSelected: '',
            email: '',
            appName: ''
        };
    }
    ngOnInit() {
        this.intializeSavedPaymentMethodsForm();
        this.intializeCreditCardForm();
        this.intializeEFTForm();
        this.isFetching$.subscribe(isFetching => this.isFetching = isFetching);
        this.isFetchingPayment$.subscribe(x => this.isFetchingPayment = x);
        this.isFetchingAddCustomerPaymentProfile$.subscribe(x => this.isFetchingAddCustomerPaymentProfile = x);
        this.isFetchingCustomerPaymentProfiles$.subscribe(x => this.isFetchingCustomerPaymentProfiles = x);
        this.customerPaymentProfileError$.subscribe((error) => (this.customerPaymentProfileError = (error.toUpperCase() === 'NO DATA FOUND FOR THE GIVEN REQUEST' || error.toUpperCase() === 'INTERNAL SERVER ERROR') ? '' : error));
        this.merchantAccountError$.subscribe((error) => (this.merchantAccountError = error));
        this.paymentError$.subscribe((error) => (this.paymentError = error));
        this.addCustomerProfileError$.subscribe((error) => (this.addCustomerProfileError = error));
        this.addCustomerPaymentProfileError$.subscribe((error) => (this.addCustomerPaymentProfileError = error));
    }
    intializeSavedPaymentMethodsForm() {
        this.savedPaymentMethodForm = this.formBuilder.group({
            selectedSavedPaymentMethod: ['', Validators.required],
            emailAddress: [this.paymentFeed.email, [Validators.required, Validators.pattern(BillingConstants.EMAIL_REGEXP)]]
        });
    }
    intializeCreditCardForm() {
        this.creditCardForm = this.formBuilder.group({
            nameOnCreditCard: ['', [Validators.required, Validators.pattern(BillingConstants.NAME_REGEXP)]],
            emailAddress: [this.paymentFeed.email, [Validators.required, Validators.pattern(BillingConstants.EMAIL_REGEXP)]]
        });
    }
    intializeEFTForm() {
        this.eftForm = this.formBuilder.group({
            emailAddress: [this.paymentFeed.email, [Validators.required, Validators.pattern(BillingConstants.EMAIL_REGEXP)]],
            nameOnCard: ['', [Validators.required, Validators.pattern(BillingConstants.NAME_REGEXP)]],
            routingNumber: ['', [Validators.required, Validators.pattern(BillingConstants.REGEXP_BANK_ROUTING_NUMBER)]],
            reTypeRoutingNumber: ['', [Validators.required, Validators.pattern(BillingConstants.REGEXP_BANK_ROUTING_NUMBER)]],
            accountNumber: ['', [Validators.required, Validators.pattern(BillingConstants.REGEXP_BANK_ACCOUNT_NUMBER)]],
            reTypeAccountNumber: ['', [Validators.required, Validators.pattern(BillingConstants.REGEXP_BANK_ACCOUNT_NUMBER)]],
            savePaymentMethod: ['']
        }, {
            validator: [routingNumberValidator('routingNumber'), routingNumberValidator('reTypeRoutingNumber'), confirmValidator('routingNumber', 'reTypeRoutingNumber'),
                confirmValidator('accountNumber', 'reTypeAccountNumber')]
        });
    }
    initializeStripeCardElement() {
        this.stripe = this.stripeFactory.create(this.merchantAccountResponse.merchantAccountRegistrationKey);
    }
    resetErrorMessages() {
        this.lux.set(x => x.billing, {
            merchantAccountError: '', addCustomerProfileError: '', addCustomerPaymentProfileError: '',
            paymentError: '', customerPaymentProfilesError: ''
        });
        this.stripeTokenError = '';
    }
    handleForm(e) {
    }
    paymentConfig() {
        const paymentConfigurationsRequest = {
            adminPlanAcronym: this.paymentFeed.adminPlan,
            planAcronym: this.paymentFeed.planAcronym,
            clientType: 'Group',
            asOfDate: moment(new Date()).format('YYYY-MM-DD')
        };
        this.bAsync
            .checkPaymentConfig(paymentConfigurationsRequest)
            .subscribe((config) => {
            if (config && config.length) {
                this.paymentConfigurationsResponse = config;
                this.setNewPaymentMethods();
            }
        });
        this.showDialog = true;
    }
    setNewPaymentMethods() {
        if (this.paymentConfigurationsResponse && this.paymentConfigurationsResponse[0].paymentMethods) {
            this.newPaymentMethods = this.paymentConfigurationsResponse[0].paymentMethods.map((paymentMethods) => {
                return { value: paymentMethods.paymentMethod, label: paymentMethods.paymentMethod };
            });
            this.newPaymentMethods.sort((a, b) => a.value.localeCompare(b.value));
        }
    }
    customerPaymentProfiles() {
        const customerPaymentProfilesRequest = {
            planAcronym: this.paymentFeed.planAcronym,
            businessUnit: this.paymentFeed.businessUnit,
            fetchAllAccounts: 'Yes',
            _include: 'paymentProfile'
        };
        this.lux.set((state) => state.billing.customerPaymentProfilesRequest, customerPaymentProfilesRequest);
        this.bAsync.getCustomerPaymentProfiles().subscribe((response) => {
            if (response) {
                this.customerPaymentProfilesResponse = response;
                this.setSavedPaymentMethods();
            }
        });
        this.showDialog = true;
    }
    getMerchantAccount() {
        const merchantAccountRequest = {
            adminPlanAcronym: this.paymentFeed.adminPlan,
            planAcronym: this.paymentFeed.planAcronym,
            businessUnit: this.paymentFeed.businessUnit,
            clientType: 'GROUP',
            startDate: this.paymentFeed.startDate
        };
        this.lux.set((state) => state.billing.merchantAccountRequest, merchantAccountRequest);
        this.bAsync.getMerchantAccount().subscribe((response) => {
            if (response && response.merchantAccountId) {
                this.merchantAccountResponse = response;
                this.initializeStripeCardElement();
            }
        });
        this.showDialog = true;
    }
    setSavedPaymentMethods() {
        this.savedPaymentMethods = [];
        let defaultPayment = [];
        if (this.customerPaymentProfilesResponse && this.customerPaymentProfilesResponse.customerProfile) {
            this.isSavedPaymentEnabled = true;
            defaultPayment = this.customerPaymentProfilesResponse.customerProfile.paymentProfile.filter(paymentProfile => paymentProfile.defaultPaymentIndicator === 'Yes');
            this.savedPaymentMethods = this.customerPaymentProfilesResponse.customerProfile.paymentProfile.map(paymentProfile => {
                return {
                    value: paymentProfile.paymentProfileId,
                    label: paymentProfile.paymentType + ' ' + ' Account Ending ' + paymentProfile.accountNumber
                };
            });
        }
        if (this.isProfilePaymentEnabled) {
            this.submitStripePayment(defaultPayment[0], null);
        }
        this.selectedSavedPaymentMethod = (defaultPayment && defaultPayment.length > 0) ?
            defaultPayment[0].paymentProfileId :
            (this.customerPaymentProfilesResponse.customerProfile) ?
                this.customerPaymentProfilesResponse.customerProfile.paymentProfile[0].paymentProfileId : null;
        this.savedPaymentMethodForm.get('selectedSavedPaymentMethod').setValue(this.selectedSavedPaymentMethod);
    }
    selectedSavedPaymentMethods() {
        this.isSavedPaymentEnabled = true;
        this.selectedPaymentMethod = '';
        this.savePaymentMethodCheck = false;
        this.intializeSavedPaymentMethodsForm();
        this.creditCardForm.reset();
        this.eftForm.reset();
        this.resetErrorMessages();
    }
    selectedNewPaymentMethod() {
        this.isSavedPaymentEnabled = false;
        this.selectedSavedPaymentMethod = '';
        this.creditCardForm.reset();
        this.eftForm.reset();
        this.savedPaymentMethodForm.reset();
    }
    selectedNewPaymentOption(paymentMethod) {
        this.resetErrorMessages();
        this.selectedPaymentMethod = paymentMethod;
        if (this.selectedPaymentMethod === BillingConstants.PAYMENT_ACH || BillingConstants.PAYMENT_SAVING) {
            this.intializeEFTForm();
        }
        if (this.selectedPaymentMethod.toUpperCase() === BillingConstants.PAYMENT_CC.toUpperCase()) {
            this.intializeCreditCardForm();
        }
    }
    selectedSavedPaymentProfile(paymentProfile) {
        this.resetErrorMessages();
        this.selectedSavedPaymentMethod = paymentProfile;
    }
    submitPayment() {
        this.isProfilePaymentEnabled = false;
        this.resetErrorMessages();
        if (this.isSavedPaymentEnabled) {
            const savedPaymentMethodFormData = this.savedPaymentMethodForm.getRawValue();
            this.receiptEmailAddress = savedPaymentMethodFormData.emailAddress;
            this.customerPaymentProfilesResponse.customerProfile.paymentProfile.forEach(pmtProfile => {
                if (pmtProfile.paymentProfileId === this.selectedSavedPaymentMethod) {
                    this.submitStripePayment(pmtProfile, null);
                }
            });
        }
        else {
            if (this.selectedPaymentMethod === BillingConstants.PAYMENT_ACH) {
                const eftFormData = this.eftForm.getRawValue();
                this.receiptEmailAddress = eftFormData.emailAddress;
                this.stripe.createToken('bank_account', {
                    country: 'US',
                    currency: 'usd',
                    routing_number: eftFormData.routingNumber,
                    account_number: eftFormData.accountNumber,
                    account_holder_name: eftFormData.nameOnCard,
                    account_holder_type: 'company'
                }).subscribe(result => {
                    if (result.error) {
                        this.stripeTokenError = result.error.message;
                    }
                    else {
                        if (result && result.token && result.token.id) {
                            this.submitStripePayment(null, result.token.id);
                        }
                    }
                });
            }
            else if (this.selectedPaymentMethod.toUpperCase() === BillingConstants.PAYMENT_CC.toUpperCase()) {
                const creditCardFormData = this.creditCardForm.getRawValue();
                this.receiptEmailAddress = creditCardFormData.emailAddress;
                const additionalData = {
                    name: creditCardFormData.nameOnCreditCard
                };
                this.stripe.createToken(this.card.element, additionalData).subscribe(result => {
                    if (result.error) {
                        this.stripeTokenError = result.error.message;
                    }
                    else {
                        this.submitStripePayment(null, result.token.id);
                    }
                });
            }
        }
    }
    saveCustomerProfile(paymentToken) {
        const addCustomerProfileRequest = {
            planAcronym: this.paymentFeed.planAcronym,
            businessUnit: this.paymentFeed.businessUnit,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            merchantAcctIdentifier: this.merchantAccountResponse.merchantAccountIdentifier,
            email: this.receiptEmailAddress,
            paymentProfileToken: paymentToken,
            description: 'group payment'
        };
        this.lux.set((state) => state.billing.addCustomerProfileRequest, addCustomerProfileRequest);
        this.bAsync.addGroupBillingCustomerProfile().subscribe((response) => {
            if (response && response.customerProfileId) {
                this.isProfilePaymentEnabled = true;
                this.customerPaymentProfiles();
            }
        });
    }
    savePaymentProfile(paymentToken) {
        const addCustomerPaymentProfileRequest = {
            paymentProfileToken: paymentToken,
            merchantAcctIdentifier: this.merchantAccountResponse.merchantAccountIdentifier,
            planAcronym: this.paymentFeed.planAcronym,
            businessUnit: this.paymentFeed.businessUnit,
            paymentType: (paymentToken.charAt(0).toUpperCase() === 'B') ? 'ACH' : 'CC',
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            defaultPaymentIndicator: 'Y'
        };
        this.lux.set((state) => state.billing.addCustomerPaymentProfileRequest, addCustomerPaymentProfileRequest);
        this.bAsync.addGroupBillingPaymentProfile().subscribe((response) => {
            if (response && response.paymentProfileId) {
                this.isProfilePaymentEnabled = true;
                this.customerPaymentProfiles();
            }
        });
    }
    convertAmountToCents() {
        return Number(this.paymentFeed.amount) * 100;
    }
    createPaymentRequest(savedPaymentProfile, stripePaymentToken) {
        const invoicesArray = [];
        const consolidatedInvoicesArray = [];
        this.paymentFeed.selectedInvoices.forEach((value, key) => {
            if (value && value.invoiceNumber && value.consolidation) {
                consolidatedInvoicesArray.push({
                    businessUnit: value.businessUnit,
                    departmentId: value.departmentID,
                    remainingBalance: value.remainingBalance,
                    invoiceNumber: value.invoiceNumber
                });
            }
            else {
                invoicesArray.push({
                    invoiceNumber: value.invoiceNumber,
                    businessUnit: value.businessUnit,
                    departmentId: value.departmentID,
                    remainingBalance: value.remainingBalance,
                    clientSpecifiedIdentifier: value.clientSpecifiedIdentifier,
                    subClientSpecifiedIdentifier: value.subclientSpecifiedIdentifier
                });
            }
        });
        const paymentRequest = {
            businessUnitDeptTypeId: '2',
            receiptEmail: this.receiptEmailAddress,
            applicationName: this.paymentFeed.appName,
            message: 'group payment',
            planAcronym: this.paymentFeed.planAcronym,
            clientsSubclients: this.paymentFeed.allInvoicesSelected ? this.createClientsSubclients() : null,
            totalBalanceDueDetails: this.paymentFeed.allInvoicesSelected ? this.createTotalBalanceDueDetails() : null,
            businessUnitDepartmentIds: [
                {
                    businessUnit: this.paymentFeed.businessUnit,
                    departmentId: (this.paymentFeed.businessUnitDepartmentIDs[0].departmentId &&
                        this.paymentFeed.businessUnitDepartmentIDs[0].departmentId.length > 0) ?
                        this.paymentFeed.businessUnitDepartmentIDs[0].departmentId : '',
                    merchantAccountId: this.merchantAccountResponse.merchantAccountId,
                    merchantRegistrationKey: this.merchantAccountResponse.merchantAccountRegistrationKey,
                    merchantAccountIdentifier: this.merchantAccountResponse.merchantAccountIdentifier,
                    gatewayCustomerId: savedPaymentProfile ? this.customerPaymentProfilesResponse.customerProfile.customerProfileId : null,
                    paymentProfileId: savedPaymentProfile ? savedPaymentProfile.paymentProfileId : null,
                    paymentToken: stripePaymentToken ? stripePaymentToken : null
                }
            ],
            invoiceDetails: this.paymentFeed.allInvoicesSelected ? null :
                (invoicesArray && invoicesArray.length >= 1 ? invoicesArray : null),
            consolidationDetails: this.paymentFeed.allInvoicesSelected ? null :
                (consolidatedInvoicesArray && consolidatedInvoicesArray.length >= 1 ? consolidatedInvoicesArray : null)
        };
        return paymentRequest;
    }
    createClientsSubclients() {
        const clientsSubclients = {
            clientSpecifiedIdentifier: this.paymentFeed.clientSpecifiedIdentifier,
            subclientSpecifiedId: this.paymentFeed.subClientSpecifiedIdentifier
        };
        return clientsSubclients;
    }
    createTotalBalanceDueDetails() {
        const totalBalanceDueDetails = {
            remainingBalance: Number(this.paymentFeed.amount),
            filterType: this.paymentFeed.filterType
        };
        return totalBalanceDueDetails;
    }
    submitStripePayment(savedPaymentProfile, stripePaymentToken) {
        const paymentRequest = this.createPaymentRequest(savedPaymentProfile, stripePaymentToken);
        if (this.savePaymentMethodCheck && !this.isProfilePaymentEnabled) {
            this.customerPaymentProfilesResponse.customerProfile ?
                this.savePaymentProfile(paymentRequest.businessUnitDepartmentIds[0].paymentToken) :
                this.saveCustomerProfile(paymentRequest.businessUnitDepartmentIds[0].paymentToken);
        }
        else {
            this.lux.set((state) => state.billing.paymentRequest, paymentRequest);
            this.bAsync.submitPayment().subscribe((response) => {
                if (response && response.transactions && response.transactions.length > 0) {
                    this.paymentResponse = {
                        chargeId: response.transactions[0].transactionId,
                        paymentGatewayLogId: response.transactions[0].paymentGatewayLogId,
                        receiptEmail: this.receiptEmailAddress
                    };
                    this.bAsync.getTotalAmount().subscribe();
                    this.closeDialog();
                    this.isConfirmPaymentEnable = true;
                }
            });
        }
    }
    closeDialog() {
        this.paymentDilogClosed.emit(this.paymentResponse);
        this.showDialog = false;
    }
    backToInvoices() {
        this.paymentDilogClosed.emit('BACK');
        this.showDialog = false;
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function PaymentComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaymentComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync), i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(i4$2.StripeFactoryService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentComponent, selectors: [["billing-payment"]], viewQuery: function PaymentComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(StripeCardComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.card = _t.first);
        } }, inputs: { loaderImage: "loaderImage", paymentFeed: "paymentFeed" }, outputs: { paymentDilogClosed: "paymentDilogClosed" }, decls: 1, vars: 1, consts: [["class", "payment-container", 4, "ngIf"], [1, "payment-container"], [3, "imageSrc", 4, "ngIf"], [1, "row-container"], [1, "column-container", "pmt-method-heading"], [1, "border-solid"], [1, "column-container"], ["id", "paymentMethodSaved", "name", "paymentMethods", "value", "SAVED", "label", "Saved Payment Methods", 3, "change", "checked"], [3, "formGroup", 4, "ngIf"], ["id", "paymentMethodNew", "name", "paymentMethods", "value", "NEW", "label", "Add a New Payment Method", 3, "change", "checked"], [1, "column-container-left"], ["validation", "eager", 1, "payment-new-dropdown", 3, "change", "items", "selectValue", "multiple", "disabled"], ["class", "column-container align-center", 4, "ngIf"], ["class", "row-container", 4, "ngIf"], [3, "formGroup"], [1, "row-container", "top-solid"], [1, "column-container-sm"], ["label", "", 1, "ac-checkbox", 3, "change"], [1, "flex-row-container", "btns-right-align"], ["rs-button", "", 2, "width", "auto", 3, "click"], ["rs-raised-button", "", "color", "primary", 1, "btn-align", 2, "width", "auto", 3, "click", "disabled"], ["class", "error", 4, "ngIf"], [3, "imageSrc"], [1, "column-container-padding"], ["formControlName", "selectedSavedPaymentMethod", "validation", "eager", 1, "dropdown-content", 3, "change", "items", "selectValue", "multiple"], ["formControlName", "emailAddress", "label", "Email", "validation", "eager"], [1, "column-container", "align-center"], ["id", "savePmtCheckbox", "label", "Save Payment Method to Accounts", 1, "ac-checkbox", 3, "change"], [1, "column-container-padding", "pmt-method-heading"], [1, "eft-container-no-padding"], [1, "row-container", "name-padding"], ["formControlName", "nameOnCard", "label", "Name on Account", "validation", "eager"], [1, "row-container", "eft-padding"], ["formControlName", "routingNumber", "label", "Routing Number", "validation", "eager"], [1, "eft-container-right"], ["formControlName", "reTypeRoutingNumber", "label", "Re-type Routing Number", "validation", "eager"], ["formControlName", "accountNumber", "label", "Account Number", "validation", "eager"], ["formControlName", "reTypeAccountNumber", "label", "Re-type Account Number", "validation", "eager"], [1, "row-container", "check-image-center"], ["src", "assets/images/check_sample.gif"], ["formControlName", "nameOnCreditCard", "label", "Name on Card", "validation", "eager"], [1, "form-group", 3, "hidden"], ["for", "card-element"], ["id", "card-element", 1, "form-control", "credit-card-container", 3, "stripe"], ["id", "card-errors", "role", "alert"], [1, "error"]], template: function PaymentComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, PaymentComponent_div_0_Template, 38, 18, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isConfirmPaymentEnable);
        } }, dependencies: [i3$1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i6$1.SelectComponent, i7$1.CheckboxComponent, i2.FormGroupDirective, i2.FormControlName, i8.InputComponent, i9.RadioComponent, i5.ButtonComponent, i7.LoaderComponent, i4$2.StripeCardComponent], styles: [".payment-container[_ngcontent-%COMP%]{padding:0}.payment-container[_ngcontent-%COMP%]   .payment-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{background-color:#f1f1f1;margin:1px;padding:10px;font-size:16px}.payment-container[_ngcontent-%COMP%]   .row-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:700;padding:0 2px}.payment-container[_ngcontent-%COMP%]   .column-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:12px;padding:8px 0 0 15px}.payment-container[_ngcontent-%COMP%]   .column-container-padding[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:12px;padding:0 50% 0 15px}.payment-container[_ngcontent-%COMP%]   .column-container-sm[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:10%;flex:1;font-size:12px;width:100%;max-width:2em;padding:0 0 0 10px}.payment-container[_ngcontent-%COMP%]   .eft-padding[_ngcontent-%COMP%], .payment-container[_ngcontent-%COMP%]   .name-padding[_ngcontent-%COMP%]{padding:0 5px 0 1px}.payment-container[_ngcontent-%COMP%]   .check-image-center[_ngcontent-%COMP%]{padding:20px 10% 10px}.payment-container[_ngcontent-%COMP%]   .eft-container-right[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:50%;font-weight:700;font-size:12px;padding:8px 2px 0 4px}.payment-container[_ngcontent-%COMP%]   .column-container-left[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:50%;padding:8px 0 0 17px}.payment-container[_ngcontent-%COMP%]   .eft-container-no-padding[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:14px;padding:0}.payment-container[_ngcontent-%COMP%]   .border-solid[_ngcontent-%COMP%]{border-right:1px solid rgb(194,191,191);border-left:1px solid rgb(194,191,191);border-top:1px solid rgb(194,191,191);border-bottom:1px solid rgb(194,191,191);margin-bottom:2px;margin-top:5px}.payment-container[_ngcontent-%COMP%]   .font-gray[_ngcontent-%COMP%]{color:#919191;margin:20px px 0px 0px}.payment-container[_ngcontent-%COMP%]   .btns-right-align[_ngcontent-%COMP%]{padding:5px 0 0 69%;margin-top:10px;margin-bottom:10px;display:flex;border-top:1px solid rgb(194,191,191);justify-content:flex-start}.payment-container[_ngcontent-%COMP%]   .top-solid[_ngcontent-%COMP%]{margin-top:10px;border-top:1px solid rgb(194,191,191)}.payment-container[_ngcontent-%COMP%]   .align-center[_ngcontent-%COMP%]{margin-top:15px}.payment-container[_ngcontent-%COMP%]   .pmt-method-heading[_ngcontent-%COMP%]{font-weight:700;font-size:15px;padding:2px 0 7px 5px}.payment-container[_ngcontent-%COMP%]   .failed[_ngcontent-%COMP%]{background-color:#e7653d}.payment-container[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:14px;color:#e01e5a;overflow-x:auto;border:1px solid}.payment-container[_ngcontent-%COMP%]   .credit-card-container[_ngcontent-%COMP%]{display:block;width:100%;height:42px;padding:12px 12px 31px 2px;line-height:1.42857143;margin:4px 0 20px;color:#222;background-color:#f7f8fa;background-image:none;border:1px;border-style:solid;border-radius:4px;box-shadow:inset 0 1px 1px #00000014;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentComponent, [{
        type: Component,
        args: [{ selector: 'billing-payment', template: "<div class=\"payment-container\" *ngIf=\"!isConfirmPaymentEnable\">\n    <rs-loader *ngIf=\"(isFetching || isFetchingPayment || isFetchingAddCustomerPaymentProfile || isFetchingCustomerPaymentProfiles)\" [imageSrc]=\"loaderImage\"></rs-loader>\n    <div class=\"row-container\">\n        <div class=\"column-container pmt-method-heading\">\n            Select Payment Method\n        </div>\n    </div>\n    <div class=\"border-solid\">\n        <div class=\"row-container\">\n            <div class=\"column-container\">\n                <rs-radio id=\"paymentMethodSaved\" name=\"paymentMethods\" value=\"SAVED\" label=\"Saved Payment Methods\"\n                    [checked]=\"isSavedPaymentEnabled\" (change)=\"selectedSavedPaymentMethods();\">\n                </rs-radio>\n            </div>\n        </div>\n        <form [formGroup]=\"savedPaymentMethodForm\" *ngIf=\"isSavedPaymentEnabled\">\n            <div class=\"row-container\">\n                <div class=\"column-container-padding\">\n                    <rs-select class=\"dropdown-content\" formControlName=\"selectedSavedPaymentMethod\" [items]=\"savedPaymentMethods\" [selectValue]=\"selectedSavedPaymentMethod\" [multiple]=\"false\" validation=\"eager\"\n                         (change)=\"selectedSavedPaymentProfile($event);\">\n                </rs-select>\n                </div>\n            </div>\n            <div class=\"row-container\">\n                <div class=\"column-container-padding\">\n                    <rs-input formControlName=\"emailAddress\" label=\"Email\" validation=\"eager\"></rs-input>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"border-solid\">\n        <div class=\"row-container\">\n            <div class=\"column-container\">\n                <rs-radio id=\"paymentMethodNew\" name=\"paymentMethods\" value=\"NEW\" label=\"Add a New Payment Method\"\n                    [checked]=\"!isSavedPaymentEnabled\" (change)=\"selectedNewPaymentMethod();\">\n                </rs-radio>\n            </div>\n        </div>\n        <div class=\"row-container\">\n            <div class=\"column-container-left\">\n                <rs-select class=\"payment-new-dropdown\" [items]=\"newPaymentMethods\" [selectValue]=\"selectedPaymentMethod\" [multiple]=\"false\"\n                    validation=\"eager\" [disabled]=\"isSavedPaymentEnabled\" (change)=\"selectedNewPaymentOption($event);\">\n                </rs-select>\n            </div>\n            <div class=\"column-container align-center\" *ngIf=\"selectedPaymentMethod\">\n                <rs-checkbox id=\"savePmtCheckbox\" class=\"ac-checkbox\" label=\"Save Payment Method to Accounts\"\n                    (change)=\"savePaymentMethodCheck = $event.target.checked\">\n                </rs-checkbox>\n            </div>\n        </div>\n        <div class=\"row-container\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_ACH || selectedPaymentMethod === BillingConstants.PAYMENT_SAVING\">\n            <div class=\"column-container-padding pmt-method-heading\">\n                Bank Information\n            </div>\n        </div>\n        <form [formGroup]=\"eftForm\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_ACH || selectedPaymentMethod === BillingConstants.PAYMENT_SAVING\">\n            <div class=\"row-container\">\n                <div class=\"eft-container-no-padding\">\n                    <div class=\"row-container name-padding\">\n                        <div class=\"column-container\">\n                            <rs-input formControlName=\"nameOnCard\" label=\"Name on Account\" validation=\"eager\"></rs-input>\n                        </div>\n                    </div>\n                    <div class=\"row-container name-padding\">\n                        <div class=\"column-container\">\n                            <rs-input formControlName=\"emailAddress\" label=\"Email\" validation=\"eager\"></rs-input>\n                        </div>\n                    </div>   \n                    <div class=\"row-container eft-padding\">\n                        <div class=\"column-container\">\n                            <rs-input formControlName=\"routingNumber\" label=\"Routing Number\" validation=\"eager\">\n                            </rs-input>\n                        </div>\n                        <div class=\"eft-container-right\">\n                            <rs-input formControlName=\"reTypeRoutingNumber\" label=\"Re-type Routing Number\"\n                                validation=\"eager\"></rs-input>\n                        </div>\n                    </div>\n                    <div class=\"row-container eft-padding\">\n                        <div class=\"column-container\">\n                            <rs-input formControlName=\"accountNumber\" label=\"Account Number\" validation=\"eager\">\n                            </rs-input>\n                        </div>\n                        <div class=\"eft-container-right\">\n                            <rs-input formControlName=\"reTypeAccountNumber\" label=\"Re-type Account Number\"\n                                validation=\"eager\"></rs-input>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"column-container\">\n                    <div class=\"row-container check-image-center\">\n                        <img src=\"assets/images/check_sample.gif\">\n                    </div>\n                </div>\n            </div>\n        </form>\n        <div class=\"row-container\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_CC\">\n            <div class=\"column-container-padding pmt-method-heading\">\n                Credit Card Information\n            </div>\n        </div>\n        <form [formGroup]=\"creditCardForm\">\n            <div class=\"row-container\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_CC\">\n                <div class=\"column-container-padding\">\n                    <rs-input formControlName=\"nameOnCreditCard\" label=\"Name on Card\" validation=\"eager\"></rs-input>\n                </div>\n            </div>\n            <div class=\"row-container\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_CC\">\n                <div class=\"column-container-padding\">\n                    <rs-input formControlName=\"emailAddress\" label=\"Email\" validation=\"eager\"></rs-input>\n                </div>\n            </div>        \n            <div class=\"row-container\" *ngIf=\"selectedPaymentMethod === BillingConstants.PAYMENT_CC\">   \n                <div class=\"column-container-padding\">\n                    <div class=\"form-group\" [hidden]=\"selectedPaymentMethod !== BillingConstants.PAYMENT_CC\">\n                        <label for=\"card-element\">Card Number</label>\n                        <ngx-stripe-card id=\"card-element\" class=\"form-control credit-card-container\" [stripe]=\"stripe\"></ngx-stripe-card>\n                        <div id=\"card-errors\" role=\"alert\"></div> \n                    </div>\n                </div> \n            </div>\n        </form>        \n    </div>\n    <div class=\"row-container top-solid\">\n        <div class=\"column-container-sm\">\n            <rs-checkbox class=\"ac-checkbox\" label=\"\" (change)=\"authorizeCheck=$event.target.checked\">\n            </rs-checkbox>\n        </div>\n        <div class=\"column-container\">\n            By clicking Submit, I agree to the following: I hereby authorize Delta Dental, its subsidiaries and\n            affiliates to initiate a one-time withdrawal (ACH) from the account indicated above.\n            I understand that I am responsible for any fees incurred due to my payment being rejected for processing by\n            my bank. Rejected payments may cause my account to become delinquent and a claims hold will be placed on my\n            account until outstanding invoices are paid in full.\n        </div>\n    </div>\n    <div class=\"flex-row-container btns-right-align\">\n        <button style=\"width: auto;\" rs-button (click)=\"closeDialog();\">CANCEL</button>\n        <button style=\"width: auto;\" rs-button (click)=\"backToInvoices();\">BACK</button>\n        <button style=\"width: auto;\" class=\"btn-align\" rs-raised-button color=\"primary\" [disabled]=\" isSavedPaymentEnabled ? (!authorizeCheck || !savedPaymentMethodForm.valid) : (!(selectedPaymentMethod === BillingConstants.PAYMENT_CC ? creditCardForm.valid : eftForm.valid) || !authorizeCheck)\"\n            (click)=\"submitPayment();\">SUBMIT</button>\n    </div>\n    <div class =\"error\" *ngIf=\"addCustomerProfileError || addCustomerPaymentProfileError || customerPaymentProfileError || merchantAccountError || paymentError || stripeTokenError\" >\n        {{addCustomerProfileError || addCustomerPaymentProfileError || customerPaymentProfileError || merchantAccountError || paymentError || stripeTokenError}}\n    </div>\n</div>\n", styles: [".payment-container{padding:0}.payment-container .payment-container>div{background-color:#f1f1f1;margin:1px;padding:10px;font-size:16px}.payment-container .row-container{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:700;padding:0 2px}.payment-container .column-container{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:12px;padding:8px 0 0 15px}.payment-container .column-container-padding{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:12px;padding:0 50% 0 15px}.payment-container .column-container-sm{display:flex;flex-direction:column;flex-basis:10%;flex:1;font-size:12px;width:100%;max-width:2em;padding:0 0 0 10px}.payment-container .eft-padding,.payment-container .name-padding{padding:0 5px 0 1px}.payment-container .check-image-center{padding:20px 10% 10px}.payment-container .eft-container-right{display:flex;flex-direction:column;width:50%;font-weight:700;font-size:12px;padding:8px 2px 0 4px}.payment-container .column-container-left{display:flex;flex-direction:column;width:50%;padding:8px 0 0 17px}.payment-container .eft-container-no-padding{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:14px;padding:0}.payment-container .border-solid{border-right:1px solid rgb(194,191,191);border-left:1px solid rgb(194,191,191);border-top:1px solid rgb(194,191,191);border-bottom:1px solid rgb(194,191,191);margin-bottom:2px;margin-top:5px}.payment-container .font-gray{color:#919191;margin:20px px 0px 0px}.payment-container .btns-right-align{padding:5px 0 0 69%;margin-top:10px;margin-bottom:10px;display:flex;border-top:1px solid rgb(194,191,191);justify-content:flex-start}.payment-container .top-solid{margin-top:10px;border-top:1px solid rgb(194,191,191)}.payment-container .align-center{margin-top:15px}.payment-container .pmt-method-heading{font-weight:700;font-size:15px;padding:2px 0 7px 5px}.payment-container .failed{background-color:#e7653d}.payment-container .error{font-family:monospace;font-weight:700;padding:14px;color:#e01e5a;overflow-x:auto;border:1px solid}.payment-container .credit-card-container{display:block;width:100%;height:42px;padding:12px 12px 31px 2px;line-height:1.42857143;margin:4px 0 20px;color:#222;background-color:#f7f8fa;background-image:none;border:1px;border-style:solid;border-radius:4px;box-shadow:inset 0 1px 1px #00000014;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }, { type: i2.UntypedFormBuilder }, { type: i4$2.StripeFactoryService }], { card: [{
            type: ViewChild,
            args: [StripeCardComponent]
        }], paymentDilogClosed: [{
            type: Output
        }], loaderImage: [{
            type: Input
        }], paymentFeed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentComponent, { className: "PaymentComponent", filePath: "lib/billing/payment/payment.component.ts", lineNumber: 31 }); })();

class PaymentConfirmationComponent {
    get paymentConfirmationFeed() {
        return this._paymentConfirmationFeed;
    }
    set paymentConfirmationFeed(val) {
        this._paymentConfirmationFeed = val;
        if (val) {
        }
    }
    constructor() {
        this.paymentConfirmDilogClosed = new EventEmitter();
        this.loaderImage = '';
    }
    ngOnInit() {
    }
    closeDialog() {
        this.paymentConfirmDilogClosed.emit(true);
    }
    static { this.ɵfac = function PaymentConfirmationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaymentConfirmationComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentConfirmationComponent, selectors: [["billing-payment-confirmation"]], inputs: { loaderImage: "loaderImage", paymentConfirmationFeed: "paymentConfirmationFeed" }, outputs: { paymentConfirmDilogClosed: "paymentConfirmDilogClosed" }, decls: 27, vars: 4, consts: [[1, "payment-confirm-container"], [1, "pmt-confirm-heading"], [1, "pmt-confirm-msg"], ["rs-raised-button", "", "color", "primary", 1, "btns-center-align", 3, "click"]], template: function PaymentConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2, " Request Submitted");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtext(4, " Payment registration has been submitted on the behalf of the following account:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div")(6, "label");
            i0.ɵɵtext(7, "Confirmation Number ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span");
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div")(11, "label");
            i0.ɵɵtext(12, "Group ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "span");
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "div")(16, "label");
            i0.ɵɵtext(17, "Receive Date ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "span");
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div")(21, "label");
            i0.ɵɵtext(22, " A confirmation email has been sent to ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "span");
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "button", 3);
            i0.ɵɵlistener("click", function PaymentConfirmationComponent_Template_button_click_25_listener() { return ctx.closeDialog(); });
            i0.ɵɵtext(26, "RETURN TO BILLING");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(9);
            i0.ɵɵtextInterpolate(ctx.paymentConfirmationFeed.confirmationNumber || "");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.paymentConfirmationFeed.groupName || "");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.paymentConfirmationFeed.receivedDate || "");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.paymentConfirmationFeed.emailAddress || "");
        } }, dependencies: [i5.ButtonComponent], styles: [".payment-confirm-container[_ngcontent-%COMP%]{padding:25px}.payment-confirm-container[_ngcontent-%COMP%]   .pmt-confirm-heading[_ngcontent-%COMP%]{font-weight:700;padding:10px;font-size:20px}.payment-confirm-container[_ngcontent-%COMP%]   .pmt-confirm-msg[_ngcontent-%COMP%]{font-weight:700;padding:15px}.payment-confirm-container[_ngcontent-%COMP%]   .btns-center-align[_ngcontent-%COMP%]{padding:5px 30px;margin-top:10px;margin-bottom:10px;width:100%;justify-content:flex-start}.payment-confirm-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:5px 0}.payment-confirm-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;color:#919191;width:40%;font-weight:700;padding:10px 10px 10px 50px}.payment-confirm-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{content:\":\"}.payment-confirm-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;font-weight:700;width:60%;font-size:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'billing-payment-confirmation', template: "<div class=\"payment-confirm-container\">\n    <div class=\"pmt-confirm-heading\"> Request Submitted</div>\n    <div class=\"pmt-confirm-msg\"> Payment registration has been submitted on the behalf of the following account:</div>\n    <div>\n        <label>Confirmation Number </label>\n        <span>{{paymentConfirmationFeed.confirmationNumber || ''}}</span>\n    </div>\n    <div>\n        <label>Group </label>\n        <span>{{paymentConfirmationFeed.groupName || ''}}</span>\n    </div>\n    <div>\n        <label>Receive Date </label>\n        <span>{{paymentConfirmationFeed.receivedDate || ''}}</span>\n    </div>\n    <div>\n        <label> A confirmation email has been sent to  </label>\n        <span>{{paymentConfirmationFeed.emailAddress || ''}}</span>\n    </div>\n   <button class=\"btns-center-align\" rs-raised-button color=\"primary\" (click)=\"closeDialog();\">RETURN TO BILLING</button>\n</div>\n", styles: [".payment-confirm-container{padding:25px}.payment-confirm-container .pmt-confirm-heading{font-weight:700;padding:10px;font-size:20px}.payment-confirm-container .pmt-confirm-msg{font-weight:700;padding:15px}.payment-confirm-container .btns-center-align{padding:5px 30px;margin-top:10px;margin-bottom:10px;width:100%;justify-content:flex-start}.payment-confirm-container div{padding:5px 0}.payment-confirm-container div label{display:inline-block;color:#919191;width:40%;font-weight:700;padding:10px 10px 10px 50px}.payment-confirm-container div label:after{content:\":\"}.payment-confirm-container div span{display:inline-block;font-weight:700;width:60%;font-size:1em}\n"] }]
    }], () => [], { paymentConfirmDilogClosed: [{
            type: Output
        }], loaderImage: [{
            type: Input
        }], paymentConfirmationFeed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentConfirmationComponent, { className: "PaymentConfirmationComponent", filePath: "lib/billing/payment-confirmation/payment-confirmation.component.ts", lineNumber: 9 }); })();

function PaymentInvoiceComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " View ");
    i0.ɵɵelementEnd();
} }
function PaymentInvoiceComponent_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "rs-select", 19);
    i0.ɵɵlistener("change", function PaymentInvoiceComponent_div_1_div_13_Template_rs_select_change_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.getInvoices($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", ctx_r1.viewTypes);
} }
function PaymentInvoiceComponent_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
} }
function PaymentInvoiceComponent_div_1_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 22);
    i0.ɵɵtext(2, " You may either select All Invoices to pay, or up to 100 invoices to pay. By selecting the top checkbox, all invoices will be selected. Or you can click on individual checkboxes (up to 100) to pay specifically. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23)(4, "div", 24)(5, "button", 25);
    i0.ɵɵlistener("click", function PaymentInvoiceComponent_div_1_div_15_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.paySelectedInvoices()); });
    i0.ɵɵtext(6, "PAY SELECTED INVOICES");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", !ctx_r1.showPaySelectedInvoices);
} }
function PaymentInvoiceComponent_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
} }
function PaymentInvoiceComponent_div_1_div_17_rs_loader_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "rs-loader", 35);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("imageSrc", ctx_r1.loaderImage);
} }
function PaymentInvoiceComponent_div_1_div_17_tbody_23_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "rs-checkbox", 37);
    i0.ɵɵlistener("change", function PaymentInvoiceComponent_div_1_div_17_tbody_23_tr_1_Template_rs_checkbox_change_2_listener() { const item_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.selectedSingleInvoice(item_r6)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !item_r6.selected && ctx_r1.disableUnSelected)("id", item_r6.invoiceNumber)("checked", item_r6.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.invoiceNumber || "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6.billType || "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", item_r6.clientSpecifiedIdentifier, " - ", item_r6.subclientSpecifiedIdentifier, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 11, item_r6.invoiceDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 14, item_r6.dueDate, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 17, item_r6.invoiceAmount));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 19, item_r6.remainingBalance));
} }
function PaymentInvoiceComponent_div_1_div_17_tbody_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, PaymentInvoiceComponent_div_1_div_17_tbody_23_tr_1_Template, 21, 21, "tr", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.invoiceResponse.invoices);
} }
function PaymentInvoiceComponent_div_1_div_17_table_24_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.invoiceResponse || "No Data found for the given request data.");
} }
function PaymentInvoiceComponent_div_1_div_17_table_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵtemplate(1, PaymentInvoiceComponent_div_1_div_17_table_24_div_1_Template, 2, 1, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMsg);
} }
function PaymentInvoiceComponent_div_1_div_17_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "rs-paginator", 39);
    i0.ɵɵlistener("page", function PaymentInvoiceComponent_div_1_div_17_div_25_Template_rs_paginator_page_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.pageChanged($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("length", ctx_r1.invoiceResponse.pagination.totalRecords)("pageSize", ctx_r1.defaultPageSize);
} }
function PaymentInvoiceComponent_div_1_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, PaymentInvoiceComponent_div_1_div_17_rs_loader_1_Template, 1, 1, "rs-loader", 28);
    i0.ɵɵelementStart(2, "table")(3, "thead")(4, "tr")(5, "th")(6, "div", 29)(7, "div", 30)(8, "rs-checkbox", 31);
    i0.ɵɵlistener("change", function PaymentInvoiceComponent_div_1_div_17_Template_rs_checkbox_change_8_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectedAllInvoices($event)); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Invoice #");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Invoice Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Group - Subgroup ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Invoice Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Due Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20, "Invoice Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "th");
    i0.ɵɵtext(22, "Total Amount");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(23, PaymentInvoiceComponent_div_1_div_17_tbody_23_Template, 2, 1, "tbody", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, PaymentInvoiceComponent_div_1_div_17_table_24_Template, 2, 1, "table", 2)(25, PaymentInvoiceComponent_div_1_div_17_div_25_Template, 2, 2, "div", 32);
    i0.ɵɵelementStart(26, "div", 33)(27, "button", 34);
    i0.ɵɵlistener("click", function PaymentInvoiceComponent_div_1_div_17_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeDialog()); });
    i0.ɵɵtext(28, "CANCEL");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "button", 25);
    i0.ɵɵlistener("click", function PaymentInvoiceComponent_div_1_div_17_Template_button_click_29_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.paySelectedInvoices()); });
    i0.ɵɵtext(30, "PAY SELECTED INVOICES");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFetching);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("checked", ctx_r1.allInvoicesSelected);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngIf", ctx_r1.invoiceResponse && ctx_r1.invoiceResponse.invoices && ctx_r1.invoiceResponse.invoices.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.invoiceResponse && !ctx_r1.invoiceResponse.invoices);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.invoiceResponse && ctx_r1.invoiceResponse.pagination && ctx_r1.invoiceResponse.pagination.totalRecords);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r1.showPaySelectedInvoices);
} }
function PaymentInvoiceComponent_div_1_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 40);
    i0.ɵɵtext(2, " Make a Payment for Selected Invoices ");
    i0.ɵɵelementEnd()();
} }
function PaymentInvoiceComponent_div_1_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "div", 4)(2, "div", 5);
    i0.ɵɵtext(3, " Selected Invoices ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtext(5, " Payment Amount ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 4)(7, "div", 9);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 18);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.allInvoicesSelected ? "All" : ctx_r1.selectedInvoices.size, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 2, ctx_r1.selectedInvoicesAmount), " ");
} }
function PaymentInvoiceComponent_div_1_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-payment", 42);
    i0.ɵɵlistener("paymentDilogClosed", function PaymentInvoiceComponent_div_1_ng_container_20_Template_billing_payment_paymentDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.paymentDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("paymentFeed", ctx_r1.paymentFeed)("loaderImage", ctx_r1.loaderImage);
} }
function PaymentInvoiceComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5);
    i0.ɵɵtext(3, " Group ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5, " Account Balance ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PaymentInvoiceComponent_div_1_div_6_Template, 2, 0, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, PaymentInvoiceComponent_div_1_div_13_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, PaymentInvoiceComponent_div_1_div_14_Template, 1, 0, "div", 11)(15, PaymentInvoiceComponent_div_1_div_15_Template, 7, 1, "div", 12)(16, PaymentInvoiceComponent_div_1_div_16_Template, 2, 1, "div", 13)(17, PaymentInvoiceComponent_div_1_div_17_Template, 31, 6, "div", 14)(18, PaymentInvoiceComponent_div_1_div_18_Template, 3, 0, "div", 15)(19, PaymentInvoiceComponent_div_1_div_19_Template, 12, 4, "div", 16)(20, PaymentInvoiceComponent_div_1_ng_container_20_Template, 2, 2, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", ctx_r1.isMakeAPaymentEnable ? "column-container" : "column-container border-right-solid");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.paymentInvoiceFeed.groupName || "", " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.isMakeAPaymentEnable ? "column-container" : "column-container border-right-solid");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 13, ctx_r1.amountDue), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMakeAPaymentEnable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMakeAPaymentEnable);
} }
function PaymentInvoiceComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-payment-confirmation", 43);
    i0.ɵɵlistener("paymentConfirmDilogClosed", function PaymentInvoiceComponent_ng_container_2_Template_billing_payment_confirmation_paymentConfirmDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.paymentConfirmDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("paymentConfirmationFeed", ctx_r1.paymentConfirmationFeed)("loaderImage", ctx_r1.loaderImage);
} }
class PaymentInvoiceComponent {
    get paymentInvoiceFeed() {
        return this._paymentInvoiceFeed;
    }
    set paymentInvoiceFeed(val) {
        this._paymentInvoiceFeed = val;
        if (val) {
            this.getInvoices('TOTAL_DUE');
        }
    }
    constructor(lux, bAsync) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.paymentInvoiceDilogClosed = new EventEmitter();
        this.loaderImage = '';
        this.openOptionsforRow = 0;
        this.luxId = 'billing-lib-payment-invoice-comp' + this.constructor.name;
        this.errorMsg$ = this.lux.get(error, this.luxId);
        this.isFetching$ = this.lux.get(isInvoiceFetching, this.luxId);
        this.accountBalance$ = this.lux.get(totalBalanceDueRes, this.luxId);
        this.totalBalanceErrorMessage$ = this.lux.get(totalBalanceErrorMessage, this.luxId);
        this.defaultPageSize = 50;
        this.allInvoicesSelected = false;
        this.selectedViewType = 'TOTAL_DUE';
        this.showExportSelectedInvoices = false;
        this.showPaySelectedInvoices = false;
        this.selectedInvoices = new Map();
        this.errorMessage = '';
        this.viewTypes = [
            { value: 'TOTAL_DUE', label: 'Total Account Balance' },
            { value: 'PAST_DUE', label: 'Past Due' },
            { value: 'FUTURE_DUE', label: 'Future Due' }
        ];
    }
    ngOnInit() {
        this.isFetching$.subscribe(x => this.isFetching = x);
        this.accountBalance$.subscribe(balance => {
            this.totalAmountDueResponse = balance;
            this.amountDue = this.totalAmountDueResponse.totalDue;
        });
        this.totalBalanceErrorMessage$.subscribe(errorMessage => this.totalBalanceErrorMessage = errorMessage);
        this.errorMsg$.subscribe(errorMessage => this.errorMsg = errorMessage);
    }
    getInvoiceSearchRequest() {
        this.invoiceRequest =
            {
                pagination: {
                    offset: 0,
                    limit: 50
                },
                planAcronym: this.paymentInvoiceFeed.planAcronym,
                payNow: false,
                filterType: '',
                remainingBalance: this.paymentInvoiceFeed.accountBalance,
                ...(this.paymentInvoiceFeed.subClientSpecifiedIdentifier
                    ? {
                        clientsSubclients: {
                            clientSpecifiedIdentifier: this.paymentInvoiceFeed.clientSpecifiedIdentifier,
                            subClientSpecifiedIdentifier: this.paymentInvoiceFeed.subClientSpecifiedIdentifier
                        }
                    }
                    : {
                        clientsSubclients: {
                            clientSpecifiedIdentifier: this.paymentInvoiceFeed.clientSpecifiedIdentifier
                        }
                    }),
                startDate: this.paymentInvoiceFeed.startDate ? this.paymentInvoiceFeed.startDate : '',
                endDate: this.paymentInvoiceFeed.endDate ? this.paymentInvoiceFeed.endDate : ''
            };
        return this.invoiceRequest;
    }
    getInvoices(viewType) {
        if (viewType) {
            this.selectedViewType = viewType;
            this.showPaySelectedInvoices = false;
            this.showExportSelectedInvoices = false;
            this.errorMessage = '';
            this.invoiceResponse = '';
            this.getInvoiceRecords(this.getInvoiceSearchRequest(), viewType);
            this.amountDue = viewType === 'TOTAL_DUE' ? this.totalAmountDueResponse?.totalDue
                : (viewType === 'PAST_DUE' ? this.totalAmountDueResponse.pastDue
                    : this.totalAmountDueResponse.futureDue);
            this.showDialog = true;
            this.allInvoicesSelected = false;
            this.showPaySelectedInvoices = (this.selectedInvoices && this.selectedInvoices.size > 0);
        }
    }
    getInvoiceRecords(val, filterType) {
        this.invoiceResponse = '';
        this.invoiceRequest.filterType = filterType;
        this.lux.set(state => state.billing, { invoiceRequest: val });
        this.bAsync.getInvoiceRecords(true).subscribe(invoices => {
            this.invoiceResponse = invoices;
            this.setInvoicesChecked();
            this.isFetching = false;
        });
        this.showDialog = true;
    }
    selectedAllInvoices(event) {
        this.allInvoicesSelected = event.target.checked;
        this.disableUnSelected = false;
        this.selectedInvoices = new Map();
        this.errorMessage = '';
        if (this.invoiceResponse.invoices && this.invoiceResponse.invoices.length > 0) {
            this.invoiceResponse.invoices.forEach(invoice => invoice.selected = event.target.checked);
            this.showPaySelectedInvoices = true;
            this.showExportSelectedInvoices = false; // TODO set to true when we implement the export functionality
        }
        else {
            this.showPaySelectedInvoices = false;
            this.showExportSelectedInvoices = false;
        }
    }
    selectedSingleInvoice(selectedInvoice) {
        this.allInvoicesSelected = false;
        this.errorMessage = '';
        if (!this.selectedInvoices.has(selectedInvoice.invoiceNumber)) {
            this.selectedInvoices.set(selectedInvoice.invoiceNumber, selectedInvoice);
        }
        else {
            this.selectedInvoices.delete(selectedInvoice.invoiceNumber);
        }
        if (this.selectedInvoices.size > 0) {
            this.showPaySelectedInvoices = true;
            this.showExportSelectedInvoices = false; // TODO set to true when we implement the export functionality
            this.disableUnSelected = this.selectedInvoices.size >= 100;
        }
        else {
            this.showPaySelectedInvoices = false;
            this.showExportSelectedInvoices = false;
        }
        this.setInvoicesChecked();
    }
    exportSelectedInvoices() {
    }
    isMultipleBusinessExists() {
        let businessUnits = [];
        if (this.allInvoicesSelected) {
            businessUnits = this.invoiceResponse.businessUnitDepartmentIDs.map(value => value.businessUnit);
        }
        else {
            businessUnits = Array.from(this.selectedInvoices, ([key, value]) => {
                return value.businessUnit;
            });
        }
        const businessUnitsSet = new Set(businessUnits);
        return (businessUnitsSet.size > 1);
    }
    paySelectedInvoices() {
        if (this.isMultipleBusinessExists()) {
            this.errorMessage = 'Payment Attempted for Multiple Businesses. Please contact Customer Support for help.';
        }
        else {
            this.errorMessage = '';
            this.selectedInvoicesAmount = this.allInvoicesSelected ? this.amountDue : this.calculateSelectedInvoicesAmont();
            if (this.selectedInvoicesAmount && this.selectedInvoicesAmount <= 0) {
                this.errorMessage = 'Payment Attempted for invalid amount : ' + this.selectedInvoicesAmount + '. Please contact Customer Support for help.';
            }
            else {
                this.paymentFeed = {
                    adminPlan: this.paymentInvoiceFeed.adminPlan,
                    planAcronym: this.paymentInvoiceFeed.planAcronym,
                    clientSpecifiedIdentifier: this.paymentInvoiceFeed.clientSpecifiedIdentifier,
                    subClientSpecifiedIdentifier: this.paymentInvoiceFeed.subClientId,
                    startDate: this.paymentInvoiceFeed.startDate,
                    endDate: this.paymentInvoiceFeed.endDate,
                    groupName: this.paymentInvoiceFeed.groupName,
                    amount: this.selectedInvoicesAmount,
                    selectedInvoices: this.selectedInvoices,
                    businessUnitDepartmentIDs: this.invoiceResponse.businessUnitDepartmentIDs,
                    businessUnit: this.paymentInvoiceFeed.businessUnit,
                    filterType: this.selectedViewType,
                    email: this.paymentInvoiceFeed.email,
                    appName: this.paymentInvoiceFeed.appName,
                    allInvoicesSelected: this.allInvoicesSelected
                };
                this.isMakeAPaymentEnable = true;
            }
        }
    }
    calculateSelectedInvoicesAmont() {
        let amount = '0';
        this.selectedInvoices.forEach((value, key) => {
            amount = amount * 1 + value.remainingBalance * 1;
        });
        return amount;
    }
    pageChanged(page) {
        this.getMoreRecords(page.pageIndex >= 1 ? (page.pageIndex * this.defaultPageSize) + 1 : 0);
    }
    getMoreRecords(offsetRequest) {
        this.lux.set(state => state.billing.invoiceRequest.pagination, { offset: offsetRequest });
        this.bAsync.getInvoiceRecords(true).subscribe(x => {
            this.invoiceResponse = x;
            this.setInvoicesChecked();
        });
    }
    setInvoicesChecked() {
        if (this.invoiceResponse.invoices && this.invoiceResponse.invoices.length > 0) {
            this.invoiceResponse.invoices.forEach(invoice => {
                invoice.selected = this.allInvoicesSelected ? invoice.selected = true :
                    (this.selectedInvoices && this.selectedInvoices.size > 0) ?
                        this.selectedInvoices.has(invoice.invoiceNumber) : false;
            });
        }
    }
    paymentConfirmation(event) {
        this.selectedInvoicesAmount = this.allInvoicesSelected ? this.amountDue : this.calculateSelectedInvoicesAmont();
        this.paymentConfirmationFeed = {
            adminPlan: this.paymentInvoiceFeed.adminPlan,
            planAcronym: this.paymentInvoiceFeed.planAcronym,
            clientSpecifiedIdentifier: this.paymentInvoiceFeed.clientSpecifiedIdentifier,
            subClientSpecifiedIdentifier: this.paymentInvoiceFeed.subClientId,
            startDate: this.paymentInvoiceFeed.startDate,
            endDate: this.paymentInvoiceFeed.endDate,
            groupName: this.paymentInvoiceFeed.groupName,
            amount: this.paymentInvoiceFeed.accountBalance,
            businessUnit: this.paymentInvoiceFeed.businessUnit,
            emailAddress: event.receiptEmail,
            confirmationNumber: event.chargeId,
            receivedDate: moment(new Date()).format('MM/DD/YYYY')
        };
        this.isMakeAPaymentEnable = false;
        this.isPaymentConfirmationEnable = true;
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    paymentDilogClosed(event) {
        if (event === null || event === undefined) {
            this.closeDialog();
        }
        else if (event === 'BACK') {
            this.showDialog = true;
            this.isMakeAPaymentEnable = false;
            this.isPaymentConfirmationEnable = false;
        }
        else {
            this.paymentConfirmation(event);
        }
    }
    paymentConfirmDilogClosed(event) {
        this.paymentFeed = '';
        this.paymentConfirmationFeed = '';
        this.paymentInvoiceDilogClosed.emit(event);
        this.showDialog = false;
    }
    dialogClose(event) {
        this.invoiceResponse = '';
        this.paymentInvoiceDilogClosed.emit(event);
        this.showDialog = false;
    }
    closeDialog() {
        this.invoiceResponse = '';
        this.paymentInvoiceDilogClosed.emit(true);
        this.showDialog = false;
    }
    static { this.ɵfac = function PaymentInvoiceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaymentInvoiceComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentInvoiceComponent, selectors: [["billing-payment-invoice"]], inputs: { loaderImage: "loaderImage", paymentInvoiceFeed: "paymentInvoiceFeed" }, outputs: { paymentInvoiceDilogClosed: "paymentInvoiceDilogClosed" }, decls: 3, vars: 4, consts: [["maxWidth", "75%", 3, "visibleChange", "visible", "heading"], ["class", "payment-invoice-container", 4, "ngIf"], [4, "ngIf"], [1, "payment-invoice-container"], [1, "row-container"], [1, "double-column-container", "font-gray", "border-right-solid"], [3, "ngClass"], ["class", "column-container font-gray", 4, "ngIf"], [1, "row-container", "border-bottom-solid"], [1, "double-column-container", "border-right-solid"], ["class", "column-container", 4, "ngIf"], ["class", "straight-line", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "error-message", 4, "ngIf"], ["class", "search-results-content", 4, "ngIf"], ["class", "row-container", 4, "ngIf"], ["class", "border-solid", 4, "ngIf"], [1, "column-container", "font-gray"], [1, "column-container"], ["label", "", "selectValue", "TOTAL_DUE", "validation", "eager", 1, "view-dropdown", 3, "change", "items"], [1, "straight-line"], [1, "row"], [1, "double-column-container", "font-gray"], [1, "double-column-container"], [1, "flex-row", "btn-pay-selected"], ["rs-raised-button", "", "color", "primary", 1, "btn-align", 2, "width", "auto", 3, "click", "disabled"], [1, "error-message"], [1, "search-results-content"], [3, "imageSrc", 4, "ngIf"], [1, "top-links"], [1, "top-link-check"], ["id", "allInvoices", "label", "", 3, "change", "checked"], ["class", "billing-pagination", 4, "ngIf"], [1, "flex-row", "btns-right-align"], ["rs-button", "", 2, "width", "auto", 3, "click"], [3, "imageSrc"], [4, "ngFor", "ngForOf"], ["name", "invoice", 3, "change", "disabled", "id", "checked"], [1, "billing-pagination"], ["showFirstLastButtons", "", 3, "page", "length", "pageSize"], [1, "double-column"], [1, "border-solid"], [3, "paymentDilogClosed", "paymentFeed", "loaderImage"], [3, "paymentConfirmDilogClosed", "paymentConfirmationFeed", "loaderImage"]], template: function PaymentInvoiceComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "rs-dialog", 0);
            i0.ɵɵlistener("visibleChange", function PaymentInvoiceComponent_Template_rs_dialog_visibleChange_0_listener($event) { return ctx.dialogClose($event); });
            i0.ɵɵtemplate(1, PaymentInvoiceComponent_div_1_Template, 21, 15, "div", 1)(2, PaymentInvoiceComponent_ng_container_2_Template, 2, 2, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("visible", ctx.showDialog)("heading", ctx.isMakeAPaymentEnable ? "Make a One-time Payment" : ctx.isPaymentConfirmationEnable ? "Payment Confirmation" : "Select Invoices");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isPaymentConfirmationEnable);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isPaymentConfirmationEnable);
        } }, dependencies: [i3$1.NgClass, i3$1.NgForOf, i3$1.NgIf, i4.PaginatorComponent, i6$1.SelectComponent, i7$1.CheckboxComponent, i5.ButtonComponent, i6.DialogComponent, i7.LoaderComponent, PaymentComponent, PaymentConfirmationComponent, i3$1.CurrencyPipe, i3$1.DatePipe], styles: [".payment-invoice-container[_ngcontent-%COMP%]{padding:0 25px 10px}.payment-invoice-container[_ngcontent-%COMP%]   .payment-invoice-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{background-color:#f1f1f1;margin:10px;padding:20px;font-size:30px}.row-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:700;padding:0 20px 0 0}.column-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:14px;padding:1px 0 1px 10px}.double-column-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:2;font-size:14px;padding:3px 20px}.font-gray[_ngcontent-%COMP%]{color:#919191;margin:20px px 0px 0px}.border-bottom-solid[_ngcontent-%COMP%]{border-bottom:1px solid rgb(194,191,191)}.border-right-solid[_ngcontent-%COMP%]{border-right:1px solid rgb(194,191,191)}.border-solid[_ngcontent-%COMP%]{border-right:1px solid rgb(194,191,191);border-left:1px solid rgb(194,191,191);border-top:1px solid rgb(194,191,191);border-bottom:1px solid rgb(194,191,191);margin-top:10px}.btn-pay-selected[_ngcontent-%COMP%]{padding:3px 0 0 54%;margin-top:0;display:flex;justify-content:flex-start}.btns-right-align[_ngcontent-%COMP%]{padding:5px 0 0 70%;margin-top:0;display:flex;justify-content:flex-start}.btn-align[_ngcontent-%COMP%]{margin-left:10px;font-size:10px;padding:5px 9px}.search-results-content[_ngcontent-%COMP%]{margin-bottom:10px}.search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 5px;width:100px}.search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0c6ac7;text-decoration:none;cursor:pointer}.search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{vertical-align:middle}.search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.search-results-content[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #c2c2c2;border-collapse:collapse;width:99%;margin-left:5px}.search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}.top-links[_ngcontent-%COMP%]{padding:0 -2px 0 5px;display:flex;justify-content:space-between}.top-links[_ngcontent-%COMP%]   .top-links-left[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;border-bottom:1px solid #f9981c;padding-bottom:5px;cursor:pointer}.top-links[_ngcontent-%COMP%]   .top-link-check[_ngcontent-%COMP%]{flex:1;margin-left:2px}.top-links[_ngcontent-%COMP%]   .top-links-right[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding-bottom:5px}.top-links[_ngcontent-%COMP%]   .top-links-left-pg[_ngcontent-%COMP%]{color:#4b4c4d;padding-bottom:5px;cursor:pointer;padding-top:20px}.top-links[_ngcontent-%COMP%]   .top-links-right-pg[_ngcontent-%COMP%]{color:#0c6ac7;padding-bottom:5px}.invoice-pagination[_ngcontent-%COMP%]{margin:2px 0 0 30px}.error-message[_ngcontent-%COMP%]{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px}[_nghost-%COMP%]     .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentInvoiceComponent, [{
        type: Component,
        args: [{ selector: 'billing-payment-invoice', template: "<rs-dialog [visible]=\"showDialog\" maxWidth=\"75%\" (visibleChange)=\"dialogClose($event)\" [heading]=\"isMakeAPaymentEnable ? 'Make a One-time Payment' : (isPaymentConfirmationEnable ? 'Payment Confirmation' : 'Select Invoices')\">\n    <div class=\"payment-invoice-container\" *ngIf=\"!isPaymentConfirmationEnable\">\n        <div class=\"row-container\">\n            <div class=\"double-column-container font-gray border-right-solid\">\n                Group\n            </div>\n            <div [ngClass]=\"isMakeAPaymentEnable ? 'column-container' : 'column-container border-right-solid'\">\n                Account Balance\n            </div>\n            <div class=\"column-container font-gray\" *ngIf=\"!isMakeAPaymentEnable\">\n                View\n            </div>\n        </div>\n        <div class=\"row-container border-bottom-solid\">\n            <div class=\"double-column-container border-right-solid\">\n                {{paymentInvoiceFeed.groupName || ''}}\n            </div>\n            <div [ngClass]=\"isMakeAPaymentEnable ? 'column-container' : 'column-container border-right-solid'\">\n                {{ (amountDue) | currency }}\n            </div>\n            <div class=\"column-container\" *ngIf=\"!isMakeAPaymentEnable\">\n                <rs-select class=\"view-dropdown\" [items]=\"viewTypes\" label=\"\" selectValue=\"TOTAL_DUE\" validation=\"eager\" (change)=\"getInvoices($event)\">\n                </rs-select>\n            </div>\n        </div>    \n        <div *ngIf=\"!isMakeAPaymentEnable\" class=\"straight-line\"></div>\n        <div *ngIf=\"!isMakeAPaymentEnable\" class=\"row\">\n            <div class=\"double-column-container font-gray\">\n                You may either select All Invoices to pay, or up to 100 invoices to pay.\n                    By selecting the top checkbox, all invoices will be selected. Or you can click on individual \n                    checkboxes (up to 100) to pay specifically.\n            </div>\n            <div class=\"double-column-container\">\n                <div class=\"flex-row btn-pay-selected\">\n                    <button style=\"width: auto;\" class=\"btn-align\" rs-raised-button color=\"primary\" (click)=\"paySelectedInvoices();\" [disabled]=\"!showPaySelectedInvoices\">PAY SELECTED INVOICES</button>\n                </div>\n            </div>\n        </div>\n        <div class =\"error-message\" *ngIf=\"errorMessage\" >\n            {{errorMessage}}\n        </div>   \n        <div *ngIf=\"!isMakeAPaymentEnable\" class=\"search-results-content\">\n            <rs-loader *ngIf=\"isFetching\" [imageSrc]=\"loaderImage\"></rs-loader>\n                <table>\n                    <thead>\n                        <tr>\n                            <th>\n                                <div class=\"top-links\">\n                                    <div  class=\"top-link-check\">\n                                        <rs-checkbox (change)=\"selectedAllInvoices($event)\" [checked] =\"allInvoicesSelected\" id=\"allInvoices\" label=\"\">\n                                        </rs-checkbox>\n                                    </div>\n                                </div>\n                            </th>\n                            <th>Invoice #</th>\n                            <th>Invoice Type</th>\n                            <th>Group - Subgroup ID</th>\n                            <th>Invoice Date</th>\n                            <th>Due Date</th>\n                            <th>Invoice Amount</th>\n                            <th>Total Amount</th>\n                        </tr>\n                    </thead>\n                    <tbody  *ngIf=\"invoiceResponse && invoiceResponse.invoices && invoiceResponse.invoices.length > 0\">\n                        <tr *ngFor=\"let item of invoiceResponse.invoices; let i = index\">\n                            <td>\n                                <rs-checkbox [disabled]=\"!item.selected && disableUnSelected\" name=\"invoice\" [id]=\"item.invoiceNumber\"\n                                  [checked]=\"item.selected\" (change)=\"selectedSingleInvoice(item)\">\n                                </rs-checkbox>\n                              </td>\n                            <td>{{item.invoiceNumber || ''}}</td>\n                            <td>{{item.billType || ''}}</td>\n                            <td>{{item.clientSpecifiedIdentifier}} - {{item.subclientSpecifiedIdentifier}}</td>\n                            <td>{{(item.invoiceDate | date: 'MM/dd/yyyy') || ''}}</td>\n                            <td>{{(item.dueDate | date: 'MM/dd/yyyy') || ''}}</td>\n                            <td>{{(item.invoiceAmount)| currency}}</td>\n                            <td>{{(item.remainingBalance) | currency}}</td>\n                        </tr>\n                    </tbody>\n                </table>    \n                <table *ngIf=\"invoiceResponse && !invoiceResponse.invoices\">\n                    <div *ngIf=\"errorMsg\" class=\"error-message\">{{invoiceResponse || 'No Data found for the given request data.'}}</div>    \n                </table>\n            <div *ngIf=\"invoiceResponse && invoiceResponse.pagination && invoiceResponse.pagination.totalRecords\"\n                class=\"billing-pagination\">\n                <rs-paginator  [length]=\"invoiceResponse.pagination.totalRecords\" showFirstLastButtons\n                    (page)=\"pageChanged($event)\" [pageSize]=\"defaultPageSize\"></rs-paginator>\n            </div>\n            <div class=\"flex-row btns-right-align\">\n                <button style=\"width: auto;\" rs-button (click)=\"closeDialog();\">CANCEL</button>\n                <!-- TODO enable when implement export functionality <button style=\"width: auto;\" class=\"btn-align\" rs-raised-button color=\"primary\" (click)=\"exportSelectedInvoices();\" [disabled]=\"!showExportSelectedInvoices\">EXPORT SELECTED INVOICES</button> -->\n                <button style=\"width: auto;\" class=\"btn-align\" rs-raised-button color=\"primary\" (click)=\"paySelectedInvoices();\" [disabled]=\"!showPaySelectedInvoices\">PAY SELECTED INVOICES</button>\n            </div>\n        </div>\n        <div *ngIf=\"isMakeAPaymentEnable\" class=\"row-container\">\n            <div class=\"double-column\">\n                Make a Payment for Selected Invoices\n            </div>\n        </div>\n        <div *ngIf=\"isMakeAPaymentEnable\" class=\"border-solid\">\n            <div class=\"row-container\">\n                <div class=\"double-column-container font-gray border-right-solid\">\n                    Selected Invoices\n                </div>\n                <div class=\"column-container font-gray\">\n                    Payment Amount\n                </div>\n            </div>\n            <div class=\"row-container\">\n                <div class=\"double-column-container border-right-solid\">\n                    {{allInvoicesSelected ? 'All' : selectedInvoices.size}}\n                </div>\n                <div class=\"column-container\">\n                    {{ (selectedInvoicesAmount) | currency }}\n                </div>\n            </div>\n        </div>\n        <ng-container *ngIf=\"isMakeAPaymentEnable\">\n            <billing-payment [paymentFeed]=\"paymentFeed\" [loaderImage]=\"loaderImage\" (paymentDilogClosed)=\"paymentDilogClosed($event)\">\n            </billing-payment>\n        </ng-container>\n    </div>\n    <ng-container *ngIf=\"isPaymentConfirmationEnable\">\n        <billing-payment-confirmation [paymentConfirmationFeed]=\"paymentConfirmationFeed\" [loaderImage]=\"loaderImage\" (paymentConfirmDilogClosed)=\"paymentConfirmDilogClosed($event)\">\n        </billing-payment-confirmation>\n    </ng-container>\n</rs-dialog>\n", styles: [".payment-invoice-container{padding:0 25px 10px}.payment-invoice-container .payment-invoice-container>div{background-color:#f1f1f1;margin:10px;padding:20px;font-size:30px}.row-container{display:flex;flex-direction:row;flex-wrap:wrap;font-weight:700;padding:0 20px 0 0}.column-container{display:flex;flex-direction:column;flex-basis:100%;flex:1;font-size:14px;padding:1px 0 1px 10px}.double-column-container{display:flex;flex-direction:column;flex-basis:100%;flex:2;font-size:14px;padding:3px 20px}.font-gray{color:#919191;margin:20px px 0px 0px}.border-bottom-solid{border-bottom:1px solid rgb(194,191,191)}.border-right-solid{border-right:1px solid rgb(194,191,191)}.border-solid{border-right:1px solid rgb(194,191,191);border-left:1px solid rgb(194,191,191);border-top:1px solid rgb(194,191,191);border-bottom:1px solid rgb(194,191,191);margin-top:10px}.btn-pay-selected{padding:3px 0 0 54%;margin-top:0;display:flex;justify-content:flex-start}.btns-right-align{padding:5px 0 0 70%;margin-top:0;display:flex;justify-content:flex-start}.btn-align{margin-left:10px;font-size:10px;padding:5px 9px}.search-results-content{margin-bottom:10px}.search-results-content tbody tr:nth-child(odd){background-color:#f0f2f5}.search-results-content th,.search-results-content td{padding:12px 5px;width:100px}.search-results-content td a{color:#0c6ac7;text-decoration:none;cursor:pointer}.search-results-content td label{vertical-align:middle}.search-results-content th:first-of-type,.search-results-content td:first-of-type,.search-results-content th:last-of-type,.search-results-content td:last-of-type{padding-left:32px}.search-results-content th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.search-results-content table{border:1px solid #c2c2c2;border-collapse:collapse;width:99%;margin-left:5px}.search-results-content tbody tr{cursor:pointer}.top-links{padding:0 -2px 0 5px;display:flex;justify-content:space-between}.top-links .top-links-left span{color:#0c6ac7;border-bottom:1px solid #f9981c;padding-bottom:5px;cursor:pointer}.top-links .top-link-check{flex:1;margin-left:2px}.top-links .top-links-right span{color:#0c6ac7;padding-bottom:5px}.top-links .top-links-left-pg{color:#4b4c4d;padding-bottom:5px;cursor:pointer;padding-top:20px}.top-links .top-links-right-pg{color:#0c6ac7;padding-bottom:5px}.invoice-pagination{margin:2px 0 0 30px}.error-message{font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid;margin:5px}:host ::ng-deep .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }], { paymentInvoiceDilogClosed: [{
            type: Output
        }], loaderImage: [{
            type: Input
        }], paymentInvoiceFeed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentInvoiceComponent, { className: "PaymentInvoiceComponent", filePath: "lib/billing/payment-invoice/payment-invoice.component.ts", lineNumber: 15 }); })();

function BillingSearchComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.clientOrSubClientSearchErrors, "");
} }
function BillingSearchComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "rs-input", 24);
    i0.ɵɵelementEnd();
} }
function BillingSearchComponent_div_26_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r1.loaderImage);
} }
function BillingSearchComponent_div_26_div_2_ng_container_1_tbody_23_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "rs-radio", 33);
    i0.ɵɵlistener("click", function BillingSearchComponent_div_26_div_2_ng_container_1_tbody_23_tr_1_Template_rs_radio_click_2_listener() { const client_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.selectedClient(client_r6, true)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td")(10, "span", 34);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "date");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const client_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", client_r6.specifiedId)("checked", client_r6.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(client_r6.specifiedId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(client_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(client_r6.planAcronym);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("inactive-indicator", client_r6.status.code === "0");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(client_r6.status.code === "0" ? "INACTIVE" : "ACTIVE");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(14, 9, client_r6.status.effectiveDate, "MM/dd/yyyy"));
} }
function BillingSearchComponent_div_26_div_2_ng_container_1_tbody_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, BillingSearchComponent_div_26_div_2_ng_container_1_tbody_23_tr_1_Template, 15, 12, "tr", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.clientResults.clients);
} }
function BillingSearchComponent_div_26_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28)(3, "label");
    i0.ɵɵtext(4, "Total Group Record's Found: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 29)(8, "table")(9, "thead")(10, "tr")(11, "th");
    i0.ɵɵtext(12, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Group Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Payer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "th");
    i0.ɵɵtext(22, "Effective Date");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(23, BillingSearchComponent_div_26_div_2_ng_container_1_tbody_23_Template, 2, 1, "tbody", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 30)(25, "button", 31);
    i0.ɵɵlistener("click", function BillingSearchComponent_div_26_div_2_ng_container_1_Template_button_click_25_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.showMoreClientResults()); });
    i0.ɵɵtext(26, "Show More");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.clientResults.pagination == null ? null : ctx_r1.clientResults.pagination.totalRecords);
    i0.ɵɵadvance(17);
    i0.ɵɵproperty("ngIf", ctx_r1.clientResults.clients.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.areThereMoreResults);
} }
function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_tbody_28_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "rs-radio", 39);
    i0.ɵɵlistener("change", function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_tbody_28_tr_1_Template_rs_radio_change_2_listener() { const item_r9 = i0.ɵɵrestoreView(_r8).$implicit; const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.selectedSingleSubClient(item_r9)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td")(8, "span", 34);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "uppercase");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "date");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.disableInactive)("id", item_r9.specifiedId)("checked", item_r9.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r9.specifiedId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r9.name);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("inactive-indicator", !(item_r9.status.value === "Active"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 9, item_r9.status.value));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 11, item_r9.status.effectiveDate, "MM/dd/yyyy"));
} }
function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_tbody_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_tbody_28_tr_1_Template, 14, 14, "tr", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.subClientResults.subClients);
} }
function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 35);
    i0.ɵɵlistener("click", function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.backToClient()); });
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4, "Group: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 36)(8, "rs-checkbox", 37);
    i0.ɵɵlistener("change", function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_Template_rs_checkbox_change_8_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.selectedAllSubClients($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 38)(10, "label");
    i0.ɵɵtext(11, "Total Subgroup Record's Found: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 29)(15, "table")(16, "thead")(17, "tr")(18, "th");
    i0.ɵɵtext(19, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "th");
    i0.ɵɵtext(21, "Subgroup ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "th");
    i0.ɵɵtext(23, "Subgroup Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "th");
    i0.ɵɵtext(25, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "th");
    i0.ɵɵtext(27, "Effective Date");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(28, BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_tbody_28_Template, 2, 1, "tbody", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 30)(30, "button", 31);
    i0.ɵɵlistener("click", function BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_Template_button_click_30_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.showMoreSubClientResults()); });
    i0.ɵɵtext(31, "Show More");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate3("", ctx_r1.selectedClientInfo && ctx_r1.selectedClientInfo.planAcronym, " ", ctx_r1.selectedClientInfo && ctx_r1.selectedClientInfo.specifiedId, " ", ctx_r1.selectedClientInfo && ctx_r1.selectedClientInfo.name, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.allSubClientsSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.subClientResults.pagination == null ? null : ctx_r1.subClientResults.pagination.totalRecords);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngIf", ctx_r1.subClientResults.subClients.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.areThereMoreSCResults);
} }
function BillingSearchComponent_div_26_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BillingSearchComponent_div_26_div_2_ng_container_2_ng_container_1_Template, 32, 7, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSubClientResults);
} }
function BillingSearchComponent_div_26_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, BillingSearchComponent_div_26_div_2_ng_container_1_Template, 27, 3, "ng-container", 22)(2, BillingSearchComponent_div_26_div_2_ng_container_2_Template, 2, 1, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showSubClientResults);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r1.selectedSubClients && ctx_r1.selectedSubClients.length && !ctx_r1.backToResults || ctx_r1.allSubClientsSelected));
} }
function BillingSearchComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, BillingSearchComponent_div_26_ng_container_1_Template, 2, 1, "ng-container", 22)(2, BillingSearchComponent_div_26_div_2_Template, 3, 2, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFetchingClient);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFetchingClient);
} }
function BillingSearchComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.totalBalanceErrorMessage, "");
} }
function BillingSearchComponent_ng_container_29_div_2_div_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("due", ctx_r1.accountBalance > 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r1.accountBalance), "");
} }
function BillingSearchComponent_ng_container_29_div_2_div_10_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 49)(1, "a", 44);
    i0.ɵɵlistener("click", function BillingSearchComponent_ng_container_29_div_2_div_10_span_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.openPaymentInvoicePopup()); });
    i0.ɵɵtext(2, "Make a One-time Payment");
    i0.ɵɵelementEnd()();
} }
function BillingSearchComponent_ng_container_29_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46)(1, "label");
    i0.ɵɵtext(2, "Total Balance: ");
    i0.ɵɵtemplate(3, BillingSearchComponent_ng_container_29_div_2_div_10_span_3_Template, 3, 5, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BillingSearchComponent_ng_container_29_div_2_div_10_span_4_Template, 3, 0, "span", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.accountBalance);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isPaymentEnable);
} }
function BillingSearchComponent_ng_container_29_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42)(1, "div", 43)(2, "label", 44);
    i0.ɵɵlistener("click", function BillingSearchComponent_ng_container_29_div_2_Template_label_click_2_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.backToClient()); });
    i0.ɵɵtext(3, "Group:");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "label", 44);
    i0.ɵɵlistener("click", function BillingSearchComponent_ng_container_29_div_2_Template_label_click_6_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.backToSubClient()); });
    i0.ɵɵtext(7, "Subgroup:");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, BillingSearchComponent_ng_container_29_div_2_div_10_Template, 5, 2, "div", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate3("", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients[0].planAcronym, " ", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients[0].client.specifiedId, " ", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients[0].client.name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients[0].specifiedId, " ", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients[0].name, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dateRange && !ctx_r1.isPaymentHistoryFeature);
} }
function BillingSearchComponent_ng_container_29_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51)(1, "label", 44);
    i0.ɵɵlistener("click", function BillingSearchComponent_ng_container_29_ng_template_3_div_0_Template_label_click_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.backToClient()); });
    i0.ɵɵtext(2, "Group:");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "label", 44);
    i0.ɵɵlistener("click", function BillingSearchComponent_ng_container_29_ng_template_3_div_0_Template_label_click_5_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.backToSubClient()); });
    i0.ɵɵtext(6, "Subgroup:");
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate3("", ctx_r1.clientDetails && ctx_r1.clientDetails.planAcronym, " ", ctx_r1.clientDetails && ctx_r1.clientDetails.specifiedId, " ", ctx_r1.clientDetails && ctx_r1.clientDetails.name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.subGroupId ? ctx_r1.subGroupId : "All Subgroups", " ", ctx_r1.subGroupId ? ctx_r1.subClientResults.subClients[0] == null ? null : ctx_r1.subClientResults.subClients[0].name : "", "");
} }
function BillingSearchComponent_ng_container_29_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, BillingSearchComponent_ng_container_29_ng_template_3_div_0_Template, 9, 5, "div", 50);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.clientDetails);
} }
function BillingSearchComponent_ng_container_29_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "form", 5);
    i0.ɵɵlistener("ngSubmit", function BillingSearchComponent_ng_container_29_div_5_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.fromDateRangeForm()); });
    i0.ɵɵelementStart(2, "div", 52)(3, "div", 53);
    i0.ɵɵelement(4, "rs-input", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 53);
    i0.ɵɵelement(6, "rs-input", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 56)(8, "button", 19);
    i0.ɵɵtext(9, "Submit");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "ul", 57)(11, "li");
    i0.ɵɵtext(12, "Date Range is optional. If not specified will default to the last 3 months worth of processed invoices");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.dateForm);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", !ctx_r1.dateForm.valid);
} }
function BillingSearchComponent_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵtemplate(2, BillingSearchComponent_ng_container_29_div_2_Template, 11, 6, "div", 41)(3, BillingSearchComponent_ng_container_29_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, BillingSearchComponent_ng_container_29_div_5_Template, 13, 2, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const withoutSelection_r14 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedSubClients && ctx_r1.selectedSubClients.length && !ctx_r1.allSubClientsSelected)("ngIfElse", withoutSelection_r14);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dateRange && !ctx_r1.isPaymentHistoryFeature);
} }
function BillingSearchComponent_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-payment-invoice", 58);
    i0.ɵɵlistener("paymentInvoiceDilogClosed", function BillingSearchComponent_ng_container_30_Template_billing_payment_invoice_paymentInvoiceDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.paymentInvoiceDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("paymentInvoiceFeed", ctx_r1.paymentInvoiceFeed)("loaderImage", ctx_r1.loaderImage);
} }
class BillingSearchComponent {
    get selectedAdminPlan() {
        return this.selectedAdminPlan_;
    }
    set selectedAdminPlan(val) {
        if (val) {
            this.selectedAdminPlan_ = val;
            this.setPlanDropdowns(val);
        }
    }
    get disableInactive() {
        return this._disableInactive;
    }
    set disableInactive(value) {
        this._disableInactive = coerceBooleanProperty(value);
    }
    get userFeed() {
        return this._userFeed;
    }
    set userFeed(value) {
        this._userFeed = value;
    }
    constructor(lux, bAsync, fb, authConfig) {
        this.lux = lux;
        this.bAsync = bAsync;
        this.fb = fb;
        this.authConfig = authConfig;
        this.luxId = 'billing-lib-billing-search-comp' + this.constructor.name;
        this.billing = [];
        this.loaderImage = '';
        this.selectedAdminPlan_ = '';
        this._disableInactive = false;
        this._userFeed = {
            email: '',
            appName: ''
        };
        this.resetSelected = new EventEmitter();
        this.billingInput = new EventEmitter();
        this.payerOptions = ['', 'DDPMI', 'DDPIN', 'DDPOH', 'DDPNM', 'DDAR', 'DDPTN', 'RLHA', 'DDNC', 'DDKY', 'MOO', 'DDMN', 'DDNE', 'DDMN2', 'WICMS', 'TPA', 'ARCMS', 'DDAZ'];
        this.clientStatus = ['', 'Active', 'Inactive'];
        this.subClientStatus = ['', 'Active', 'Inactive'];
        this.initialClientOffset = 0;
        this.initialSubClientOffset = 0;
        this.subClientTotal = 0;
        this.clientTotal = 0;
        this.searchCriteria$ = this.lux.get(getSearchCriteria, this.luxId);
        this.clientResults$ = this.lux.get(getClientResults, this.luxId);
        this.isSubClientCalled = this.lux.get(getCallInfo, this.luxId);
        this.isSubClientFlow = this.lux.get(getFlowInfo, this.luxId);
        this.subClientResults$ = this.lux.get(getSubClientResults, this.luxId);
        this.clientOrSubClientSearchErrors$ = this.lux.get(getClientOrSubClientSearchErrors, this.luxId);
        this.isFetchingClient$ = this.lux.get(isFetchingClient, this.luxId);
        this.accountBalance$ = this.lux.get(totalBalanceDueRes, this.luxId);
        this.isFetchingTotalDue$ = this.lux.get(isFetchingTotalBalance, this.luxId);
        this.selectedClientInfo$ = this.lux.get(getSelectedClient, this.luxId);
        this.paymentConfigError$ = this.lux.get(paymentConfigError, this.luxId);
        this.totalBalanceErrorMessage$ = this.lux.get(totalBalanceErrorMessage, this.luxId);
        this.isFetchingpaymentConfig$ = this.lux.get(isFetchingpaymentConfig, this.luxId);
        this.searchCriteria$.pipe(first()).subscribe(criteria => {
            this.searchForm = this.fb.group({
                planAcronym: { value: criteria.planAcronym, disabled: false },
                clientSpecifiedIdentifier: [criteria.clientSpecifiedIdentifier, Validators.required],
                clientSpecifiedName: [criteria.clientSpecifiedName, Validators.required],
                subClientSpecifiedIdentifier: criteria.subClientSpecifiedIdentifier,
                subClientSpecifiedName: criteria.subClientSpecifiedName,
                activeIndicator: criteria.activeIndicator,
                paymentId: criteria.paymentId,
            });
            this.searchForm.valueChanges.pipe(startWith(this.searchForm.value)).subscribe(val => {
                const csId = 'clientSpecifiedIdentifier';
                const csn = 'clientSpecifiedName';
                const payId = 'paymentId';
                const payer = 'planAcronym';
                [csId, csn].forEach((x) => {
                    this.searchForm.controls[x].setValidators(Validators.required);
                    this.searchForm.controls[x].updateValueAndValidity({ onlySelf: true, emitEvent: false });
                });
                if (val.clientSpecifiedIdentifier && !val.paymentId) {
                    this.turnOffValidation(csn);
                    this.turnOffValidation(payId);
                    this.turnOffValidation(payer);
                }
                else if (val.clientSpecifiedName) {
                    this.turnOffValidation(csId);
                    this.turnOffValidation(payId);
                    this.turnOffValidation(payer);
                }
                else if (val.paymentId && this.isPaymentHistoryFeature) {
                    this.searchForm.controls[payer].setValidators(Validators.required);
                    this.searchForm.controls[payer].updateValueAndValidity({ onlySelf: true, emitEvent: false });
                    this.turnOffValidation(csId);
                    this.turnOffValidation(csn);
                }
                this.searchForm.updateValueAndValidity({ onlySelf: false, emitEvent: false });
            });
        });
    }
    turnOffValidation(controlName) {
        this.searchForm.controls[controlName].clearValidators();
        this.searchForm.controls[controlName].updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    ngOnInit() {
        setTimeout(() => {
            this.resetSearch();
        }, 0);
        this.isPaymentHistoryFeature = this.billing && this.billing.includes('paymentHistory');
        this.isHistoricalReportsFeature = this.billing && this.billing.includes('historicalReports');
        this.adminPlans = Object.keys(this.authConfig.userAuthorizations);
        this.selectedAdminPlan ? this.setPlanDropdowns(this.selectedAdminPlan)
            : this.plansDropdown = this.adminPlans.indexOf['DDPMI']
                ? this.authConfig.userAuthorizations[this.selectedAdminPlan] : [];
        this.isFetchingClient$.subscribe(fetching => this.isFetchingClient = fetching);
        this.isFetchingTotalDue$.subscribe(fetching => this.isFetchingTotalDue = fetching);
        this.isFetchingpaymentConfig$.subscribe(fetching => this.isFetchingpaymentConfig = fetching);
        this.isSubClientCalled.subscribe(results => this.showSubClientResults = results);
        this.isSubClientFlow.subscribe(Response => this.subClientFlow = Response);
        this.accountBalance$.subscribe(balance => this.accountBalance = balance && balance.totalDue);
        this.paymentConfigError$.subscribe(error => this.paymentConfigError = error);
        this.clientOrSubClientSearchErrors$.subscribe(error => this.clientOrSubClientSearchErrors = error);
        this.totalBalanceErrorMessage$.subscribe(error => this.totalBalanceErrorMessage = error);
        this.clientResults$.subscribe(x => {
            this.clientResults = x;
            if (this.clientResults && this.clientResults.clients.length === 1) {
                this.selectedClient(this.clientResults.clients[0], false);
            }
            this.areThereMoreResults = x.hasMoreClients;
            this.clientTotal = x.pagination.totalRecords;
        });
        this.subClientResults$.subscribe(x => {
            this.selectedSubClient = null;
            this.subClientResults = x;
            this.areThereMoreSCResults = x.hasMoreSubClients;
        });
        this.selectedClientInfo$.subscribe(x => this.selectedClientInfo = x);
        this.dateForm = this.fb.group({
            startDate: [''],
            endDate: [{ value: '', disabled: true }]
        });
        this.dateForm.controls.startDate.valueChanges.pipe(startWith('')).subscribe(val => {
            if (moment(val).isValid() && val !== '') {
                this.dateForm.controls.endDate.enable();
            }
        });
        this.accountBalance = '';
        this.backToResults = false;
        this.allSubClientsSelected = false;
    }
    searchFormSubmitted() {
        this.resetState();
        if (this.searchForm.valid) {
            const formValue = { ...this.searchForm.getRawValue(), pagination: { offset: 0 } };
            this.subGroupId = formValue.subClientSpecifiedIdentifier;
            formValue.planAcronym = formValue.planAcronym && formValue.planAcronym.length ? [formValue.planAcronym] : this.plansDropdown;
            this.lux.set(state => state.billing, { searchCriteria: formValue, subClientFlow: false });
            this.paymentId = formValue.paymentId;
            if (this.paymentId) {
                const searchDta = {
                    planAcronym: formValue.planAcronym,
                };
                this.getBillingInfo(searchDta);
            }
            else {
                this.startClientSearch();
            }
        }
    }
    startClientSearch() {
        this.bAsync.getClients(null).subscribe(x => {
            if (x && x.clients.length === 1) {
                this.groupId = x.clients[0].specifiedId;
                this.payer = x.clients[0].planAcronym;
                this.allSubClientsSelected = true;
                this.lux.set(state => state.billing, {
                    isSubClientCalled: true,
                    subClientFlow: true,
                    selectedClient: x.clients[0]
                });
                this.bAsync.getSubClients(null).subscribe();
            }
        });
    }
    selectedClient(client, isEmittingEvent) {
        this.groupId = client.specifiedId;
        this.payer = client.planAcronym;
        const clientData = {
            groupId: client.specifiedId,
            subGroupId: this.subGroupId ? this.subGroupId : '',
            planAcronym: client.planAcronym,
            groupName: client.name
        };
        this.clientDetails = client;
        this.getBillingInfo(clientData);
        this.allSubClientsSelected = true;
        this.clientResults.clients.map(x => x.selected = false);
        client.selected = true;
        client.isrowselected = false;
        this.lux.set(state => state.billing, { selectedClient: client, isSubClientCalled: true });
        this.getSubClient(client);
    }
    getSubClient(client) {
        this.lux.set(state => state.billing.searchCriteria, {
            planAcronym: client.planAcronym,
            clientSpecifiedIdentifier: client.specifiedId,
            pagination: { offset: 0 }
        });
        this.bAsync.getSubClients(false).subscribe(() => {
            this.subClientTotal = this.subClientResults.pagination.totalRecords;
        });
    }
    selectedSingleSubClient(subClient) {
        this.payer = subClient.planAcronym;
        this.subGroupId = subClient.specifiedId;
        const clientData = {
            groupId: this.groupId,
            subGroupId: subClient.specifiedId,
            planAcronym: subClient.planAcronym,
        };
        this.getBillingInfo(clientData);
        this.selectedSubClient = subClient;
        this.subClientResults.subClients.forEach(x => x.selected = false);
        subClient.selected = true;
        this.setSubClients();
    }
    setSubClients() {
        this.selectedSubClients = this.subClientResults.subClients.filter(x => x.selected);
        this.selectedSubClients.map(x => x.client = this.selectedClientInfo);
        this.lux.set(state => state.billing, { selectedSubClient: this.selectedSubClients });
        this.backToResults = false;
    }
    backToClient() {
        this.billingFeed = {};
        this.backToResults = true;
        if (!this.subClientFlow) {
            this.lux.set(state => state.billing, { isSubClientCalled: false });
        }
    }
    backToSubClient() {
        this.billingFeed = {};
        this.backToResults = true;
        this.showSubClientResults = true;
        this.allSubClientsSelected = false;
        this.subClientResults.subClients.forEach((item) => item.selected = false);
        this.areThereMoreResults = false;
    }
    showMoreClientResults() {
        const searchFormValues = this.searchForm.getRawValue();
        if (searchFormValues.clientSpecifiedIdentifier.includes('*')) {
            this.lux.set(state => state.billing.searchCriteria, {
                clientSpecifiedIdentifier: searchFormValues.clientSpecifiedIdentifier,
                planAcronym: searchFormValues.planAcronym ? [searchFormValues.planAcronym] : this.plansDropdown
            });
        }
        this.initialClientOffset++;
        this.lux.set(state => state.billing.searchCriteria.pagination, { offset: 25 * this.initialClientOffset });
        this.bAsync.getClients('showMore').subscribe();
    }
    showMoreSubClientResults() {
        this.initialSubClientOffset++;
        this.lux.set(state => state.billing.subClientSearchCriteria.pagination, { offset: 25 * this.initialSubClientOffset });
        this.bAsync.getSubClients('showMore').subscribe();
    }
    setPlanDropdowns(adminPlan) {
        this.plansDropdown = this.authConfig.userAuthorizations[adminPlan] || [];
    }
    selectedAllSubClients(event) {
        this.subGroupId = '';
        this.allSubClientsSelected = event.target.checked;
        const clientData = {
            groupId: this.selectedClientInfo.specifiedId,
            subGroupId: '',
            planAcronym: this.selectedClientInfo.planAcronym,
            groupName: this.selectedClientInfo.name
        };
        this.getBillingInfo(clientData);
    }
    fromDateRangeForm() {
        this.billingFeed = {};
        const dateFormValues = this.dateForm.getRawValue();
        const billingData = {
            subGroupId: this.subGroupId,
            startDate: dateFormValues.startDate ? moment(dateFormValues.startDate).format('YYYY-MM-DD') : '',
            endDate: dateFormValues.endDate ? moment(dateFormValues.endDate).format('YYYY-MM-DD') : ''
        };
        const delay = setTimeout(() => {
            this.getBillingInfo(billingData, true);
        }, 1000);
    }
    getBillingInfo(data, fromDateForm) {
        if (!fromDateForm) {
            this.dateForm && this.dateForm.reset();
        }
        this.totalBalanceErrorMessage = '';
        const groupSpecifiedId = data && data.groupId ? data.groupId : this.selectedClientInfo.specifiedId;
        const payer = data && data.planAcronym ? data.planAcronym : this.selectedClientInfo.planAcronym;
        const groupName = data && data.groupName ? data.groupName : this.selectedClientInfo.name;
        if (!this.isPaymentHistoryFeature && !this.isHistoricalReportsFeature) {
            const paymentConfigurationsRequest = {
                adminPlanAcronym: this.selectedAdminPlan,
                planAcronym: payer,
                clientType: 'Group',
                asOfDate: moment(new Date()).format('YYYY-MM-DD'),
            };
            this.bAsync.checkPaymentConfig(paymentConfigurationsRequest).subscribe(config => {
                this.isPaymentEnable = false;
                if (config && config.length) {
                    this.isPaymentEnable = !!(config[0].status === 'A');
                    this.businessUnit = config[0].businessUnit;
                }
            });
        }
        this.billingFeed = {
            groupId: groupSpecifiedId,
            subGroupId: data.subGroupId || '',
            planAcronym: payer,
            groupName,
            subGroupName: data.subGroupName || '',
            fromDate: data.startDate || '',
            toDate: data.endDate || '',
            paymentId: this.paymentId
        };
        this.billingInput.emit(this.billingFeed);
    }
    resetSearch() {
        this.resetButton = document.querySelector('.client-search-buttons .rs-button');
        if (this.resetButton && this.resetButton != null) {
            this.resetButton.click();
        }
        this.clientDetails = null;
        this.searchForm.reset({
            planAcronym: '',
            clientSpecifiedIdentifier: '',
            clientSpecifiedName: '',
            subClientSpecifiedIdentifier: '',
            subClientSpecifiedName: '',
            clientStatus: '',
            subClientStatus: '',
            clientStatusIndicator: '',
            activeIndicator: false,
            fetchInactive: false,
            paymentId: '',
        });
        this.resetState();
    }
    openPaymentInvoicePopup() {
        this.showPaymentInvoice = true;
        const dateFormValues = this.dateForm.getRawValue();
        this.paymentInvoiceFeed = {
            adminPlan: this.selectedAdminPlan,
            planAcronym: this.selectedClientInfo.planAcronym,
            clientSpecifiedIdentifier: this.selectedClientInfo.specifiedId,
            subClientSpecifiedIdentifier: this.subGroupId,
            startDate: dateFormValues.startDate ? moment(dateFormValues.startDate).format('YYYY-MM-DD') : '',
            endDate: dateFormValues.endDate ? moment(dateFormValues.endDate).format('YYYY-MM-DD') : '',
            groupName: this.selectedClientInfo.specifiedId + ' - ' + this.selectedClientInfo.name,
            accountBalance: this.accountBalance,
            businessUnit: this.businessUnit,
            email: this.userFeed.email,
            appName: this.userFeed.appName
        };
    }
    paymentInvoiceDilogClosed() {
        this.paymentInvoiceFeed = '';
        this.showPaymentInvoice = false;
    }
    resetState() {
        this.resetSelected.emit('clearResults');
        this.selectedSubClients = [];
        this.allSubClientsSelected = false;
        this.billingFeed = {};
        this.dateForm && this.dateForm.reset();
        this.lux.set(state => state.billing, initialBillingState);
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
        this.subscription$ && this.subscription$.unsubscribe();
    }
    static { this.ɵfac = function BillingSearchComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingSearchComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(BillingAsync), i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(UserAuthConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BillingSearchComponent, selectors: [["billing-search"]], inputs: { billing: "billing", loaderImage: "loaderImage", dateRange: "dateRange", selectedAdminPlan: "selectedAdminPlan", disableInactive: "disableInactive", userFeed: "userFeed" }, outputs: { resetSelected: "resetSelected", billingInput: "billingInput" }, decls: 31, vars: 9, consts: [["ngSearchForm", "ngForm"], ["withoutSelection", ""], [1, "client-billing-search"], ["class", "no-results", 4, "ngIf"], [1, "client-search"], [3, "ngSubmit", "formGroup"], [1, "row", "client-search-options"], [1, "col-sm-3"], ["formControlName", "planAcronym", "label", "Payer", "selectValue", "", "validation", "eager", 3, "items"], ["formControlName", "clientSpecifiedIdentifier", "label", "Group ID", "validation", "eager"], ["formControlName", "subClientSpecifiedIdentifier", "label", "Subgroup ID", "validation", "eager"], ["formControlName", "clientSpecifiedName", "label", "Group Name", "validation", "eager"], ["formControlName", "subClientSpecifiedName", "label", "Subgroup Name", "validation", "eager"], ["class", "col-sm-3", 4, "ngIf"], [1, "col-sm-3", "client-search-active"], ["id", "active", "formControlName", "activeIndicator", "label", "Active"], [1, "row", "client-search-row"], [1, "col", "client-search-buttons"], ["rs-button", "", "type", "button", 3, "click"], ["rs-raised-button", "", "color", "primary", 3, "disabled"], ["class", "client-search-results", 4, "ngIf"], [1, "billing-search"], [4, "ngIf"], [1, "no-results"], ["formControlName", "paymentId", "label", "Payment ID", "validation", "eager"], [1, "client-search-results"], ["position", "absolute", 3, "imageSrc"], [1, "top-links"], [1, "top-links-left"], [1, "search-results-content"], [1, "show-more"], ["rs-raised-button", "", "color", "primary", 3, "click", "disabled"], [4, "ngFor", "ngForOf"], ["name", "select", 3, "click", "id", "checked"], [1, "active-indicator"], [1, "top-links-left", 3, "click"], [1, "top-link-check"], ["id", "allSubClients", "label", "All Subgroups", 3, "change", "checked"], [1, "top-links-right"], ["name", "subClient", 3, "change", "disabled", "id", "checked"], [1, "group-subgroup-heading"], ["class", "client-info billing-row", 4, "ngIf", "ngIfElse"], [1, "client-info", "billing-row"], [1, "group-subgroup"], [3, "click"], ["class", "billing-info", 4, "ngIf"], [1, "billing-info"], [3, "due", 4, "ngIf"], ["class", "make-a-payment", 4, "ngIf"], [1, "make-a-payment"], ["class", "client-info", 4, "ngIf"], [1, "client-info"], [1, "row", "date-form"], [1, "col-sm-2"], ["formControlName", "startDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "From Date", "validation", "eager"], ["formControlName", "endDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "To Date", "validation", "eager"], [1, "col-sm-2", "date-submit-button"], [1, "date-range-info"], [3, "paymentInvoiceDilogClosed", "paymentInvoiceFeed", "loaderImage"]], template: function BillingSearchComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, BillingSearchComponent_div_1_Template, 2, 1, "div", 3);
            i0.ɵɵelementStart(2, "div", 4)(3, "form", 5, 0);
            i0.ɵɵlistener("ngSubmit", function BillingSearchComponent_Template_form_ngSubmit_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.searchFormSubmitted()); });
            i0.ɵɵelementStart(5, "div", 6)(6, "div", 7);
            i0.ɵɵelement(7, "rs-select", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵelement(9, "rs-input", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵelement(11, "rs-input", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "rs-input", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 6)(15, "div", 7);
            i0.ɵɵelement(16, "rs-input", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(17, BillingSearchComponent_div_17_Template, 2, 0, "div", 13);
            i0.ɵɵelementStart(18, "div", 14);
            i0.ɵɵelement(19, "rs-checkbox", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 16)(21, "div", 17)(22, "button", 18);
            i0.ɵɵlistener("click", function BillingSearchComponent_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r1); const ngSearchForm_r3 = i0.ɵɵreference(4); ngSearchForm_r3.resetForm(); return i0.ɵɵresetView(ctx.resetSearch()); });
            i0.ɵɵtext(23, "Reset");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "button", 19);
            i0.ɵɵtext(25, "Search");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵtemplate(26, BillingSearchComponent_div_26_Template, 3, 2, "div", 20);
            i0.ɵɵelementStart(27, "div", 21);
            i0.ɵɵtemplate(28, BillingSearchComponent_div_28_Template, 2, 1, "div", 3)(29, BillingSearchComponent_ng_container_29_Template, 6, 3, "ng-container", 22)(30, BillingSearchComponent_ng_container_30_Template, 2, 2, "ng-container", 22);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isFetchingClient && ctx.clientOrSubClientSearchErrors);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.searchForm);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("items", ctx.plansDropdown.length ? ctx.plansDropdown : ctx.payerOptions);
            i0.ɵɵadvance(10);
            i0.ɵɵproperty("ngIf", ctx.isPaymentHistoryFeature);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("disabled", ctx.isFetching || !ctx.searchForm.valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.clientResults && ctx.clientResults.clients.length && !ctx.paymentId || ctx.subClientResults && ctx.subClientResults.subClients.length && !ctx.paymentId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.totalBalanceErrorMessage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selectedSubClients && ctx.selectedSubClients.length && !ctx.backToResults || ctx.allSubClientsSelected || ctx.paymentId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showPaymentInvoice);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i6$1.SelectComponent, i7$1.CheckboxComponent, i2.FormGroupDirective, i2.FormControlName, i8.InputComponent, i9.RadioComponent, i5.ButtonComponent, i7.LoaderComponent, PaymentInvoiceComponent, i3$1.UpperCasePipe, i3$1.CurrencyPipe, i3$1.DatePipe], styles: [".client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{white-space:nowrap;color:#124980;font-weight:700}.client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]{flex-direction:column}.client-billing-search[_ngcontent-%COMP%]   .client-search-row[_ngcontent-%COMP%]{align-content:center;justify-content:center;align-items:center;padding:0 10px}.client-billing-search[_ngcontent-%COMP%]   .client-search-buttons[_ngcontent-%COMP%]{text-align:right}.client-billing-search[_ngcontent-%COMP%]   .client-search-active[_ngcontent-%COMP%]{padding-top:30px}.client-billing-search[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin-bottom:16px;font-weight:700}.client-billing-search[_ngcontent-%COMP%]   hr.profile-thematic-break[_ngcontent-%COMP%]{border-top:2px solid #d1c9c9}.client-billing-search[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]{color:#a94442;font-weight:700;padding-bottom:10px}@media (min-width: 768px){.client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]{flex-direction:row}}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:5px 0}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border-collapse:collapse;width:100%}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#06c;font-weight:700;cursor:pointer}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .active-indicator[_ngcontent-%COMP%]{background-color:#41a929;padding:5px;border-radius:3px;color:#fff;text-transform:capitalize}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .inactive-indicator[_ngcontent-%COMP%]{background-color:#d3d3d3}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .show-more[_ngcontent-%COMP%]{padding-top:32px;text-align:center;padding-left:0!important;border:transparent!important;border-radius:20px!important;font-size:15px!important}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .show[_ngcontent-%COMP%]{display:block}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]{border-top:1px solid gray;padding:5px 25px 0 32px;display:flex;justify-content:space-between}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]   .top-links-left[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;border-bottom:1px solid #f9981c;padding-bottom:5px;cursor:pointer}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]   .top-link-check[_ngcontent-%COMP%]{flex:1;margin-left:20px}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]   .top-links-right[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding-bottom:5px}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]   .top-links-left-pg[_ngcontent-%COMP%]{color:#4b4c4d;padding-bottom:5px;cursor:pointer;padding-top:20px}.client-billing-search[_ngcontent-%COMP%]   .client-search-results[_ngcontent-%COMP%]   .top-links[_ngcontent-%COMP%]   .top-links-right-pg[_ngcontent-%COMP%]{color:#0c6ac7;padding-bottom:5px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]{margin:0 0 24px;padding:0 10px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]{border-bottom:1px solid grey;padding:20px 15px 5px;margin-bottom:10px;font-size:16px;justify-content:space-between}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .client-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .client-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .group-subgroup[_ngcontent-%COMP%]{display:flex}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]{text-align:right}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   .due[_ngcontent-%COMP%]{color:red}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:700;cursor:pointer}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:last-child{padding-left:10px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .make-a-payment[_ngcontent-%COMP%]{border-left:1px solid gray}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-range-info[_ngcontent-%COMP%]{margin-left:-20px;font-weight:700}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]{margin-top:5px}.client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]   .date-submit-button[_ngcontent-%COMP%]{margin-top:20px}[_nghost-%COMP%]     .billing-component .rs-tab-content{margin:0 0 auto!important}[_nghost-%COMP%]     .billing-component .rs-tab-header-container{padding:0!important;margin-left:30px!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingSearchComponent, [{
        type: Component,
        args: [{ selector: 'billing-search', template: "\n<div class=\"client-billing-search\">\n    <div class=\"no-results\" *ngIf=\"!isFetchingClient && clientOrSubClientSearchErrors\">\n      {{clientOrSubClientSearchErrors}}</div>\n    <div class=\"client-search\">\n    <form [formGroup]=\"searchForm\" #ngSearchForm=\"ngForm\" (ngSubmit)=\"searchFormSubmitted();\">\n      <div class=\"row client-search-options\">\n        <div class=\"col-sm-3\">\n          <rs-select formControlName=\"planAcronym\" label=\"Payer\" selectValue=\"\" validation=\"eager\" [items]=\"plansDropdown.length ? plansDropdown : payerOptions\">\n          </rs-select>\n        </div>\n        <div class=\"col-sm-3\">\n          <rs-input formControlName=\"clientSpecifiedIdentifier\" label=\"Group ID\" validation=\"eager\"></rs-input>\n        </div>\n        <div class=\"col-sm-3\">\n          <rs-input formControlName=\"subClientSpecifiedIdentifier\" label=\"Subgroup ID\" validation=\"eager\"></rs-input>\n        </div>\n        <div class=\"col-sm-3\">\n          <rs-input formControlName=\"clientSpecifiedName\" label=\"Group Name\" validation=\"eager\"></rs-input>\n        </div>\n      </div>\n      <div class=\"row client-search-options\">\n        <div class=\"col-sm-3\">\n          <rs-input formControlName=\"subClientSpecifiedName\" label=\"Subgroup Name\" validation=\"eager\"></rs-input>\n        </div>\n        <div *ngIf=\"isPaymentHistoryFeature\" class=\"col-sm-3\">\n          <rs-input formControlName=\"paymentId\" label=\"Payment ID\" validation=\"eager\"></rs-input>\n        </div>\n        <div class=\"col-sm-3 client-search-active\">\n          <rs-checkbox id=\"active\" formControlName=\"activeIndicator\" label=\"Active\"></rs-checkbox>\n        </div>\n      </div>\n      <div class=\"row client-search-row\">\n        <div class=\"col client-search-buttons\">\n          <button rs-button type=\"button\" (click)=\"ngSearchForm.resetForm();resetSearch();\">Reset</button>\n          <button [disabled]=\"isFetching || !searchForm.valid\" rs-raised-button color=\"primary\">Search</button>\n        </div>\n      </div>\n    </form>\n  </div>\n  <!-- Client Search Results -->\n    <div class=\"client-search-results\" *ngIf=\"((clientResults && clientResults.clients.length && !paymentId) || (subClientResults && subClientResults.subClients.length && !paymentId) )\">\n      <ng-container *ngIf=\"isFetchingClient\">\n        <rs-loader position=\"absolute\" imageSrc={{loaderImage}}></rs-loader>\n      </ng-container>\n      <div *ngIf=\"!isFetchingClient\">\n        <ng-container *ngIf=\"!showSubClientResults\">\n          <div class=\"top-links\">\n            <div class=\"top-links-left\"><label>Total Group Record's Found:\n              </label><span>{{clientResults.pagination?.totalRecords}}</span></div>\n          </div>\n          <div class=\"search-results-content\">\n            <table>\n              <thead>\n                <tr>\n                  <th>Select</th>\n                  <th>Group ID</th>\n                  <th>Group Name</th>\n                  <th>Payer</th>\n                  <th>Status</th>\n                  <th>Effective Date</th>\n                </tr>\n              </thead>\n              <tbody *ngIf=\"clientResults.clients.length\">\n                <tr *ngFor=\"let client of clientResults.clients\">\n                  <td>\n                    <rs-radio name=\"select\" [id]=\"client.specifiedId\" [checked]=\"client.selected\"\n                      (click)=\"selectedClient(client,true)\"></rs-radio>\n                  </td>\n                  <td>{{client.specifiedId}}</td>\n                  <td>{{client.name}}</td>\n                  <td>{{client.planAcronym}}</td>\n                  <td><span class=\"active-indicator\"\n                      [class.inactive-indicator]=\"client.status.code === '0'\">{{client.status.code === '0' ? 'INACTIVE' :\n                      'ACTIVE'}}</span></td>\n                  <td>{{client.status.effectiveDate | date: 'MM/dd/yyyy'}}</td>\n                </tr>\n              </tbody>\n            </table>\n            <div class=\"show-more\">\n              <button rs-raised-button color=\"primary\" [disabled]=\"!areThereMoreResults\"\n                (click)=\"showMoreClientResults()\">Show More</button>\n            </div>\n          </div>\n        </ng-container>\n        <!-- SUB CLIENT SEARCH RESULTS -->\n        <ng-container *ngIf=\"!((selectedSubClients && selectedSubClients.length && !backToResults ) || (allSubClientsSelected))\">\n          <ng-container *ngIf=\"showSubClientResults\">\n            <div class=\"top-links\">\n              <div class=\"top-links-left\" (click)=\"backToClient()\">\n                <label>Group: </label><span>{{selectedClientInfo && selectedClientInfo.planAcronym}} {{selectedClientInfo && selectedClientInfo.specifiedId}}\n                  {{selectedClientInfo && selectedClientInfo.name}}</span>\n              </div>\n              <div  class=\"top-link-check\">\n                <rs-checkbox (change)=\"selectedAllSubClients($event)\" [checked] =\"allSubClientsSelected\" id=\"allSubClients\" label=\"All Subgroups\">\n                </rs-checkbox>\n              </div>\n              <div class=\"top-links-right\">\n                <label>Total Subgroup Record's Found: </label><span>{{subClientResults.pagination?.totalRecords}}</span>\n              </div>\n            </div>\n            <div class=\"search-results-content\">\n              <table>\n                <thead>\n                  <tr>\n                    <th>Select</th>\n                    <th>Subgroup ID</th>\n                    <th>Subgroup Name</th>\n                    <th>Status</th>\n                    <th>Effective Date</th>\n                  </tr>\n                </thead>\n                <tbody *ngIf=\"subClientResults.subClients.length\">\n                  <tr *ngFor=\"let item of subClientResults.subClients\">\n                    <td>\n                      <rs-radio [disabled]=\"disableInactive\" name=\"subClient\" [id]=\"item.specifiedId\"\n                        [checked]=\"item.selected\" (change)=\"selectedSingleSubClient(item)\">\n                      </rs-radio>\n                    </td>\n                    <td>{{item.specifiedId}}</td>\n                    <td>{{item.name}}</td>\n                    <td><span class=\"active-indicator\"\n                        [class.inactive-indicator]=\"!(item.status.value ==='Active')\">{{(item.status.value) |\n                        uppercase}}</span></td>\n                    <td>{{item.status.effectiveDate | date: 'MM/dd/yyyy'}}</td>\n                  </tr>\n                </tbody>\n              </table>\n              <div class=\"show-more\">\n                <button rs-raised-button color=\"primary\" [disabled]=\"!areThereMoreSCResults\"\n                  (click)=\"showMoreSubClientResults()\">Show More</button>\n              </div>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n    <!-- Date Range -->\n    <div class=\"billing-search\">\n      <div class=\"no-results\" *ngIf=\"totalBalanceErrorMessage\">\n        {{totalBalanceErrorMessage}}</div>\n         <ng-container *ngIf=\"((selectedSubClients && selectedSubClients.length && !backToResults) || allSubClientsSelected || paymentId)\">\n           <div class=\"group-subgroup-heading\">\n             <div class=\"client-info billing-row\" *ngIf=\"selectedSubClients && selectedSubClients.length && !allSubClientsSelected; else withoutSelection\">\n               <div class=\"group-subgroup\">\n                 <label (click)=\"backToClient()\">Group:<span>{{ selectedSubClients && selectedSubClients[0].planAcronym }} {{ selectedSubClients && selectedSubClients[0].client.specifiedId }} {{ selectedSubClients && selectedSubClients[0].client.name }} </span></label>\n                 <label (click)=\"backToSubClient()\">Subgroup:<span>{{ selectedSubClients && selectedSubClients[0].specifiedId }} {{ selectedSubClients && selectedSubClients[0].name }}</span></label>\n               </div>\n               <div class=\"billing-info\" *ngIf=\"dateRange && !isPaymentHistoryFeature\">\n                 <label>Total Balance: <span *ngIf=\"accountBalance\" [class.due]=\"accountBalance > 0\"> {{ (accountBalance) | currency }}</span></label>\n                 <span class=\"make-a-payment\" *ngIf=\"isPaymentEnable\"><a (click)=\"openPaymentInvoicePopup()\">Make a One-time Payment</a></span>\n               </div>\n             </div>\n             <ng-template #withoutSelection>\n               <div *ngIf=\"clientDetails\" class=\"client-info\">\n                 <label (click)=\"backToClient()\">Group:<span>{{ clientDetails && clientDetails.planAcronym }} {{ clientDetails && clientDetails.specifiedId }} {{ clientDetails && clientDetails.name }} </span></label>\n                 <label (click)=\"backToSubClient()\">Subgroup:<span>{{ subGroupId ? subGroupId : 'All Subgroups' }} {{ subGroupId ? subClientResults.subClients[0]?.name : '' }}</span></label>\n               </div>\n             </ng-template>\n           </div>\n          <div *ngIf=\"dateRange && !isPaymentHistoryFeature\">\n           <form [formGroup]=\"dateForm\" (ngSubmit)=\"fromDateRangeForm()\">\n            <div class=\"row date-form\">\n              <div class=\"col-sm-2\">\n                <rs-input formControlName=\"startDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"From Date\"\n                  validation=\"eager\"></rs-input>\n              </div>\n              <div class=\"col-sm-2\">\n                <rs-input formControlName=\"endDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"To Date\"\n                  validation=\"eager\"></rs-input>\n              </div>\n              <div class=\"col-sm-2 date-submit-button\">\n                <button [disabled]=\"!dateForm.valid\"  rs-raised-button color=\"primary\">Submit</button>\n              </div>\n            </div>\n            <ul class =\"date-range-info\"> <li>Date Range is optional. If not specified will default to the last 3 months worth of processed invoices</li></ul>\n          </form>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"showPaymentInvoice\">\n          <billing-payment-invoice [paymentInvoiceFeed]=\"paymentInvoiceFeed\" [loaderImage]=\"loaderImage\" (paymentInvoiceDilogClosed)=\"paymentInvoiceDilogClosed($event)\">\n          </billing-payment-invoice>\n        </ng-container>\n    </div>\n  </div>\n", styles: [".client-billing-search .client-search-options label{white-space:nowrap;color:#124980;font-weight:700}.client-billing-search .client-search-options{flex-direction:column}.client-billing-search .client-search-row{align-content:center;justify-content:center;align-items:center;padding:0 10px}.client-billing-search .client-search-buttons{text-align:right}.client-billing-search .client-search-active{padding-top:30px}.client-billing-search .row{margin-bottom:16px;font-weight:700}.client-billing-search hr.profile-thematic-break{border-top:2px solid #d1c9c9}.client-billing-search .no-results{color:#a94442;font-weight:700;padding-bottom:10px}@media (min-width: 768px){.client-billing-search .client-search-options{flex-direction:row}}.client-billing-search .client-search-results .search-results-content tbody tr:nth-child(odd){background-color:#f0f2f5}.client-billing-search .client-search-results .search-results-content th,.client-billing-search .client-search-results .search-results-content td{padding:5px 0}.client-billing-search .client-search-results .search-results-content th:first-of-type,.client-billing-search .client-search-results .search-results-content td:first-of-type,.client-billing-search .client-search-results .search-results-content th:last-of-type,.client-billing-search .client-search-results .search-results-content td:last-of-type{padding-left:32px}.client-billing-search .client-search-results .search-results-content th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.client-billing-search .client-search-results .search-results-content table{border-collapse:collapse;width:100%}.client-billing-search .client-search-results .search-results-content a{color:#06c;font-weight:700;cursor:pointer}.client-billing-search .client-search-results .search-results-content .active-indicator{background-color:#41a929;padding:5px;border-radius:3px;color:#fff;text-transform:capitalize}.client-billing-search .client-search-results .search-results-content .inactive-indicator{background-color:#d3d3d3}.client-billing-search .client-search-results .search-results-content .show-more{padding-top:32px;text-align:center;padding-left:0!important;border:transparent!important;border-radius:20px!important;font-size:15px!important}.client-billing-search .client-search-results .show{display:block}.client-billing-search .client-search-results .top-links{border-top:1px solid gray;padding:5px 25px 0 32px;display:flex;justify-content:space-between}.client-billing-search .client-search-results .top-links .top-links-left span{color:#0c6ac7;border-bottom:1px solid #f9981c;padding-bottom:5px;cursor:pointer}.client-billing-search .client-search-results .top-links .top-link-check{flex:1;margin-left:20px}.client-billing-search .client-search-results .top-links .top-links-right span{color:#0c6ac7;padding-bottom:5px}.client-billing-search .client-search-results .top-links .top-links-left-pg{color:#4b4c4d;padding-bottom:5px;cursor:pointer;padding-top:20px}.client-billing-search .client-search-results .top-links .top-links-right-pg{color:#0c6ac7;padding-bottom:5px}.client-billing-search .billing-search{margin:0 0 24px;padding:0 10px}.client-billing-search .billing-search .group-subgroup-heading{border-bottom:1px solid grey;padding:20px 15px 5px;margin-bottom:10px;font-size:16px;justify-content:space-between}.client-billing-search .billing-search .group-subgroup-heading .client-info label{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.client-billing-search .billing-search .group-subgroup-heading .client-info label span{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.client-billing-search .billing-search .group-subgroup-heading .billing-row{display:flex;justify-content:space-between;align-items:center}.client-billing-search .billing-search .group-subgroup-heading .group-subgroup{display:flex}.client-billing-search .billing-search .group-subgroup-heading .billing-info{text-align:right}.client-billing-search .billing-search .group-subgroup-heading .billing-info label{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.client-billing-search .billing-search .group-subgroup-heading .billing-info label .due{color:red}.client-billing-search .billing-search .group-subgroup-heading .billing-info label span{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.client-billing-search .billing-search .group-subgroup-heading .billing-info a{color:#0c6ac7;padding:0 15px 0 10px;font-weight:700;cursor:pointer}.client-billing-search .billing-search .group-subgroup-heading label:last-child{padding-left:10px}.client-billing-search .billing-search .group-subgroup-heading .make-a-payment{border-left:1px solid gray}.client-billing-search .billing-search .date-range-info{margin-left:-20px;font-weight:700}.client-billing-search .billing-search .date-form{margin-top:5px}.client-billing-search .billing-search .date-form .date-submit-button{margin-top:20px}:host ::ng-deep .billing-component .rs-tab-content{margin:0 0 auto!important}:host ::ng-deep .billing-component .rs-tab-header-container{padding:0!important;margin-left:30px!important}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: BillingAsync }, { type: i2.UntypedFormBuilder }, { type: UserAuthConfig }], { billing: [{
            type: Input
        }], loaderImage: [{
            type: Input
        }], dateRange: [{
            type: Input
        }], selectedAdminPlan: [{
            type: Input
        }], disableInactive: [{
            type: Input
        }], userFeed: [{
            type: Input
        }], resetSelected: [{
            type: Output
        }], billingInput: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BillingSearchComponent, { className: "BillingSearchComponent", filePath: "lib/billing/billing-search/billing-search.component.ts", lineNumber: 33 }); })();

function HistoricalReportsComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-invoice-download", 10);
    i0.ɵɵlistener("downloadDilogClosed", function HistoricalReportsComponent_ng_container_13_Template_billing_invoice_download_downloadDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.downloadDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("downloadFeed", ctx_r1.invoiceDownloadInput)("loaderImage", ctx_r1.loaderImage);
} }
class HistoricalReportsComponent {
    // @Input() clientInfo;
    get clientInfo() {
        return this._clientInfo;
    }
    set clientInfo(value) {
        this._clientInfo = value;
    }
    constructor(lux, fb, bAsync) {
        this.lux = lux;
        this.fb = fb;
        this.bAsync = bAsync;
        this.luxId = 'billing-lib-historical-comp' + this.constructor.name;
        this.billType = ['Claim Invoice', 'Admin Invoice'];
        this.reportType = ['Consolidated', 'Non-Consolidated'];
        this.historicalReportsValidation = (fg) => {
            const crt = fg.get('reportType');
            const cbt = fg.get('billType');
            const start = fg.get('hStartDate');
            const end = fg.get('hEndDate');
            if (crt.valid && cbt.valid) {
                if (crt.value === 'Consolidated' && cbt.value === 'Claim Invoice') {
                    if (end.valid) {
                        moment(end.value).isAfter(moment(start.value)
                            .add(1, 'month')
                            .endOf('month')
                            .format('YYYY-MM-DD'))
                            ? end.setErrors({ consolidatedClaimInvoice: true })
                            : end.setErrors(null);
                    }
                }
                else if (crt.value === 'Non-Consolidated' &&
                    cbt.value === 'Claim Invoice') {
                    if (end.valid) {
                        moment(end.value).isAfter(moment(start.value).endOf('month').format('YYYY-MM-DD'))
                            ? end.setErrors({ nonConsolidatedClaimInvoice: true })
                            : end.setErrors(null);
                    }
                }
                else if ((crt.value === 'Consolidated' || crt.value === 'Non-Consolidated') &&
                    cbt.value === 'Admin Invoice') {
                    if (start.valid) {
                        moment(start.value).isAfter(moment(start.value).startOf('month').format('YYYY-MM-DD'))
                            ? start.setErrors({ consolidatedNCClaimInvoiceStartDate: true })
                            : start.setErrors(null);
                    }
                    if (end.valid) {
                        !moment(end.value).isSame(moment(start.value).endOf('month').format('YYYY-MM-DD'))
                            ? end.setErrors({ consolidatedNCClaimInvoiceEndDate: true })
                            : end.setErrors(null);
                    }
                }
                if (end.valid &&
                    start.valid &&
                    moment(end.value).isBefore(moment(start.value).format('YYYY-MM-DD'))) {
                    moment(end.value).isBefore(moment(start.value).format('YYYY-MM-DD'))
                        ? end.setErrors({ historicalReportsEndDate: true })
                        : end.setErrors(null);
                }
            }
            return null;
        };
    }
    ngOnInit() {
        this.setHistoricalForm();
    }
    setHistoricalForm() {
        this.historicalReportsDateForm = this.fb.group({
            hStartDate: ['', [Validators.required]],
            hEndDate: ['', [Validators.required]],
            billType: ['', [Validators.required]],
            reportType: ['', [Validators.required]],
        }, { validator: this.historicalReportsValidation });
        this.historyFormFields$ = combineLatest([
            this.historicalReportsDateForm.controls.reportType.valueChanges.pipe(startWith('')),
            this.historicalReportsDateForm.controls.billType.valueChanges.pipe(startWith('')),
        ]).subscribe((x) => {
            const start = this.historicalReportsDateForm.controls.hStartDate;
            const end = this.historicalReportsDateForm.controls.hEndDate;
            [start, end].forEach((ctl) => {
                ctl.setValue('');
                ctl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            });
        });
    }
    historicalReportForm() {
        const reportsForm = this.historicalReportsDateForm.getRawValue();
        const isnonConsolidated = !!(reportsForm.reportType === 'Non-Consolidated');
        this.invoiceDownloadInput = {
            ...this.clientInfo,
            billType: reportsForm.billType,
            isFromHistoricalReports: true,
            selectedView: isnonConsolidated
                ? 'Non-Consolidated'
                : 'Consolidated Reports',
            invoiceStartDate: reportsForm.hStartDate,
            invoiceEndDate: reportsForm.hEndDate,
        };
        const request = [
            {
                planAcronym: this.clientInfo.planAcronym,
                ...(isnonConsolidated
                    ? {
                        clientsSubclients: {
                            clientSpecifiedIdentifier: this.clientInfo.groupId,
                            subClientSpecifiedIdentifier: this.clientInfo.subGroupId || '',
                        },
                    }
                    : {
                        consolidatedTo: {
                            clientSpecifiedIdentifier: this.clientInfo.groupId,
                            subClientSpecifiedIdentifier: this.clientInfo.subGroupId || '',
                        },
                    }),
                billType: reportsForm.billType === 'Claim Invoice' ? 'CLAIMS' : 'ADMIN',
                startDate: reportsForm.hStartDate,
                endDate: reportsForm.hEndDate,
            },
        ];
        this.lux.set((state) => state.billing, { reportFormatsRequest: request });
        this.bAsync.getBillingReportsTypesAndFormats(isnonConsolidated).subscribe();
    }
    downloadDilogClosed() {
        this.lux.set(state => state.billing, { isNavigateToMyreports: false });
        this.invoiceDownloadInput = {};
        this.historicalReportsDateForm.reset();
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
        this.historyFormFields$.unsubscribe();
    }
    static { this.ɵfac = function HistoricalReportsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HistoricalReportsComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HistoricalReportsComponent, selectors: [["historical-reports"]], inputs: { clientInfo: "clientInfo" }, decls: 15, vars: 7, consts: [[3, "ngSubmit", "formGroup"], [1, "row", "date-form"], [1, "col-sm-2"], ["formControlName", "reportType", "label", "Report Type", "validation", "eager", 3, "items"], ["formControlName", "billType", "label", "Bill Type", "validation", "eager", 3, "items"], ["formControlName", "hStartDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "From Date", "validation", "eager"], ["formControlName", "hEndDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "To Date", "validation", "eager"], [1, "col-sm-2", "date-submit-button"], ["rs-raised-button", "", "color", "primary", 3, "disabled"], [4, "ngIf"], [3, "downloadDilogClosed", "downloadFeed", "loaderImage"]], template: function HistoricalReportsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵlistener("ngSubmit", function HistoricalReportsComponent_Template_form_ngSubmit_0_listener() { return ctx.historicalReportForm(); });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "rs-select", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵelement(5, "rs-select", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 2);
            i0.ɵɵelement(7, "rs-input", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 2);
            i0.ɵɵelement(9, "rs-input", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7)(11, "button", 8);
            i0.ɵɵtext(12, "Submit");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(13, HistoricalReportsComponent_ng_container_13_Template, 2, 2, "ng-container", 9);
            i0.ɵɵpipe(14, "keyvalue");
        } if (rf & 2) {
            let tmp_4_0;
            i0.ɵɵproperty("formGroup", ctx.historicalReportsDateForm);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("items", ctx.reportType);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("items", ctx.billType);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("disabled", !ctx.historicalReportsDateForm.valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (tmp_4_0 = i0.ɵɵpipeBind1(14, 5, ctx.invoiceDownloadInput)) == null ? null : tmp_4_0.length);
        } }, dependencies: [i3$1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i6$1.SelectComponent, i2.FormGroupDirective, i2.FormControlName, i8.InputComponent, i5.ButtonComponent, InvoiceDownloadComponent, i3$1.KeyValuePipe], styles: [".date-form[_ngcontent-%COMP%]{margin-top:5px}.date-form[_ngcontent-%COMP%]   .date-submit-button[_ngcontent-%COMP%]{margin-top:20px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HistoricalReportsComponent, [{
        type: Component,
        args: [{ selector: 'historical-reports', template: "<form [formGroup]=\"historicalReportsDateForm\" (ngSubmit)=\"historicalReportForm()\">\n    <div class=\"row date-form\">\n      <div class=\"col-sm-2\">\n        <rs-select formControlName=\"reportType\" label=\"Report Type\"  validation=\"eager\" [items]=\"reportType\"></rs-select>\n      </div>\n      <div class=\"col-sm-2\">\n        <rs-select formControlName=\"billType\" label=\"Bill Type\"  validation=\"eager\" [items]=\"billType\"></rs-select>\n      </div>\n      <div class=\"col-sm-2\">\n        <rs-input formControlName=\"hStartDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"From Date\" validation=\"eager\"></rs-input>\n      </div>\n      <div class=\"col-sm-2\">\n        <rs-input formControlName=\"hEndDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"To Date\" validation=\"eager\"></rs-input>\n      </div>\n      <div class=\"col-sm-2 date-submit-button\">\n        <button [disabled]=\"!historicalReportsDateForm.valid\"  rs-raised-button color=\"primary\">Submit</button>\n      </div>\n    </div>\n  </form>\n  <ng-container *ngIf=\"(invoiceDownloadInput| keyvalue)?.length\">\n    <billing-invoice-download [downloadFeed]=\"invoiceDownloadInput\" [loaderImage]=\"loaderImage\" (downloadDilogClosed)=\"downloadDilogClosed($event)\">\n    </billing-invoice-download>\n  </ng-container>", styles: [".date-form{margin-top:5px}.date-form .date-submit-button{margin-top:20px}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: i2.UntypedFormBuilder }, { type: BillingAsync }], { clientInfo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HistoricalReportsComponent, { className: "HistoricalReportsComponent", filePath: "lib/billing/historical-reports/historical-reports.component.ts", lineNumber: 16 }); })();

function PaymentHistoryComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.errorMsg);
} }
function PaymentHistoryComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r0.loaderImage);
} }
function PaymentHistoryComponent_ng_container_23_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td", 23);
    i0.ɵɵlistener("keydown.enter", function PaymentHistoryComponent_ng_container_23_tr_18_Template_td_keydown_enter_1_listener() { const item_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.getPaymentGroupDetails(item_r3)); })("click", function PaymentHistoryComponent_ng_container_23_tr_18_Template_td_click_1_listener() { const item_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.getPaymentGroupDetails(item_r3)); });
    i0.ɵɵelementStart(2, "a");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r3.paymentId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, item_r3.paymentAmount) || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(9, 7, item_r3.dateReceived, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(12, 10, item_r3.dateApplied, "MM/dd/yyyy") || "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r3.paymentMethod);
} }
function PaymentHistoryComponent_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "h4");
    i0.ɵɵtext(3, "Payment History");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "table")(5, "thead")(6, "tr")(7, "th");
    i0.ɵɵtext(8, "Payment ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Payment Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Date Received");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Date Applied");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Payment Method");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(17, "tbody");
    i0.ɵɵtemplate(18, PaymentHistoryComponent_ng_container_23_tr_18_Template, 15, 13, "tr", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(18);
    i0.ɵɵproperty("ngForOf", ctx_r0.paymentHistoryResponse.paymentHistories);
} }
function PaymentHistoryComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "rs-paginator", 19);
    i0.ɵɵlistener("page", function PaymentHistoryComponent_div_24_Template_rs_paginator_page_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.pageChanged($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("length", ctx_r0.paymentHistoryResponse.pagination.totalRecords)("pageSize", ctx_r0.defaultPageSize);
} }
function PaymentHistoryComponent_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.paymentActivityError);
} }
function PaymentHistoryComponent_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "rs-loader", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("imageSrc", ctx_r0.loaderImage);
} }
function PaymentHistoryComponent_ng_container_60_tr_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.groupSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.subGroupSpecifiedIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.subGroupName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.invoiceNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.activityType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 6, item_r5.amount));
} }
function PaymentHistoryComponent_ng_container_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "h4");
    i0.ɵɵtext(3, "Payment History");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "table")(5, "thead")(6, "tr")(7, "th");
    i0.ɵɵtext(8, "Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Sub Group ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Sub Group Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Invoice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Activity Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Amount");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "tbody");
    i0.ɵɵtemplate(20, PaymentHistoryComponent_ng_container_60_tr_20_Template, 14, 8, "tr", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(20);
    i0.ɵɵproperty("ngForOf", ctx_r0.paymentActivityResponse.payments && ctx_r0.paymentActivityResponse.payments.activities);
} }
class PaymentHistoryComponent {
    get feed() {
        return this._feed;
    }
    set feed(val) {
        this._feed = val;
        val && this.getPaymentHistory();
    }
    constructor(lux, fb, bAsync) {
        this.lux = lux;
        this.fb = fb;
        this.bAsync = bAsync;
        this.loaderImage = '';
        this.luxId = 'billing-payment-his-comp' + this.constructor.name;
        this.defaultPageSize = 25;
        this.PaymentActivitiesDefaultPageSize = 25;
        this.paymentMethods = [
            { label: '', value: '' },
            { label: 'Credit Card', value: 'Credit Card' },
            { label: 'EFT', value: 'EFT' },
            { label: 'Check', value: 'Check' },
            { label: 'Direct Debit', value: 'Direct Debt' }
        ];
        this.paymentHistoryResponse$ = this.lux.get(paymentHistoryResponse, this.luxId);
        this.errorMsg$ = this.lux.get(paymentHistoryError, this.luxId);
        this.isFetchingPaymentHistory$ = this.lux.get(isFetchingPaymentHistory, this.luxId);
        this.paymentActivityResponse$ = this.lux.get(paymentActivityResponse, this.luxId);
        this.isFetchingpaymentActivity$ = this.lux.get(isFetchingPaymentActivity, this.luxId);
        this.paymentActivityError$ = this.lux.get(paymentActivityError, this.luxId);
    }
    ngOnInit() {
        this.errorMsg$.subscribe((x) => (this.errorMsg = x));
        this.isFetchingPaymentHistory$.subscribe((x) => (this.isFetchingPaymentHistory = x));
        this.paymentHistoryResponse$.subscribe(response => this.paymentHistoryResponse = response);
        this.paymentActivityResponse$.subscribe(response => {
            if (response && response.payments) {
                this.paymentActivityResponse = response;
            }
        });
        this.paymentActivityError$.subscribe(error => this.paymentActivityError = error);
        this.isFetchingpaymentActivity$.subscribe(isFetching => this.isFetchingpaymentActivity = isFetching);
        this.setHistoryForm();
    }
    setHistoryForm() {
        this.paymentHistoryFiltersForm = this.fb.group({
            paymentMethod: [''],
            fromAmount: [''],
            toAmount: [''],
            fromDateRecieved: [''],
            toDateReceived: [''],
        }, { validator: this.paymentHistoryValidation() });
    }
    paymentHistoryValidation() {
        return (fg) => {
            const fromDate = fg.get('fromDateRecieved');
            const toDate = fg.get('toDateReceived');
            if ((fromDate) && (toDate)) {
                moment(toDate.value).isBefore(moment(fromDate.value)) ? toDate.setErrors({ paymentHistoryToDate: true })
                    : toDate.setErrors(null);
                moment(fromDate.value).isAfter(moment(toDate.value)) ? fromDate.setErrors({ paymentHistoryFromDate: true })
                    : fromDate.setErrors(null);
            }
        };
    }
    getPaymentHistory(isFilterApplied) {
        this.lux.set(state => state.billing, { paymentHistoryResponse: initialBillingState.paymentHistoryResponse });
        this.lux.set(state => state.billing, { paymentHistoryError: initialBillingState.paymentHistoryError });
        !isFilterApplied && this.setHistoryForm();
        const formvalues = this.paymentHistoryFiltersForm.getRawValue();
        const commonPaymentHistoryRequest = {
            pagination: {
                offset: 0,
                limit: 25
            },
            planAcronym: this.feed.paymentId ? (this.feed.planAcronym).toString() : this.feed.planAcronym,
            paymentMethod: formvalues.paymentMethod,
            fromAmount: formvalues.fromAmount,
            toAmount: formvalues.toAmount,
            fromDateReceived: formvalues.fromDateRecieved ? moment(formvalues.fromDateRecieved).format('YYYY-MM-DD') : '',
            toDateReceived: formvalues.toDateReceived ? moment(formvalues.toDateReceived).format('YYYY-MM-DD') : ''
        };
        const paymentHistoryRequest = {
            ...commonPaymentHistoryRequest,
            ...(!this.feed.paymentId) ? {
                clientsSubclients: {
                    clientSpecifiedIdentifier: this.feed.groupId,
                    subClientSpecifiedIdentifier: this.feed.subGroupId
                }
            } : {
                paymentID: this.feed.paymentId
            }
        };
        Object.keys(paymentHistoryRequest).forEach(k => (!paymentHistoryRequest[k] && paymentHistoryRequest[k] !== undefined) && delete paymentHistoryRequest[k]);
        this.lux.set((state) => state.billing, { paymentHistoryRequest });
        this.bAsync.getPaymentHistory().subscribe();
    }
    pageChanged(page) {
        if (this.showPaymentActivities) {
            this.getMorePaymentActivities(page.pageIndex >= 1 ? page.pageIndex * this.PaymentActivitiesDefaultPageSize + 1 : 0);
        }
        else {
            this.getMoreRecords(page.pageIndex >= 1 ? page.pageIndex * this.defaultPageSize + 1 : 0);
        }
    }
    getMoreRecords(offset) {
        this.lux.set((state) => state.billing.paymentHistoryRequest.pagination, { offset });
        this.bAsync.getPaymentHistory().subscribe();
    }
    getMorePaymentActivities(offset) {
        this.lux.set((state) => state.billing.paymentActivitiesRequest, { offset });
        this.bAsync.getPaymentGroupDetails().subscribe();
    }
    getPaymentGroupDetails(data) {
        this.paymentActivityError = '';
        const request = {
            planAcronym: this.feed.planAcronym,
            paymentId: data.paymentId,
            depositId: data.depositId,
            businessUnit: data.businessUnit,
            offset: 0,
            limit: 25,
        };
        this.lux.set((state) => state.billing, { paymentActivitiesRequest: request });
        this.bAsync.getPaymentGroupDetails().subscribe();
        this.showPaymentActivities = true;
    }
    dialogClose(event) {
        this.showPaymentActivities = false;
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function PaymentHistoryComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaymentHistoryComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentHistoryComponent, selectors: [["app-payment-history"]], inputs: { loaderImage: "loaderImage", feed: "feed" }, decls: 63, vars: 26, consts: [[1, "payment-history"], [3, "ngSubmit", "formGroup"], [1, "row", "date-form"], [1, "col-sm-2"], ["formControlName", "paymentMethod", "label", "Payment Method", "validation", "eager", 3, "items"], ["formControlName", "fromAmount", "label", "From Amount", "validation", "eager"], ["formControlName", "toAmount", "label", "To Amount", "validation", "eager"], ["formControlName", "fromDateRecieved", "type", "date", "placeholder", "MM/DD/YYYY", "label", "From Date Recevied", "validation", "eager"], ["formControlName", "toDateReceived", "type", "date", "placeholder", "MM/DD/YYYY", "label", "To Date Received", "validation", "eager"], [1, "col-sm-2", "date-submit-button"], ["rs-raised-button", "", "color", "primary", 3, "disabled"], [1, "row", "default-text"], [1, "search-results-content"], [4, "ngIf"], ["class", "billing-pagination", 4, "ngIf"], [1, "payment-history-modal"], ["maxWidth", "55%", "heading", "Payment Group Detail", 3, "visibleChange", "visible"], [1, "activity-content"], [1, "billing-pagination"], ["showFirstLastButtons", "", 3, "page", "length", "pageSize"], [1, "error"], [3, "imageSrc"], [4, "ngFor", "ngForOf"], ["role", "button", "tabindex", "0", 3, "keydown.enter", "click"]], template: function PaymentHistoryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "form", 1);
            i0.ɵɵlistener("ngSubmit", function PaymentHistoryComponent_Template_form_ngSubmit_1_listener() { return ctx.getPaymentHistory(true); });
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "rs-select", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵelement(6, "rs-input", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 3);
            i0.ɵɵelement(8, "rs-input", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 3);
            i0.ɵɵelement(10, "rs-input", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 3);
            i0.ɵɵelement(12, "rs-input", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 9)(14, "button", 10);
            i0.ɵɵtext(15, "Submit");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(16, "div", 11)(17, "ul")(18, "li");
            i0.ɵɵtext(19, " By Default one year of Payment history is returned");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(20, "div", 12);
            i0.ɵɵtemplate(21, PaymentHistoryComponent_ng_container_21_Template, 3, 1, "ng-container", 13)(22, PaymentHistoryComponent_ng_container_22_Template, 2, 1, "ng-container", 13)(23, PaymentHistoryComponent_ng_container_23_Template, 19, 1, "ng-container", 13)(24, PaymentHistoryComponent_div_24_Template, 2, 2, "div", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "div", 15)(26, "rs-dialog", 16);
            i0.ɵɵlistener("visibleChange", function PaymentHistoryComponent_Template_rs_dialog_visibleChange_26_listener($event) { return ctx.dialogClose($event); });
            i0.ɵɵelementStart(27, "div", 0)(28, "div", 12);
            i0.ɵɵtemplate(29, PaymentHistoryComponent_ng_container_29_Template, 3, 1, "ng-container", 13)(30, PaymentHistoryComponent_ng_container_30_Template, 2, 1, "ng-container", 13);
            i0.ɵɵelementStart(31, "div", 17)(32, "div")(33, "label");
            i0.ɵɵtext(34, "Payment ID");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "span");
            i0.ɵɵtext(36);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "div")(38, "label");
            i0.ɵɵtext(39, "Payment Group Amount");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(40, "span");
            i0.ɵɵtext(41);
            i0.ɵɵpipe(42, "currency");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(43, "div")(44, "label");
            i0.ɵɵtext(45, "Date Received");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "span");
            i0.ɵɵtext(47);
            i0.ɵɵpipe(48, "date");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(49, "div")(50, "label");
            i0.ɵɵtext(51, "Date Applied");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(52, "span");
            i0.ɵɵtext(53);
            i0.ɵɵpipe(54, "date");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(55, "div")(56, "label");
            i0.ɵɵtext(57, "Payment Method");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "span");
            i0.ɵɵtext(59);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(60, PaymentHistoryComponent_ng_container_60_Template, 21, 1, "ng-container", 13);
            i0.ɵɵelementStart(61, "div", 18)(62, "rs-paginator", 19);
            i0.ɵɵlistener("page", function PaymentHistoryComponent_Template_rs_paginator_page_62_listener($event) { return ctx.pageChanged($event); });
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.paymentHistoryFiltersForm);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("items", ctx.paymentMethods);
            i0.ɵɵadvance(10);
            i0.ɵɵproperty("disabled", !ctx.paymentHistoryFiltersForm.valid);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", ctx.errorMsg);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isFetchingPaymentHistory);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.paymentHistoryResponse && ctx.paymentHistoryResponse.paymentHistories && ctx.paymentHistoryResponse.paymentHistories.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.paymentHistoryResponse && ctx.paymentHistoryResponse.paymentHistories && ctx.paymentHistoryResponse.paymentHistories.length);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("visible", ctx.showPaymentActivities);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.paymentActivityError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isFetchingpaymentActivity);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.paymentActivityResponse.payments.paymentId || "");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(42, 18, ctx.paymentActivityResponse.payments.paymentAmount) || "");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(48, 20, ctx.paymentActivityResponse.payments.dateReceived, "MM/dd/yyyy") || "");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(54, 23, ctx.paymentActivityResponse.payments.dateApplied, "MM/dd/yyyy") || "");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(ctx.paymentActivityResponse.payments.paymentMethod || "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.paymentActivityResponse && ctx.paymentActivityResponse.payments);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("length", ctx.paymentActivityResponse.pagination.totalRecords)("pageSize", ctx.PaymentActivitiesDefaultPageSize);
        } }, dependencies: [i3$1.NgForOf, i3$1.NgIf, i4.PaginatorComponent, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i6$1.SelectComponent, i2.FormGroupDirective, i2.FormControlName, i8.InputComponent, i5.ButtonComponent, i6.DialogComponent, i7.LoaderComponent, i3$1.CurrencyPipe, i3$1.DatePipe], styles: [".payment-history[_ngcontent-%COMP%]{padding:0 16px 0 29px}.payment-history[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]{margin-top:5px}.payment-history[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]   .date-submit-button[_ngcontent-%COMP%]{margin-top:20px}.payment-history[_ngcontent-%COMP%]   .default-text[_ngcontent-%COMP%]{font-weight:700}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#f0f2f5}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:12px 5px;width:100px}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:focus{outline:none;border:2px solid #1D8928}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0c6ac7;text-decoration:none;cursor:pointer}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{vertical-align:middle}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type, .payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-of-type, .payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:last-of-type, .payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-of-type{padding-left:32px}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border:1px solid #c2c2c2;border-collapse:collapse;width:100%}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{cursor:pointer}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]{padding:10px 10px 15px}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:5px 0}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;width:18%}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:after{content:\":\"}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;font-weight:700;font-size:1em;margin-right:5px}.payment-history[_ngcontent-%COMP%]   .search-results-content[_ngcontent-%COMP%]   .activity-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:last-of-type{margin-left:5px}.payment-history[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.payment-history[_ngcontent-%COMP%]   .billing-pagination[_ngcontent-%COMP%]{margin:2px 0 0 30px;padding:15px}[_nghost-%COMP%]     .payment-history-modal rs-card.rs-dialog .rs-card .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentHistoryComponent, [{
        type: Component,
        args: [{ selector: 'app-payment-history', template: "<div class=\"payment-history\">\n    <form [formGroup]=\"paymentHistoryFiltersForm\" (ngSubmit)=\"getPaymentHistory(true)\">\n        <div class=\"row date-form\">\n            <div class=\"col-sm-2\">\n                <rs-select formControlName=\"paymentMethod\" label=\"Payment Method\" validation=\"eager\"\n                    [items]=\"paymentMethods\"></rs-select>\n            </div>\n            <div class=\"col-sm-2\">\n                <rs-input formControlName=\"fromAmount\" label=\"From Amount\" validation=\"eager\"></rs-input>\n            </div>\n            <div class=\"col-sm-2\">\n                <rs-input formControlName=\"toAmount\" label=\"To Amount\" validation=\"eager\"></rs-input>\n            </div>\n            <div class=\"col-sm-2\">\n                <rs-input formControlName=\"fromDateRecieved\" type=\"date\" placeholder=\"MM/DD/YYYY\"\n                    label=\"From Date Recevied\" validation=\"eager\"></rs-input>\n            </div>\n            <div class=\"col-sm-2\">\n                <rs-input formControlName=\"toDateReceived\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"To Date Received\"\n                    validation=\"eager\"></rs-input>\n            </div>\n            <div class=\"col-sm-2 date-submit-button\">\n                <button [disabled]=\"!paymentHistoryFiltersForm.valid\" rs-raised-button color=\"primary\">Submit</button>\n            </div>\n        </div>\n        <div class=\"row default-text\">\n            <ul>\n                <li> By Default one year of Payment history is returned</li>\n            </ul>\n        </div>\n    </form>\n    <div class=\"search-results-content\">\n        <ng-container *ngIf=\"errorMsg\">\n            <div class=\"error\">{{errorMsg}}</div>\n        </ng-container>\n        <ng-container *ngIf=\"isFetchingPaymentHistory\">\n            <rs-loader imageSrc={{loaderImage}}></rs-loader>\n        </ng-container>\n        <ng-container\n            *ngIf=\"paymentHistoryResponse && paymentHistoryResponse.paymentHistories && paymentHistoryResponse.paymentHistories.length\">\n            <div>\n                <h4>Payment History</h4>\n            </div>\n            <table>\n                <thead>\n                    <tr>\n                        <th>Payment ID</th>\n                        <th>Payment Amount</th>\n                        <th>Date Received</th>\n                        <th>Date Applied</th>\n                        <th>Payment Method</th>\n\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let item of paymentHistoryResponse.paymentHistories\">\n                        <td role=\"button\" tabindex=\"0\" (keydown.enter)=\"getPaymentGroupDetails(item)\" (click) = \"getPaymentGroupDetails(item)\"><a>{{item.paymentId}}</a></td>\n                        <td>{{((item.paymentAmount) | currency) || ''}}</td>\n                        <td>{{(item.dateReceived | date: 'MM/dd/yyyy') || ''}}</td>\n                        <td>{{(item.dateApplied | date: 'MM/dd/yyyy') || ''}}</td>\n                        <td>{{item.paymentMethod}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </ng-container>\n\n        <div *ngIf=\"paymentHistoryResponse && paymentHistoryResponse.paymentHistories && paymentHistoryResponse.paymentHistories.length\"\n            class=\"billing-pagination\">\n            <rs-paginator [length]=\"paymentHistoryResponse.pagination.totalRecords\" showFirstLastButtons\n                (page)=\"pageChanged($event)\" [pageSize]=\"defaultPageSize\"></rs-paginator>\n        </div>\n    </div>\n</div>\n<div class = \"payment-history-modal \">\n<rs-dialog [visible]=\"showPaymentActivities\" maxWidth=\"55%\" (visibleChange)=\"dialogClose($event)\" heading=\"Payment Group Detail\">\n    <div class=\"payment-history\">\n        <div class=\"search-results-content\">\n            <ng-container *ngIf=\"paymentActivityError\">\n                <div class=\"error\">{{paymentActivityError}}</div>\n            </ng-container>\n            <ng-container *ngIf=\"isFetchingpaymentActivity\">\n                <rs-loader imageSrc={{loaderImage}}></rs-loader>\n            </ng-container>\n            <div class = \"activity-content\">\n                <div>\n                    <label>Payment ID</label>\n                    <span>{{paymentActivityResponse.payments.paymentId || ''}}</span>\n                </div>\n                <div>\n                    <label>Payment Group Amount</label>\n                    <span>{{((paymentActivityResponse.payments.paymentAmount) | currency) || ''}}</span>\n                </div>\n                <div>\n                    <label>Date Received</label>\n                    <span>{{(paymentActivityResponse.payments.dateReceived | date: 'MM/dd/yyyy')|| ''}}</span>\n                </div>\n                <div>\n                    <label>Date Applied</label>\n                    <span>{{(paymentActivityResponse.payments.dateApplied | date: 'MM/dd/yyyy') || ''}}</span>\n                </div>\n                <div>\n                    <label>Payment Method</label>\n                    <span>{{paymentActivityResponse.payments.paymentMethod || ''}}</span>\n                </div>\n            </div>\n            <ng-container\n                *ngIf=\"paymentActivityResponse && paymentActivityResponse.payments\">\n                <div>\n                    <h4>Payment History</h4>\n                </div>\n                <table>\n                    <thead>\n                        <tr>\n                            <th>Group ID</th>\n                            <th>Sub Group ID</th>\n                            <th>Sub Group Name</th>\n                            <th>Invoice</th>\n                            <th>Activity Type</th>\n                            <th>Amount</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr *ngFor=\"let item of paymentActivityResponse.payments && paymentActivityResponse.payments.activities; let i = index\">\n                            <td >{{item.groupSpecifiedIdentifier}}</td>\n                            <td>{{item.subGroupSpecifiedIdentifier}}</td>\n                            <td>{{item.subGroupName}}</td>\n                            <td>{{item.invoiceNumber}}</td>\n                            <td>{{item.activityType}}</td>\n                            <td>{{(item.amount) | currency}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </ng-container>\n            <div class=\"billing-pagination\">\n                <rs-paginator [length]=\"paymentActivityResponse.pagination.totalRecords\" showFirstLastButtons\n                    (page)=\"pageChanged($event)\" [pageSize]=\"PaymentActivitiesDefaultPageSize\"></rs-paginator>\n            </div>\n        </div>\n    </div>\n</rs-dialog>\n</div>\n", styles: [".payment-history{padding:0 16px 0 29px}.payment-history .date-form{margin-top:5px}.payment-history .date-form .date-submit-button{margin-top:20px}.payment-history .default-text{font-weight:700}.payment-history .search-results-content tbody tr:nth-child(odd){background-color:#f0f2f5}.payment-history .search-results-content th,.payment-history .search-results-content td{padding:12px 5px;width:100px}.payment-history .search-results-content td:focus{outline:none;border:2px solid #1D8928}.payment-history .search-results-content td a{color:#0c6ac7;text-decoration:none;cursor:pointer}.payment-history .search-results-content td label{vertical-align:middle}.payment-history .search-results-content th:first-of-type,.payment-history .search-results-content td:first-of-type,.payment-history .search-results-content th:last-of-type,.payment-history .search-results-content td:last-of-type{padding-left:32px}.payment-history .search-results-content th{text-align:left;color:#636870;border-bottom:1px solid #c2c2c2}.payment-history .search-results-content table{border:1px solid #c2c2c2;border-collapse:collapse;width:100%}.payment-history .search-results-content tbody tr{cursor:pointer}.payment-history .search-results-content .activity-content{padding:10px 10px 15px}.payment-history .search-results-content .activity-content div{padding:5px 0}.payment-history .search-results-content .activity-content div label{display:inline-block;width:18%}.payment-history .search-results-content .activity-content div label:after{content:\":\"}.payment-history .search-results-content .activity-content div span{display:inline-block;font-weight:700;font-size:1em;margin-right:5px}.payment-history .search-results-content .activity-content div span:last-of-type{margin-left:5px}.payment-history .error{font-family:monospace;font-weight:700;padding:16px;color:#e01e5a;overflow-x:auto;border:1px solid}.payment-history .billing-pagination{margin:2px 0 0 30px;padding:15px}:host ::ng-deep .payment-history-modal rs-card.rs-dialog .rs-card .rs-card-content.full-content{overflow:auto;padding:0;max-height:calc(100vh - 140px)}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: i2.UntypedFormBuilder }, { type: BillingAsync }], { loaderImage: [{
            type: Input
        }], feed: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentHistoryComponent, { className: "PaymentHistoryComponent", filePath: "lib/billing/payment-history/payment-history.component.ts", lineNumber: 16 }); })();

function BillingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "billing-search", 4);
    i0.ɵɵlistener("resetSelected", function BillingComponent_div_1_Template_billing_search_resetSelected_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetSelected($event)); })("billingInput", function BillingComponent_div_1_Template_billing_search_billingInput_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.billingInput($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedAdminPlan", ctx_r1.selectedAdminPlan)("userFeed", ctx_r1.userFeed)("billing", ctx_r1.billing)("dateRange", !ctx_r1.isHistoricalReportsFeature)("loaderImage", ctx_r1.loaderImage);
} }
function BillingComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.totalBalanceErrorMessage, "");
} }
function BillingComponent_div_2_div_14_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("due", ctx_r1.accountBalance > 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r1.accountBalance));
} }
function BillingComponent_div_2_div_14_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵlistener("keydown.enter", function BillingComponent_div_2_div_14_span_4_Template_span_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.openPaymentInvoicePopup()); });
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵlistener("click", function BillingComponent_div_2_div_14_span_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.openPaymentInvoicePopup()); });
    i0.ɵɵtext(2, "Make a One-time Payment");
    i0.ɵɵelementEnd()();
} }
function BillingComponent_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label");
    i0.ɵɵtext(2, "Total Balance: ");
    i0.ɵɵtemplate(3, BillingComponent_div_2_div_14_span_3_Template, 3, 5, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, BillingComponent_div_2_div_14_span_4_Template, 3, 0, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.accountBalance);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isPaymentEnable);
} }
function BillingComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "form", 18);
    i0.ɵɵlistener("ngSubmit", function BillingComponent_div_2_div_15_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.fromDateRangeForm()); });
    i0.ɵɵelementStart(2, "div", 19)(3, "div", 20);
    i0.ɵɵelement(4, "rs-input", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵelement(6, "rs-input", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 23)(8, "button", 24);
    i0.ɵɵtext(9, "Submit");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "ul", 25)(11, "li");
    i0.ɵɵtext(12, "Date Range is optional. If not specified will default to the last 3 months worth of processed invoices");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.dateForm);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", !ctx_r1.dateForm.valid);
} }
function BillingComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtemplate(2, BillingComponent_div_2_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(3, "div", 8)(4, "div", 9)(5, "div", 10)(6, "label");
    i0.ɵɵtext(7, "Group:");
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "label");
    i0.ɵɵtext(11, "Subgroup:");
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(14, BillingComponent_div_2_div_14_Template, 5, 2, "div", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(15, BillingComponent_div_2_div_15_Template, 13, 2, "div", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.totalBalanceErrorMessage);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate3("", ctx_r1.feed.plan, " ", ctx_r1.feed.clientId, " ", ctx_r1.feed.clientName, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.feed.subClientId ? ctx_r1.feed.subClientId : "All Subgroups", " ", ctx_r1.feed.subClientName, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isHistoricalReportsFeature || !ctx_r1.isPaymentHistoryFeature);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isHistoricalReportsFeature);
} }
function BillingComponent_historical_reports_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "historical-reports", 26);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientInfo", ctx_r1.billingFeed);
} }
function BillingComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelement(2, "billing-reports", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("feed", ctx_r1.billingFeed)("loaderImage", ctx_r1.loaderImage)("billingFeatures", ctx_r1.billing);
} }
function BillingComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelement(2, "app-payment-history", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("feed", ctx_r1.billingFeed)("loaderImage", ctx_r1.loaderImage);
} }
function BillingComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "billing-payment-invoice", 30);
    i0.ɵɵlistener("paymentInvoiceDilogClosed", function BillingComponent_ng_container_9_Template_billing_payment_invoice_paymentInvoiceDilogClosed_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.paymentInvoiceDilogClosed($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("paymentInvoiceFeed", ctx_r1.paymentInvoiceFeed)("loaderImage", ctx_r1.loaderImage);
} }
class BillingComponent extends FeatureComponent {
    get feed() {
        return this._feed;
    }
    set feed(value) {
        this._feed = value;
        if (value) {
            this.getBillingData(value);
        }
    }
    get userFeed() {
        return this._userFeed;
    }
    set userFeed(value) {
        this._userFeed = value;
    }
    get selectedAdminPlan() {
        return this.selectedAdminPlan_;
    }
    set selectedAdminPlan(val) {
        if (val) {
            this.selectedAdminPlan_ = val;
        }
    }
    constructor(lux, fb, bAsync) {
        super(Billing);
        this.lux = lux;
        this.fb = fb;
        this.bAsync = bAsync;
        this.luxId = 'billing-lib-billing-comp' + this.constructor.name;
        this.isHistoricalReportsFeature = false;
        this.isPaymentHistoryFeature = false;
        this.billing = [];
        this.loaderImage = '';
        this.hasFeed = false;
        this.showHistoricalReports = false;
        this.navigateToMyReportsTab = new EventEmitter();
        this.resetSearch = new EventEmitter();
        this._feed = {
            plan: '',
            clientId: '',
            subClientId: '',
            clientName: '',
            subClientName: '',
            adminPlan: '',
        };
        this._userFeed = {
            email: '',
            appName: ''
        };
        this.selectedAdminPlan_ = '';
        this.accountBalance$ = this.lux.get(totalBalanceDueRes, this.luxId);
        this.isFetchingTotalDue$ = this.lux.get(isFetchingTotalBalance, this.luxId);
        this.paymentConfigError$ = this.lux.get(paymentConfigError, this.luxId);
        this.totalBalanceErrorMessage$ = this.lux.get(totalBalanceErrorMessage, this.luxId);
        this.isFetchingpaymentConfig$ = this.lux.get(isFetchingpaymentConfig, this.luxId);
        this.navigateUserToMyReports$ = this.lux.get(navigateUserToMyReports, this.luxId);
    }
    ngOnInit() {
        this.isPaymentHistoryFeature =
            this.billing && this.billing.includes('paymentHistory');
        this.isBMTPaymentHistoryFeature =
            this.billing && this.billing.includes('bmtPaymentHistory');
        this.isHistoricalReportsFeature =
            this.billing && this.billing.includes('historicalReports');
        this.accountBalance$.subscribe((balance) => (this.accountBalance = balance && balance.totalDue));
        this.isFetchingTotalDue$.subscribe((fetching) => (this.isFetchingTotalDue = fetching));
        this.paymentConfigError$.subscribe((error) => (this.paymentConfigError = error));
        this.totalBalanceErrorMessage$.subscribe((error) => (this.totalBalanceErrorMessage = error));
        this.dateForm = this.fb.group({
            startDate: [''],
            endDate: [{ value: '', disabled: true }],
        });
        this.dateForm.controls.startDate.valueChanges
            .pipe(startWith(''))
            .subscribe((val) => {
            if (moment(val).isValid() && val !== '') {
                this.dateForm.controls.endDate.enable();
            }
        });
        this.navigateUserToMyReports$.subscribe(isNavigate => isNavigate && this.navigateToMyReportsTab.emit(true));
    }
    fromDateRangeForm() {
        this.billingFeed = undefined;
        const dateFormValues = this.dateForm.getRawValue();
        const billingData = {
            startDate: dateFormValues.startDate
                ? moment(dateFormValues.startDate).format('YYYY-MM-DD')
                : '',
            endDate: dateFormValues.endDate
                ? moment(dateFormValues.endDate).format('YYYY-MM-DD')
                : '',
        };
        const delay = setTimeout(() => {
            this.getBillingData(billingData, true);
        }, 500);
    }
    getBillingData(data, fromDateRange) {
        this.lux.set(state => state.billing, initialBillingState);
        if (!fromDateRange) {
            this.dateForm && this.dateForm.reset();
        }
        this.hasFeed = true;
        this.totalBalanceErrorMessage = '';
        this.billingFeed = {
            groupId: this.feed.clientId,
            subGroupId: this.feed.subClientId || '',
            planAcronym: this.feed.plan,
            groupName: this.feed.clientName,
            subGroupName: this.feed.subClientName || '',
            fromDate: data.startDate || '',
            toDate: data.endDate || '',
        };
        this.showHistoricalReports = this.billing && this.billing.includes('historicalReports');
        !this.showHistoricalReports && this.paymentConfig(data.plan);
    }
    paymentConfig(payer) {
        const paymentConfigurationsRequest = {
            adminPlanAcronym: this.feed.adminPlan,
            planAcronym: payer ? payer : this.feed.plan,
            clientType: 'Group',
            asOfDate: moment(new Date()).format('YYYY-MM-DD'),
        };
        this.bAsync
            .checkPaymentConfig(paymentConfigurationsRequest)
            .subscribe((config) => {
            this.isPaymentEnable = false;
            if (config && config.length) {
                this.isPaymentEnable = !!(config[0].status === 'A');
                this.businessUnit = config[0].businessUnit;
            }
        });
    }
    billingInput(data) {
        this.billingFeed = undefined;
        const delay = setTimeout(() => {
            this.billingFeed = data;
            this.showHistoricalReports = !!(this.isHistoricalReportsFeature);
        }, 500);
    }
    resetSelected(event) {
        this.resetSearch.emit(true);
        this.billingFeed = undefined;
        this.showHistoricalReports = false;
    }
    openPaymentInvoicePopup() {
        this.showPaymentInvoice = true;
        const dateFormValues = this.dateForm.getRawValue();
        this.paymentInvoiceFeed = {
            adminPlan: this.selectedAdminPlan_,
            planAcronym: this.feed.plan,
            clientSpecifiedIdentifier: this.feed.clientId,
            subClientSpecifiedIdentifier: this.feed.subClientId,
            startDate: dateFormValues.startDate ? moment(dateFormValues.startDate).format('YYYY-MM-DD') : '',
            endDate: dateFormValues.endDate ? moment(dateFormValues.endDate).format('YYYY-MM-DD') : '',
            groupName: this.feed.clientId + ' - ' + this.feed.clientName,
            accountBalance: this.accountBalance,
            businessUnit: this.businessUnit,
            email: this.userFeed.email,
            appName: this.userFeed.appName
        };
    }
    paymentInvoiceDilogClosed() {
        this.paymentInvoiceFeed = '';
        this.showPaymentInvoice = false;
    }
    ngOnDestroy() {
        this.lux.destroy(this.luxId);
    }
    static { this.ɵfac = function BillingComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingComponent)(i0.ɵɵdirectiveInject(i1$1.Lux), i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(BillingAsync)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BillingComponent, selectors: [["billing"]], inputs: { billing: "billing", loaderImage: "loaderImage", feed: "feed", userFeed: "userFeed", selectedAdminPlan: "selectedAdminPlan" }, outputs: { navigateToMyReportsTab: "navigateToMyReportsTab", resetSearch: "resetSearch" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 10, consts: [[1, "billing"], [4, "ngIf"], ["class", "client-billing-search", 4, "ngIf"], [3, "clientInfo", 4, "ngIf"], [3, "resetSelected", "billingInput", "selectedAdminPlan", "userFeed", "billing", "dateRange", "loaderImage"], [1, "client-billing-search"], [1, "billing-search"], ["class", "no-results", 4, "ngIf"], [1, "group-subgroup-heading"], [1, "client-info", "billing-row"], [1, "group-subgroup"], ["class", "billing-info", 4, "ngIf"], [1, "no-results"], [1, "billing-info"], [3, "due", 4, "ngIf"], ["role", "button", "tabindex", "0", "class", "make-a-payment", 3, "keydown.enter", 4, "ngIf"], ["role", "button", "tabindex", "0", 1, "make-a-payment", 3, "keydown.enter"], [3, "click"], [3, "ngSubmit", "formGroup"], [1, "row", "date-form"], [1, "col-sm-2"], ["formControlName", "startDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "From Date", "validation", "eager"], ["formControlName", "endDate", "type", "date", "placeholder", "MM/DD/YYYY", "label", "To Date", "validation", "eager"], [1, "col-sm-2", "date-submit-button"], ["rs-raised-button", "", "color", "primary", 3, "disabled"], [1, "date-range-info"], [3, "clientInfo"], [1, "billing-component"], [3, "feed", "loaderImage", "billingFeatures"], [3, "feed", "loaderImage"], [3, "paymentInvoiceDilogClosed", "paymentInvoiceFeed", "loaderImage"]], template: function BillingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, BillingComponent_div_1_Template, 2, 5, "div", 1)(2, BillingComponent_div_2_Template, 16, 8, "div", 2);
            i0.ɵɵelementContainerStart(3);
            i0.ɵɵtemplate(4, BillingComponent_historical_reports_4_Template, 1, 1, "historical-reports", 3);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵtemplate(5, BillingComponent_ng_container_5_Template, 3, 3, "ng-container", 1);
            i0.ɵɵpipe(6, "keyvalue");
            i0.ɵɵtemplate(7, BillingComponent_ng_container_7_Template, 3, 2, "ng-container", 1);
            i0.ɵɵpipe(8, "keyvalue");
            i0.ɵɵtemplate(9, BillingComponent_ng_container_9_Template, 2, 2, "ng-container", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            let tmp_3_0;
            let tmp_4_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.hasFeed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasFeed && !ctx.isBMTPaymentHistoryFeature);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showHistoricalReports && ctx.isHistoricalReportsFeature && ctx.billingFeed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ((tmp_3_0 = i0.ɵɵpipeBind1(6, 6, ctx.billingFeed)) == null ? null : tmp_3_0.length) && !ctx.isHistoricalReportsFeature && !ctx.isPaymentHistoryFeature && !ctx.isBMTPaymentHistoryFeature);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ((tmp_4_0 = i0.ɵɵpipeBind1(8, 8, ctx.billingFeed)) == null ? null : tmp_4_0.length) && (ctx.isPaymentHistoryFeature || ctx.isBMTPaymentHistoryFeature));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showPaymentInvoice);
        } }, dependencies: [i3$1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i8.InputComponent, i5.ButtonComponent, BillingReportsComponent, BillingSearchComponent, HistoricalReportsComponent, PaymentHistoryComponent, PaymentInvoiceComponent, i3$1.CurrencyPipe, i3$1.KeyValuePipe], styles: [".billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{white-space:nowrap;color:#124980;font-weight:700}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]{flex-direction:column}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin-bottom:16px;font-weight:700}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .no-results[_ngcontent-%COMP%]{color:#a94442;font-weight:700;padding-bottom:10px}@media (min-width: 768px){.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .client-search-options[_ngcontent-%COMP%]{flex-direction:row}}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]{margin:0 0 24px;padding:0 10px}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]{border-bottom:1px solid grey;padding:20px 15px 5px;margin-bottom:10px;font-size:16px;justify-content:space-between}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .client-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .client-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .group-subgroup[_ngcontent-%COMP%]{display:flex}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]{text-align:right}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   .due[_ngcontent-%COMP%]{color:#a94442}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .billing-info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#0c6ac7;padding:0 15px 0 10px;font-weight:700;cursor:pointer}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:last-child{padding-left:10px}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .group-subgroup-heading[_ngcontent-%COMP%]   .make-a-payment[_ngcontent-%COMP%]{border-left:1px solid gray}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-range-info[_ngcontent-%COMP%]{margin-left:-20px;font-weight:700}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]{margin-top:5px}.billing[_ngcontent-%COMP%]   .client-billing-search[_ngcontent-%COMP%]   .billing-search[_ngcontent-%COMP%]   .date-form[_ngcontent-%COMP%]   .date-submit-button[_ngcontent-%COMP%]{margin-top:20px}[_nghost-%COMP%]     .billing-component .rs-tab-content{margin:0 0 auto!important}[_nghost-%COMP%]     .billing-component .rs-tab-header-container{padding:0!important;margin-left:30px!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingComponent, [{
        type: Component,
        args: [{ selector: 'billing', template: "<div class = \"billing\">\n    <div *ngIf=\"!hasFeed\">\n        <billing-search [selectedAdminPlan]=\"selectedAdminPlan\" [userFeed]=\"userFeed\" (resetSelected) =\"resetSelected($event)\" [billing] = \"billing\" [dateRange]=\"!isHistoricalReportsFeature\"\n            [loaderImage]=\"loaderImage\" (billingInput)=\"billingInput($event)\"></billing-search>\n    </div>\n    <!-- when feed is passed  -->\n    <div *ngIf=\"hasFeed && !isBMTPaymentHistoryFeature\" class=\"client-billing-search\">\n        <div class=\"billing-search\">\n            <div class=\"no-results\" *ngIf=\"totalBalanceErrorMessage\">\n                {{totalBalanceErrorMessage}}</div>\n          <div class=\"group-subgroup-heading\">\n            <div class=\"client-info billing-row\">\n              <div class=\"group-subgroup\">\n                <label>Group:<span>{{ feed.plan }} {{ feed.clientId }} {{ feed.clientName }}</span></label>\n                <label>Subgroup:<span>{{ feed.subClientId ? feed.subClientId : 'All Subgroups' }} {{ feed.subClientName }}</span></label>\n              </div>\n              <div class=\"billing-info\" *ngIf=\"!isHistoricalReportsFeature || !isPaymentHistoryFeature\">\n                <label>Total Balance: <span *ngIf=\"accountBalance\" [class.due]=\"accountBalance > 0\">{{ (accountBalance) | currency }}</span></label>\n                <span role=\"button\" tabindex=\"0\" (keydown.enter)=\"openPaymentInvoicePopup()\" class=\"make-a-payment\" *ngIf=\"isPaymentEnable\"><a (click)=\"openPaymentInvoicePopup();\">Make a One-time Payment</a></span>\n              </div>\n            </div>\n          </div>\n            <div *ngIf =\"!isHistoricalReportsFeature\">\n            <form [formGroup]=\"dateForm\" (ngSubmit)=\"fromDateRangeForm()\">\n                <div class=\"row date-form\">\n                    <div class=\"col-sm-2\">\n                        <rs-input formControlName=\"startDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"From Date\"\n                            validation=\"eager\"></rs-input>\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <rs-input formControlName=\"endDate\" type=\"date\" placeholder=\"MM/DD/YYYY\" label=\"To Date\"\n                            validation=\"eager\"></rs-input>\n                    </div>\n                    <div class=\"col-sm-2 date-submit-button\">\n                        <button [disabled]=\"!dateForm.valid\" rs-raised-button color=\"primary\">Submit</button>\n                    </div>\n                </div>\n                <ul class=\"date-range-info\">\n                    <li>Date Range is optional. If not specified will default to the last 3 months worth of processed\n                        invoices</li>\n                </ul>\n            </form>\n            </div>\n        </div>\n    </div>\n    <!-- Historical reports component -->\n    <ng-container>\n        <historical-reports *ngIf=\"showHistoricalReports && isHistoricalReportsFeature && billingFeed\" [clientInfo]=\"billingFeed\"></historical-reports>\n    </ng-container>\n    <!-- Billing Component -->\n    <ng-container *ngIf=\"((billingFeed| keyvalue)?.length && !isHistoricalReportsFeature && !isPaymentHistoryFeature && !isBMTPaymentHistoryFeature )\">\n        <div class=\"billing-component\">\n            <billing-reports [feed]=\"billingFeed\" [loaderImage]=\"loaderImage\" [billingFeatures]=\"billing\"></billing-reports>\n        </div>\n    </ng-container>\n\n    <!-- payment History -->\n    <ng-container *ngIf=\"((billingFeed| keyvalue)?.length && (isPaymentHistoryFeature || isBMTPaymentHistoryFeature))\">\n        <div class=\"billing-component\">\n            <app-payment-history [feed]=\"billingFeed\" [loaderImage]=\"loaderImage\" ></app-payment-history>\n        </div>\n    </ng-container>\n\n    <!-- payment Invoice component -->\n    <ng-container *ngIf=\"showPaymentInvoice\">\n        <billing-payment-invoice [paymentInvoiceFeed]=\"paymentInvoiceFeed\" [loaderImage]=\"loaderImage\" (paymentInvoiceDilogClosed)=\"paymentInvoiceDilogClosed($event)\">\n        </billing-payment-invoice>\n    </ng-container>\n</div>\n", styles: [".billing .client-billing-search .client-search-options label{white-space:nowrap;color:#124980;font-weight:700}.billing .client-billing-search .client-search-options{flex-direction:column}.billing .client-billing-search .row{margin-bottom:16px;font-weight:700}.billing .client-billing-search .no-results{color:#a94442;font-weight:700;padding-bottom:10px}@media (min-width: 768px){.billing .client-billing-search .client-search-options{flex-direction:row}}.billing .client-billing-search .billing-search{margin:0 0 24px;padding:0 10px}.billing .client-billing-search .billing-search .group-subgroup-heading{border-bottom:1px solid grey;padding:20px 15px 5px;margin-bottom:10px;font-size:16px;justify-content:space-between}.billing .client-billing-search .billing-search .group-subgroup-heading .client-info label{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.billing .client-billing-search .billing-search .group-subgroup-heading .client-info label span{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-row{display:flex;justify-content:space-between;align-items:center}.billing .client-billing-search .billing-search .group-subgroup-heading .group-subgroup{display:flex}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-info{text-align:right}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-info label{font-weight:700;border-bottom:3px solid #ff7308;padding-bottom:5px}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-info label .due{color:#a94442}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-info label span{color:#0c6ac7;padding:0 15px 0 10px;font-weight:400;cursor:pointer}.billing .client-billing-search .billing-search .group-subgroup-heading .billing-info a{color:#0c6ac7;padding:0 15px 0 10px;font-weight:700;cursor:pointer}.billing .client-billing-search .billing-search .group-subgroup-heading label:last-child{padding-left:10px}.billing .client-billing-search .billing-search .group-subgroup-heading .make-a-payment{border-left:1px solid gray}.billing .client-billing-search .billing-search .date-range-info{margin-left:-20px;font-weight:700}.billing .client-billing-search .billing-search .date-form{margin-top:5px}.billing .client-billing-search .billing-search .date-form .date-submit-button{margin-top:20px}:host ::ng-deep .billing-component .rs-tab-content{margin:0 0 auto!important}:host ::ng-deep .billing-component .rs-tab-header-container{padding:0!important;margin-left:30px!important}\n"] }]
    }], () => [{ type: i1$1.Lux }, { type: i2.UntypedFormBuilder }, { type: BillingAsync }], { billing: [{
            type: Input
        }], loaderImage: [{
            type: Input
        }], navigateToMyReportsTab: [{
            type: Output
        }], resetSearch: [{
            type: Output
        }], feed: [{
            type: Input
        }], userFeed: [{
            type: Input
        }], selectedAdminPlan: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BillingComponent, { className: "BillingComponent", filePath: "lib/billing/billing.component.ts", lineNumber: 19 }); })();

const initialAvailableReportsState = {
    isFetchingAvailableReports: false,
    availableReportsErrorMessage: '',
    availableReportsRequest: {
        pagination: {
            offset: '',
            limit: ''
        },
        startDate: '',
        endDate: ''
    },
    avaialableReportsResponse: [],
    isDownloading: false,
    downloadError: ''
};

class AvailableReportsModule {
    constructor(lux) {
        const availableReportsState = JSON.parse(sessionStorage.getItem('available-reports-state') || null);
        lux.register('availableReports', availableReportsState ? availableReportsState : initialAvailableReportsState);
        lux.allChanges().subscribe(state => sessionStorage.setItem('available-reports-state', JSON.stringify(state.availableReports)));
    }
    static { this.ɵfac = function AvailableReportsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvailableReportsModule)(i0.ɵɵinject(i1$1.Lux)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AvailableReportsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule,
            LoaderModule,
            CheckboxModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvailableReportsModule, [{
        type: NgModule,
        args: [{
                declarations: [availableReportsComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ButtonModule,
                    LoaderModule,
                    CheckboxModule
                ],
                exports: [
                    availableReportsComponent
                ]
            }]
    }], () => [{ type: i1$1.Lux }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AvailableReportsModule, { declarations: [availableReportsComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        LoaderModule,
        CheckboxModule], exports: [availableReportsComponent] }); })();

const ngxStripeModule = NgxStripeModule.forRoot();
class BillingModule {
    constructor(lux) {
        const billingState = JSON.parse(sessionStorage.getItem('billing-state') || null);
        lux.register('billing', billingState ? billingState : initialBillingState);
        lux.allChanges().subscribe(state => sessionStorage.setItem('billing-state', JSON.stringify(state.billing)));
    }
    static { this.ɵfac = function BillingModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BillingModule)(i0.ɵɵinject(i1$1.Lux)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BillingModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            TabsModule,
            PaginatorModule,
            FormsModule,
            SelectModule,
            CheckboxModule,
            ReactiveFormsModule,
            InputModule,
            RadioModule,
            ButtonModule,
            TooltipModule,
            DialogModule,
            LoaderModule,
            AvailableReportsModule,
            ngxStripeModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BillingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ReportsComponent,
                    BillingReportsComponent,
                    InvoiceComponent,
                    BillingComponent,
                    InvoiceDownloadComponent,
                    BillingSearchComponent,
                    HistoricalReportsComponent,
                    PaymentHistoryComponent,
                    PaymentInvoiceComponent,
                    PaymentComponent,
                    PaymentConfirmationComponent
                ],
                imports: [
                    CommonModule,
                    TabsModule,
                    PaginatorModule,
                    FormsModule,
                    SelectModule,
                    CheckboxModule,
                    ReactiveFormsModule,
                    InputModule,
                    RadioModule,
                    ButtonModule,
                    TooltipModule,
                    DialogModule,
                    LoaderModule,
                    AvailableReportsModule,
                    ngxStripeModule
                ],
                exports: [
                    ReportsComponent,
                    BillingReportsComponent,
                    InvoiceComponent,
                    BillingComponent,
                    InvoiceDownloadComponent,
                    BillingSearchComponent,
                    HistoricalReportsComponent,
                    PaymentHistoryComponent,
                    PaymentInvoiceComponent,
                    PaymentComponent,
                    PaymentConfirmationComponent
                ],
            }]
    }], () => [{ type: i1$1.Lux }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BillingModule, { declarations: [ReportsComponent,
        BillingReportsComponent,
        InvoiceComponent,
        BillingComponent,
        InvoiceDownloadComponent,
        BillingSearchComponent,
        HistoricalReportsComponent,
        PaymentHistoryComponent,
        PaymentInvoiceComponent,
        PaymentComponent,
        PaymentConfirmationComponent], imports: [CommonModule,
        TabsModule,
        PaginatorModule,
        FormsModule,
        SelectModule,
        CheckboxModule,
        ReactiveFormsModule,
        InputModule,
        RadioModule,
        ButtonModule,
        TooltipModule,
        DialogModule,
        LoaderModule,
        AvailableReportsModule, i4$2.NgxStripeModule], exports: [ReportsComponent,
        BillingReportsComponent,
        InvoiceComponent,
        BillingComponent,
        InvoiceDownloadComponent,
        BillingSearchComponent,
        HistoricalReportsComponent,
        PaymentHistoryComponent,
        PaymentInvoiceComponent,
        PaymentComponent,
        PaymentConfirmationComponent] }); })();

function historicalReportsEndDate() { return 'Must be above From Date.'; }
function consolidatedClaimInvoice() { return 'Must be adjacent to From Date Month.'; }
function consolidatedNCClaimInvoiceStartDate() { return 'Must be first day of the Month.'; }
function consolidatedNCClaimInvoiceEndDate() { return 'Must be last day of the From Date Month.'; }
function nonConsolidatedClaimInvoice() { return 'Must be same month as From Date.'; }
function paymentHistoryToDate() { return ' From Date cannot be after the To Date.'; }
function paymentHistoryFromDate() { return 'To Date cannot be before the From Date.'; }

/*
 * Public API Surface of billing-lib
 */
// modules

/**
 * Generated bundle index. Do not edit.
 */

export { AvailableReportsModule, BillingComponent, BillingComponentCriteria, BillingModule, BillingReportsComponent, BillingSearchComponent, HistoricalReportsComponent, InvoiceComponent, InvoiceDownloadComponent, PaymentComponent, PaymentConfirmationComponent, PaymentHistoryComponent, PaymentInvoiceComponent, ReportsComponent, UserAuthConfig, addCustomerPaymentProfileError, addCustomerPaymentProfileRequest, addCustomerPaymentProfileResponse, addCustomerProfileError, addCustomerProfileRequest, addCustomerProfileResponse, availableReportsComponent, availableReportsReq, availableReportsRes, availableReportserror, consolidatedClaimInvoice, consolidatedNCClaimInvoiceEndDate, consolidatedNCClaimInvoiceStartDate, consolidatedResponse, customerPaymentProfileError, customerPaymentProfilesRequest, customerPaymentProfilesResponse, documentDownloadError, downloadCSearchCriteria, downloadError, downloadResponse, error, getCallInfo, getClientOrSubClientSearchErrors, getClientResults, getClientSearchCriteria, getClientSearchCriteriaLimit25, getFlowInfo, getSearchCriteria, getSelectedClient, getSelectedSubClient, getSubClientResults, getSubClientSearchCriteria, getSubClientSearchCriteriaLimit25, groupErrorMessage, groupSearchCriteria, historicalReportsEndDate, individualInvoiceError, initialAvailableReportsState, initialBillingState, invoiceActivityError, invoiceActivityRequest, invoiceActivityResponse, invoiceDownloaderrorMessage, invoiceReq, isDownloading, isFetchingAddCustomerPaymentProfile, isFetchingAddCustomerProfile, isFetchingAuth, isFetchingAvailableReports, isFetchingClient, isFetchingCustomerPaymentProfiles, isFetchingData, isFetchingDownload, isFetchingIndividualInvoice, isFetchingInvoiceActivity, isFetchingMerchantAccount, isFetchingPayment, isFetchingPaymentActivity, isFetchingPaymentHistory, isFetchingReportFormats, isFetchingTotalBalance, isFetchingpaymentConfig, isInvoiceFetching, isUpdatingAvailableReports, merchantAccountError, merchantAccountRequest, merchantAccountResponse, navigateUserToMyReports, ngxStripeModule, nonConsolidatedClaimInvoice, nonConsolidatedResponse, paymentActivityError, paymentActivityRequest, paymentActivityResponse, paymentConfigError, paymentError, paymentHistoryError, paymentHistoryFromDate, paymentHistoryRequest, paymentHistoryResponse, paymentHistoryToDate, paymentRequest, paymentResponse, reportFormatError, reportFormatRequest, reportFormatResponse, reportsErrorMessage, subGroupSearchCriteria, totalBalanceDueRes, totalBalanceErrorMessage, userAuthProvider };
